/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AccessBlockedIndexRouteImport } from "./routes/access-blocked/index";
import { Route as AddPaymentCardIndexRouteImport } from "./routes/add-payment-card/index";
import { Route as AddPaymentCardCreateRouteImport } from "./routes/add-payment-card/create";
import { Route as AddPaymentCardSuccessRouteImport } from "./routes/add-payment-card/success";
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback";
import { Route as AuthIdpCallbackRouteImport } from "./routes/auth/idp-callback";
import { Route as AuthLandingRouteImport } from "./routes/auth/landing";
import { Route as AuthLoginRouteImport } from "./routes/auth/login";
import { Route as AuthLogoutRouteImport } from "./routes/auth/logout";
import { Route as AuthOauthCallbackRouteImport } from "./routes/auth/oauth-callback";
import { Route as AuthSigninRouteImport } from "./routes/auth/signin";
import { Route as CafDocumentsBlockedIndexRouteImport } from "./routes/caf-documents-blocked/index";
import { Route as CalendarIndexRouteImport } from "./routes/calendar/index";
import { Route as CustomWebsiteIndexRouteImport } from "./routes/custom-website/index";
import { Route as ExtendTimeAppointmentIdRouteImport } from "./routes/extend-time/$appointmentId";
import { Route as FlowsIndexRouteImport } from "./routes/flows/index";
import { Route as FlowsStepIdRouteImport } from "./routes/flows/$stepId";
import { Route as GeneralTermsIndexRouteImport } from "./routes/general-terms/index";
import { Route as GoogleCallbackRouteImport } from "./routes/google/callback";
import { Route as HomeIndexRouteImport } from "./routes/home/index";
import { Route as LocationsIndexRouteImport } from "./routes/locations/index";
import { Route as OnelivAdditionalInfoRouteImport } from "./routes/oneliv/additional-info";
import { Route as OnelivBasicInfoRouteImport } from "./routes/oneliv/basic-info";
import { Route as OnelivEducationalBackgroundRouteImport } from "./routes/oneliv/educational-background";
import { Route as OnelivExperiencesRouteImport } from "./routes/oneliv/experiences";
import { Route as OnelivFaqRouteImport } from "./routes/oneliv/faq";
import { Route as OnelivMedicalInstitutionsRouteImport } from "./routes/oneliv/medical-institutions";
import { Route as OnelivSocialMediaRouteImport } from "./routes/oneliv/social-media";
import { Route as OnelivTreatmentFocusRouteImport } from "./routes/oneliv/treatment-focus";
import { Route as OnelivUseTermsRouteImport } from "./routes/oneliv/use-terms";
import { Route as OnelivWelcomeRouteImport } from "./routes/oneliv/welcome";
import { Route as PatientsIndexRouteImport } from "./routes/patients/index";
import { Route as RecommendationIndexRouteImport } from "./routes/recommendation/index";
import { Route as RecurringAppointmentsIndexRouteImport } from "./routes/recurring-appointments/index";
import { Route as RecurringAppointmentsCodAgendamentoRecorrenteRouteImport } from "./routes/recurring-appointments/$codAgendamentoRecorrente";
import { Route as SettingsIndexRouteImport } from "./routes/settings/index";
import { Route as SettingsAssistRouteImport } from "./routes/settings/assist";
import { Route as UpdateRequiredIndexRouteImport } from "./routes/update-required/index";
import { Route as WaitingRoomIndexRouteImport } from "./routes/waiting-room/index";
import { Route as AppointmentAppointmentIdCancelRecurrenceRouteImport } from "./routes/appointment/$appointmentId/cancel-recurrence";
import { Route as AppointmentAppointmentIdFlexiblePricingRouteImport } from "./routes/appointment/$appointmentId/flexible-pricing";
import { Route as AppointmentAppointmentIdPatientSwapRouteImport } from "./routes/appointment/$appointmentId/patient-swap";
import { Route as AppointmentAppointmentIdPatientSwapRecurrenceRouteImport } from "./routes/appointment/$appointmentId/patient-swap-recurrence";
import { Route as AppointmentAppointmentIdPatientSwapSearchRouteImport } from "./routes/appointment/$appointmentId/patient-swap-search";
import { Route as AppointmentAppointmentIdRescheduleRouteImport } from "./routes/appointment/$appointmentId/reschedule";
import { Route as AppointmentAppointmentIdReschedulePatientRouteImport } from "./routes/appointment/$appointmentId/reschedule-patient";
import { Route as AppointmentAppointmentIdRescheduleRecurrenceRouteImport } from "./routes/appointment/$appointmentId/reschedule-recurrence";
import { Route as AppointmentCreateIndexRouteImport } from "./routes/appointment/create/index";
import { Route as AppointmentCreateAvailableOptionsRouteImport } from "./routes/appointment/create/available-options";
import { Route as AppointmentCreateFlexiblePricingRouteImport } from "./routes/appointment/create/flexible-pricing";
import { Route as AppointmentCreatePatientRouteImport } from "./routes/appointment/create/patient";
import { Route as AppointmentCreateSearchPatientRouteImport } from "./routes/appointment/create/search-patient";
import { Route as AuthFirstAccessCompleteRouteImport } from "./routes/auth/first-access/complete";
import { Route as AuthFirstAccessDefinePasswordRouteImport } from "./routes/auth/first-access/define-password";
import { Route as AuthFirstAccessDocumentRouteImport } from "./routes/auth/first-access/document";
import { Route as AuthFirstAccessDocumentNotFoundRouteImport } from "./routes/auth/first-access/document-not-found";
import { Route as AuthFirstAccessVerifyEmailRouteImport } from "./routes/auth/first-access/verify-email";
import { Route as AuthOauthAuthorizeRouteImport } from "./routes/auth/oauth/authorize";
import { Route as AuthPasswordResetCheckEmailRouteImport } from "./routes/auth/password-reset/check-email";
import { Route as AuthPasswordResetCreatePasswordRouteImport } from "./routes/auth/password-reset/create-password";
import { Route as AuthPasswordResetForgotPasswordRouteImport } from "./routes/auth/password-reset/forgot-password";
import { Route as AuthPasswordResetPasswordChangedRouteImport } from "./routes/auth/password-reset/password-changed";
import { Route as CalendarBatchAdjustIndexRouteImport } from "./routes/calendar/batch-adjust/index";
import { Route as CalendarBatchAdjustCancelRouteImport } from "./routes/calendar/batch-adjust/cancel";
import { Route as CalendarBatchAdjustMinutesRouteImport } from "./routes/calendar/batch-adjust/minutes";
import { Route as CalendarBatchAdjustReviewRouteImport } from "./routes/calendar/batch-adjust/review";
import { Route as CalendarBatchAdjustSuccessRouteImport } from "./routes/calendar/batch-adjust/success";
import { Route as CalendarUnavailableSlotsCreateRouteImport } from "./routes/calendar/unavailable-slots/create";
import { Route as CustomWebsiteConfirmationIndexRouteImport } from "./routes/custom-website/confirmation/index";
import { Route as CustomWebsiteConfirmationErrorRouteImport } from "./routes/custom-website/confirmation/error";
import { Route as CustomWebsiteFormIndexRouteImport } from "./routes/custom-website/form/index";
import { Route as FlowsStepIdSubStepIdRouteImport } from "./routes/flows/$stepId/$subStepId";
import { Route as FlowsCompleteFlowIdRouteImport } from "./routes/flows/complete/$flowId";
import { Route as HomeAllFeaturesIndexRouteImport } from "./routes/home/all-features/index";
import { Route as HomeNotificationCenterIndexRouteImport } from "./routes/home/notification-center/index";
import { Route as HomeNotificationCenterAboutRouteImport } from "./routes/home/notification-center/about";
import { Route as LocationsLocationIdIndexRouteImport } from "./routes/locations/$locationId/index";
import { Route as OnboardingConsultingAcquisitionRouteImport } from "./routes/onboarding/consulting/acquisition";
import { Route as OnboardingConsultingCareerProblemRouteImport } from "./routes/onboarding/consulting/career-problem";
import { Route as OnboardingConsultingChannelsRouteImport } from "./routes/onboarding/consulting/channels";
import { Route as OnboardingConsultingExpectationRouteImport } from "./routes/onboarding/consulting/expectation";
import { Route as OnboardingConsultingIntroRouteImport } from "./routes/onboarding/consulting/intro";
import { Route as OnboardingConsultingSuccessRouteImport } from "./routes/onboarding/consulting/success";
import { Route as OnboardingFirstScheduleIndexRouteImport } from "./routes/onboarding/first-schedule/index";
import { Route as OnboardingFirstScheduleFirstAppointmentRouteImport } from "./routes/onboarding/first-schedule/first-appointment";
import { Route as OnboardingFirstScheduleFollowUpRouteImport } from "./routes/onboarding/first-schedule/follow-up";
import { Route as OnboardingFirstScheduleFollowUpDaysRouteImport } from "./routes/onboarding/first-schedule/follow-up-days";
import { Route as OnboardingFirstScheduleIntroRouteImport } from "./routes/onboarding/first-schedule/intro";
import { Route as OnboardingFirstSchedulePreviewRouteImport } from "./routes/onboarding/first-schedule/preview";
import { Route as OnboardingFirstScheduleScheduleRouteImport } from "./routes/onboarding/first-schedule/schedule";
import { Route as OnboardingFirstScheduleSuccessRouteImport } from "./routes/onboarding/first-schedule/success";
import { Route as OnboardingWelcomeMeetingIndexRouteImport } from "./routes/onboarding/welcome-meeting/index";
import { Route as OnboardingWelcomeMeetingDetailsRouteImport } from "./routes/onboarding/welcome-meeting/details";
import { Route as OnboardingWelcomeMeetingDismissedRouteImport } from "./routes/onboarding/welcome-meeting/dismissed";
import { Route as OnboardingWelcomeMeetingFormatRouteImport } from "./routes/onboarding/welcome-meeting/format";
import { Route as OnboardingWelcomeMeetingLocationRouteImport } from "./routes/onboarding/welcome-meeting/location";
import { Route as OnboardingWelcomeMeetingScheduleRouteImport } from "./routes/onboarding/welcome-meeting/schedule";
import { Route as OnboardingWelcomeMeetingSkipReasonRouteImport } from "./routes/onboarding/welcome-meeting/skip-reason";
import { Route as OnboardingWelcomeMeetingSuccessRouteImport } from "./routes/onboarding/welcome-meeting/success";
import { Route as PatientsPatientIdIndexRouteImport } from "./routes/patients/$patientId/index";
import { Route as PatientsPatientIdUpdateRouteImport } from "./routes/patients/$patientId/update";
import { Route as RecommendationConfirmationIndexRouteImport } from "./routes/recommendation/confirmation/index";
import { Route as RecurringAppointmentsCreateIndexRouteImport } from "./routes/recurring-appointments/create/index";
import { Route as RecurringAppointmentsCreateAvailabilityRouteImport } from "./routes/recurring-appointments/create/availability";
import { Route as RecurringAppointmentsCreatePatientRouteImport } from "./routes/recurring-appointments/create/patient";
import { Route as RecurringAppointmentsCreateReviewRouteImport } from "./routes/recurring-appointments/create/review";
import { Route as RecurringAppointmentsCreateSearchPatientRouteImport } from "./routes/recurring-appointments/create/search-patient";
import { Route as RecurringAppointmentsCreateSuccessRouteImport } from "./routes/recurring-appointments/create/success";
import { Route as RecurringAppointmentsExtendRecurringAppointmentIdRouteImport } from "./routes/recurring-appointments/extend/$recurringAppointmentId";
import { Route as RecurringAppointmentsExtendSuccessRouteImport } from "./routes/recurring-appointments/extend/success";
import { Route as RecurringAppointmentsRescheduleAvailabilityRouteImport } from "./routes/recurring-appointments/reschedule/availability";
import { Route as RecurringAppointmentsRescheduleReviewRouteImport } from "./routes/recurring-appointments/reschedule/review";
import { Route as SettingsAssistIndexRouteImport } from "./routes/settings/assist/index";
import { Route as SettingsBillingIndexRouteImport } from "./routes/settings/billing/index";
import { Route as SettingsBillingBillingItemIdRouteImport } from "./routes/settings/billing/$billingItemId";
import { Route as SettingsBillingAboutRouteImport } from "./routes/settings/billing/about";
import { Route as SettingsBlogIndexRouteImport } from "./routes/settings/blog/index";
import { Route as SettingsBlogCreateRouteImport } from "./routes/settings/blog/create";
import { Route as SettingsCommunityIndexRouteImport } from "./routes/settings/community/index";
import { Route as SettingsGoogleCalendarIndexRouteImport } from "./routes/settings/google-calendar/index";
import { Route as SettingsPaymentsIndexRouteImport } from "./routes/settings/payments/index";
import { Route as SettingsPaymentsWelcomeRouteImport } from "./routes/settings/payments/welcome";
import { Route as SettingsProfessionalSiteIndexRouteImport } from "./routes/settings/professional-site/index";
import { Route as SettingsProfileIndexRouteImport } from "./routes/settings/profile/index";
import { Route as SettingsReferralIndexRouteImport } from "./routes/settings/referral/index";
import { Route as SettingsReferralAboutRouteImport } from "./routes/settings/referral/about";
import { Route as SettingsRegulatoryDocumentsIndexRouteImport } from "./routes/settings/regulatory-documents/index";
import { Route as SettingsRegulatoryDocumentsConfirmationRouteImport } from "./routes/settings/regulatory-documents/confirmation";
import { Route as SettingsRegulatoryDocumentsDeclarationLocationsRouteImport } from "./routes/settings/regulatory-documents/declaration-locations";
import { Route as SettingsRegulatoryDocumentsDownloadRouteImport } from "./routes/settings/regulatory-documents/download";
import { Route as SettingsRegulatoryDocumentsLocationsRouteImport } from "./routes/settings/regulatory-documents/locations";
import { Route as SettingsRegulatoryDocumentsReasonRouteImport } from "./routes/settings/regulatory-documents/reason";
import { Route as SettingsRegulatoryDocumentsRequestsRouteImport } from "./routes/settings/regulatory-documents/requests";
import { Route as SettingsRegulatoryDocumentsReviewRouteImport } from "./routes/settings/regulatory-documents/review";
import { Route as SettingsRegulatoryDocumentsStateRouteImport } from "./routes/settings/regulatory-documents/state";
import { Route as SettingsReservedSchedulesIndexRouteImport } from "./routes/settings/reserved-schedules/index";
import { Route as SettingsScheduleOptionsIndexRouteImport } from "./routes/settings/schedule-options/index";
import { Route as WaitingRoomFollowUpAppointmentReminderAppointmentIdRouteImport } from "./routes/waiting-room/follow-up-appointment-reminder/$appointmentId";
import { Route as HomeInfoInfoItemIdIndexRouteImport } from "./routes/home/info/$infoItemId/index";
import { Route as HomeInfoInfoItemIdConfirmationRouteImport } from "./routes/home/info/$infoItemId/confirmation";
import { Route as HomeNotificationCenterIdIndexRouteImport } from "./routes/home/notification-center/$id/index";
import { Route as SettingsAssistAssistProAcceptanceIndexRouteImport } from "./routes/settings/assist/assist-pro-acceptance/index";
import { Route as SettingsAssistContactsHistoryIndexRouteImport } from "./routes/settings/assist/contacts-history/index";
import { Route as SettingsAssistCustomerAppointmentOverviewIndexRouteImport } from "./routes/settings/assist/customer-appointment-overview/index";
import { Route as SettingsAssistCustomerContactOverviewIndexRouteImport } from "./routes/settings/assist/customer-contact-overview/index";
import { Route as SettingsAssistCustomerSiteOverviewIndexRouteImport } from "./routes/settings/assist/customer-site-overview/index";
import { Route as SettingsAssistFeatureSettingsIndexRouteImport } from "./routes/settings/assist/feature-settings/index";
import { Route as SettingsAssistFollowUpAppointmentReminderIndexRouteImport } from "./routes/settings/assist/follow-up-appointment-reminder/index";
import { Route as SettingsAssistRescuedAppointmentOverviewIndexRouteImport } from "./routes/settings/assist/rescued-appointment-overview/index";
import { Route as SettingsAssistSecretaryDetailsIndexRouteImport } from "./routes/settings/assist/secretary-details/index";
import { Route as SettingsAssistSecretaryDetailsAppointmentInfosRouteImport } from "./routes/settings/assist/secretary-details/appointment-infos";
import { Route as SettingsAssistSecretaryDetailsFaqRouteImport } from "./routes/settings/assist/secretary-details/faq";
import { Route as SettingsAssistSecretaryDetailsProfessionalInfosRouteImport } from "./routes/settings/assist/secretary-details/professional-infos";
import { Route as SettingsAssistSecretaryDetailsRestrictionsRouteImport } from "./routes/settings/assist/secretary-details/restrictions";
import { Route as SettingsAssistSubscribeAssistProLegacyIndexRouteImport } from "./routes/settings/assist/subscribe-assist-pro-legacy/index";
import { Route as SettingsAssistSubscribeAssistProIndexRouteImport } from "./routes/settings/assist/subscribe-assist-pro/index";
import { Route as SettingsAssistSubscribedAssistIndexRouteImport } from "./routes/settings/assist/subscribed-assist/index";
import { Route as SettingsAssistTasksIndexRouteImport } from "./routes/settings/assist/tasks/index";
import { Route as SettingsAssistUnsubscribeAssistProIndexRouteImport } from "./routes/settings/assist/unsubscribe-assist-pro/index";
import { Route as SettingsAssistUserTrackableLinksIndexRouteImport } from "./routes/settings/assist/user-trackable-links/index";
import { Route as SettingsBillingDetailsIndexRouteImport } from "./routes/settings/billing/details/index";
import { Route as SettingsBlogUserPostIdIndexRouteImport } from "./routes/settings/blog/$userPostId/index";
import { Route as SettingsBlogUserPostIdEditRouteImport } from "./routes/settings/blog/$userPostId/edit";
import { Route as SettingsPaymentsBankAccountIndexRouteImport } from "./routes/settings/payments/bank-account/index";
import { Route as SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRouteImport } from "./routes/settings/payments/bank-account/change-bank-account-or-ownership";
import { Route as SettingsPaymentsBankAccountUpdateRouteImport } from "./routes/settings/payments/bank-account/update";
import { Route as SettingsPaymentsCreateRecipientIndexRouteImport } from "./routes/settings/payments/create-recipient/index";
import { Route as SettingsPaymentsCreateRecipientAddBankAccountRouteImport } from "./routes/settings/payments/create-recipient/add-bank-account";
import { Route as SettingsPaymentsCreateRecipientCheckCnpjRouteImport } from "./routes/settings/payments/create-recipient/check-cnpj";
import { Route as SettingsPaymentsCreateRecipientChooseHolderTypeRouteImport } from "./routes/settings/payments/create-recipient/choose-holder-type";
import { Route as SettingsPaymentsCreateRecipientConfirmBankAccountRouteImport } from "./routes/settings/payments/create-recipient/confirm-bank-account";
import { Route as SettingsPaymentsCreateRecipientConfirmDocumentRouteImport } from "./routes/settings/payments/create-recipient/confirm-document";
import { Route as SettingsPaymentsCreateRecipientStatusRouteImport } from "./routes/settings/payments/create-recipient/status";
import { Route as SettingsPaymentsCreateRecipientValidateDataRouteImport } from "./routes/settings/payments/create-recipient/validate-data";
import { Route as SettingsPaymentsCreateIndexRouteImport } from "./routes/settings/payments/create/index";
import { Route as SettingsPaymentsCreateConfirmationRouteImport } from "./routes/settings/payments/create/confirmation";
import { Route as SettingsPaymentsEvolutionChartsIndexRouteImport } from "./routes/settings/payments/evolution-charts/index";
import { Route as SettingsPaymentsPatientPaymentsIndexRouteImport } from "./routes/settings/payments/patient-payments/index";
import { Route as SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRouteImport } from "./routes/settings/payments/patient-payments/about-payment-anticipation";
import { Route as SettingsPaymentsPatientPaymentsAboutPaymentDetailsRouteImport } from "./routes/settings/payments/patient-payments/about-payment-details";
import { Route as SettingsPaymentsPatientPaymentsAboutPaymentsRouteImport } from "./routes/settings/payments/patient-payments/about-payments";
import { Route as SettingsPaymentsPatientPaymentsDetailsRouteImport } from "./routes/settings/payments/patient-payments/details";
import { Route as SettingsPaymentsPatientPaymentsPaymentReceiptRouteImport } from "./routes/settings/payments/patient-payments/payment-receipt";
import { Route as SettingsPaymentsPatientPaymentsRefundRouteImport } from "./routes/settings/payments/patient-payments/refund";
import { Route as SettingsPaymentsPatientPaymentsRefundReceiptRouteImport } from "./routes/settings/payments/patient-payments/refund-receipt";
import { Route as SettingsPaymentsPayablesIndexRouteImport } from "./routes/settings/payments/payables/index";
import { Route as SettingsPaymentsPayablesAboutRouteImport } from "./routes/settings/payments/payables/about";
import { Route as SettingsPaymentsTermsOfServiceIndexRouteImport } from "./routes/settings/payments/terms-of-service/index";
import { Route as SettingsProfessionalSiteAboutIndexRouteImport } from "./routes/settings/professional-site/about/index";
import { Route as SettingsProfileCardIndexRouteImport } from "./routes/settings/profile/card/index";
import { Route as SettingsProfileCardCreateRouteImport } from "./routes/settings/profile/card/create";
import { Route as SettingsProfilePersonalDataIndexRouteImport } from "./routes/settings/profile/personal-data/index";
import { Route as SettingsProfilePersonalDataEditRouteImport } from "./routes/settings/profile/personal-data/edit";
import { Route as SettingsProfilePersonalDataEditAddressRouteImport } from "./routes/settings/profile/personal-data/edit-address";
import { Route as SettingsProfilePlanIndexRouteImport } from "./routes/settings/profile/plan/index";
import { Route as SettingsProfileProfessionalDataIndexRouteImport } from "./routes/settings/profile/professional-data/index";
import { Route as SettingsProfileUpsertPublicPhoneIndexRouteImport } from "./routes/settings/profile/upsert-public-phone/index";
import { Route as SettingsProfileVehiclesIndexRouteImport } from "./routes/settings/profile/vehicles/index";
import { Route as SettingsProfileVehiclesVehicleIdRouteImport } from "./routes/settings/profile/vehicles/$vehicleId";
import { Route as SettingsProfileVehiclesCreateRouteImport } from "./routes/settings/profile/vehicles/create";
import { Route as SettingsReservedSchedulesReservedScheduleIdIndexRouteImport } from "./routes/settings/reserved-schedules/$reservedScheduleId.index";
import { Route as SettingsReservedSchedulesReservedScheduleIdCancelRouteImport } from "./routes/settings/reserved-schedules/$reservedScheduleId.cancel";
import { Route as SettingsReservedSchedulesCreateIndexRouteImport } from "./routes/settings/reserved-schedules/create/index";
import { Route as SettingsReservedSchedulesCreateConfirmRouteImport } from "./routes/settings/reserved-schedules/create/confirm";
import { Route as SettingsReservedSchedulesCreateLinkedScheduleRouteImport } from "./routes/settings/reserved-schedules/create/linked-schedule";
import { Route as SettingsReservedSchedulesCreateSlotsRouteImport } from "./routes/settings/reserved-schedules/create/slots";
import { Route as SettingsReservedSchedulesCreateStartingDayRouteImport } from "./routes/settings/reserved-schedules/create/starting-day";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsIndexRouteImport } from "./routes/settings/schedule-options/appointment-receiving-options/index";
import { Route as SettingsScheduleOptionsAppointmentTypesIndexRouteImport } from "./routes/settings/schedule-options/appointment-types/index";
import { Route as SettingsScheduleOptionsPreferredRoomsIndexRouteImport } from "./routes/settings/schedule-options/preferred-rooms/index";
import { Route as SettingsScheduleOptionsPreferredRoomsUnitIdRouteImport } from "./routes/settings/schedule-options/preferred-rooms/$unitId";
import { Route as SettingsScheduleOptionsSchedulesIndexRouteImport } from "./routes/settings/schedule-options/schedules/index";
import { Route as SettingsScheduleOptionsSchedulesScheduleIdRouteImport } from "./routes/settings/schedule-options/schedules/$scheduleId";
import { Route as SettingsScheduleOptionsSchedulesCreateRouteImport } from "./routes/settings/schedule-options/schedules/create";
import { Route as SettingsScheduleOptionsServicePreferencesIndexRouteImport } from "./routes/settings/schedule-options/service-preferences/index";
import { Route as WaitingRoomCodAgendamentoChangeTimeIndexRouteImport } from "./routes/waiting-room/$codAgendamento/change-time/index";
import { Route as WaitingRoomCodAgendamentoChoosePaymentChannelIndexRouteImport } from "./routes/waiting-room/$codAgendamento/choose-payment-channel/index";
import { Route as WaitingRoomCodAgendamentoMenuIndexRouteImport } from "./routes/waiting-room/$codAgendamento/menu/index";
import { Route as WaitingRoomCodAgendamentoReceiveRoomNowIndexRouteImport } from "./routes/waiting-room/$codAgendamento/receive-room-now/index";
import { Route as WaitingRoomCodAgendamentoSendTotemPaymentIndexRouteImport } from "./routes/waiting-room/$codAgendamento/send-totem-payment/index";
import { Route as WaitingRoomFollowUpAppointmentReminderPatientPatientIdRouteImport } from "./routes/waiting-room/follow-up-appointment-reminder/patient/$patientId";
import { Route as SettingsAssistContactsHistoryContactIdIndexRouteImport } from "./routes/settings/assist/contacts-history/$contactId/index";
import { Route as SettingsAssistContactsHistoryAboutIndexRouteImport } from "./routes/settings/assist/contacts-history/about/index";
import { Route as SettingsAssistContactsHistoryEssentialIndexRouteImport } from "./routes/settings/assist/contacts-history/essential/index";
import { Route as SettingsAssistContactsHistoryTrialPeriodIndexRouteImport } from "./routes/settings/assist/contacts-history/trial-period/index";
import { Route as SettingsAssistCustomerContactOverviewStoriesFeedIndexRouteImport } from "./routes/settings/assist/customer-contact-overview/stories-feed/index";
import { Route as SettingsAssistFollowUpAppointmentReminderPatientsIndexRouteImport } from "./routes/settings/assist/follow-up-appointment-reminder/patients/index";
import { Route as SettingsAssistSubscribeAssistProConfirmIndexRouteImport } from "./routes/settings/assist/subscribe-assist-pro/confirm/index";
import { Route as SettingsAssistTasksTaskIdIndexRouteImport } from "./routes/settings/assist/tasks/$taskId/index";
import { Route as SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRouteImport } from "./routes/settings/assist/unsubscribe-assist-pro/upsert-phone/index";
import { Route as SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRouteImport } from "./routes/settings/assist/user-trackable-links/$userTrackableLinkId/index";
import { Route as SettingsAssistUserTrackableLinksCreateIndexRouteImport } from "./routes/settings/assist/user-trackable-links/create/index";
import { Route as SettingsBillingDetailsBillingIdIndexRouteImport } from "./routes/settings/billing/details/$billingId/index";
import { Route as SettingsBillingDetailsBillingIdBoletoRouteImport } from "./routes/settings/billing/details/$billingId/boleto";
import { Route as SettingsBillingDetailsBillingIdPixRouteImport } from "./routes/settings/billing/details/$billingId/pix";
import { Route as SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRouteImport } from "./routes/settings/payments/patient-payments/$guid/change-online-payment-status";
import { Route as SettingsPaymentsPatientPaymentsFiltersFilterOriginsRouteImport } from "./routes/settings/payments/patient-payments/filters/filter-origins";
import { Route as SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRouteImport } from "./routes/settings/payments/patient-payments/filters/filter-payment-methods";
import { Route as SettingsPaymentsPatientPaymentsFiltersFilterStatusRouteImport } from "./routes/settings/payments/patient-payments/filters/filter-status";
import { Route as SettingsProfilePlanCancelSubscriptionIndexRouteImport } from "./routes/settings/profile/plan/cancel-subscription/index";
import { Route as SettingsProfilePlanChangeIndexRouteImport } from "./routes/settings/profile/plan/change/index";
import { Route as SettingsProfileProfessionalDataEditProfessionalDataRouteImport } from "./routes/settings/profile/professional-data/edit/professional-data";
import { Route as SettingsProfileProfessionalDataEditProfessionalDataContactInformationRouteImport } from "./routes/settings/profile/professional-data/edit/professional-data-contact-information";
import { Route as SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRouteImport } from "./routes/settings/reserved-schedules/$reservedScheduleId.$nextReserveId.cancel";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRouteImport } from "./routes/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/index";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRouteImport } from "./routes/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRouteImport } from "./routes/settings/schedule-options/appointment-receiving-options/create/index";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRouteImport } from "./routes/settings/schedule-options/appointment-receiving-options/create/advanced-config";
import { Route as SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRouteImport } from "./routes/settings/schedule-options/appointment-types/$appointmentTypeId/index";
import { Route as SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRouteImport } from "./routes/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config";
import { Route as SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRouteImport } from "./routes/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info";
import { Route as SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRouteImport } from "./routes/settings/schedule-options/appointment-types/$appointmentTypeId/room-type";
import { Route as SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRouteImport } from "./routes/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info";
import { Route as SettingsScheduleOptionsAppointmentTypesCreateIndexRouteImport } from "./routes/settings/schedule-options/appointment-types/create/index";
import { Route as SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRouteImport } from "./routes/settings/schedule-options/appointment-types/create/advanced-config";
import { Route as SettingsScheduleOptionsAppointmentTypesCreateConfirmRouteImport } from "./routes/settings/schedule-options/appointment-types/create/confirm";
import { Route as SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRouteImport } from "./routes/settings/schedule-options/appointment-types/create/patient-info";
import { Route as SettingsScheduleOptionsAppointmentTypesCreateReviewRouteImport } from "./routes/settings/schedule-options/appointment-types/create/review";
import { Route as SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRouteImport } from "./routes/settings/schedule-options/appointment-types/create/room-type";
import { Route as SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRouteImport } from "./routes/settings/schedule-options/appointment-types/create/secretary-info";
import { Route as SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRouteImport } from "./routes/settings/schedule-options/service-preferences/edit/general-preferences";
import { Route as SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRouteImport } from "./routes/settings/schedule-options/service-preferences/edit/patient-preferences";
import { Route as WaitingRoomCodAgendamentoChangeTimeConfirmIndexRouteImport } from "./routes/waiting-room/$codAgendamento/change-time/confirm/index";
import { Route as SettingsAssistContactsHistoryTrialPeriodContactIdIndexRouteImport } from "./routes/settings/assist/contacts-history/trial-period/$contactId/index";
import { Route as SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRouteImport } from "./routes/settings/assist/user-trackable-links/$userTrackableLinkId/report/index";
import { Route as SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRouteImport } from "./routes/settings/billing/details/paymentBillingGroup/$billingIdGroup/index";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AccessBlockedIndexRoute = AccessBlockedIndexRouteImport.update({
  id: "/access-blocked/",
  path: "/access-blocked/",
  getParentRoute: () => rootRouteImport,
} as any);
const AddPaymentCardIndexRoute = AddPaymentCardIndexRouteImport.update({
  id: "/add-payment-card/",
  path: "/add-payment-card/",
  getParentRoute: () => rootRouteImport,
} as any);
const AddPaymentCardCreateRoute = AddPaymentCardCreateRouteImport.update({
  id: "/add-payment-card/create",
  path: "/add-payment-card/create",
  getParentRoute: () => rootRouteImport,
} as any);
const AddPaymentCardSuccessRoute = AddPaymentCardSuccessRouteImport.update({
  id: "/add-payment-card/success",
  path: "/add-payment-card/success",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthIdpCallbackRoute = AuthIdpCallbackRouteImport.update({
  id: "/auth/idp-callback",
  path: "/auth/idp-callback",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthLandingRoute = AuthLandingRouteImport.update({
  id: "/auth/landing",
  path: "/auth/landing",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: "/auth/login",
  path: "/auth/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: "/auth/logout",
  path: "/auth/logout",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthOauthCallbackRoute = AuthOauthCallbackRouteImport.update({
  id: "/auth/oauth-callback",
  path: "/auth/oauth-callback",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: "/auth/signin",
  path: "/auth/signin",
  getParentRoute: () => rootRouteImport,
} as any);
const CafDocumentsBlockedIndexRoute =
  CafDocumentsBlockedIndexRouteImport.update({
    id: "/caf-documents-blocked/",
    path: "/caf-documents-blocked/",
    getParentRoute: () => rootRouteImport,
  } as any);
const CalendarIndexRoute = CalendarIndexRouteImport.update({
  id: "/calendar/",
  path: "/calendar/",
  getParentRoute: () => rootRouteImport,
} as any);
const CustomWebsiteIndexRoute = CustomWebsiteIndexRouteImport.update({
  id: "/custom-website/",
  path: "/custom-website/",
  getParentRoute: () => rootRouteImport,
} as any);
const ExtendTimeAppointmentIdRoute = ExtendTimeAppointmentIdRouteImport.update({
  id: "/extend-time/$appointmentId",
  path: "/extend-time/$appointmentId",
  getParentRoute: () => rootRouteImport,
} as any);
const FlowsIndexRoute = FlowsIndexRouteImport.update({
  id: "/flows/",
  path: "/flows/",
  getParentRoute: () => rootRouteImport,
} as any);
const FlowsStepIdRoute = FlowsStepIdRouteImport.update({
  id: "/flows/$stepId",
  path: "/flows/$stepId",
  getParentRoute: () => rootRouteImport,
} as any);
const GeneralTermsIndexRoute = GeneralTermsIndexRouteImport.update({
  id: "/general-terms/",
  path: "/general-terms/",
  getParentRoute: () => rootRouteImport,
} as any);
const GoogleCallbackRoute = GoogleCallbackRouteImport.update({
  id: "/google/callback",
  path: "/google/callback",
  getParentRoute: () => rootRouteImport,
} as any);
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: "/home/",
  path: "/home/",
  getParentRoute: () => rootRouteImport,
} as any);
const LocationsIndexRoute = LocationsIndexRouteImport.update({
  id: "/locations/",
  path: "/locations/",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivAdditionalInfoRoute = OnelivAdditionalInfoRouteImport.update({
  id: "/oneliv/additional-info",
  path: "/oneliv/additional-info",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivBasicInfoRoute = OnelivBasicInfoRouteImport.update({
  id: "/oneliv/basic-info",
  path: "/oneliv/basic-info",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivEducationalBackgroundRoute =
  OnelivEducationalBackgroundRouteImport.update({
    id: "/oneliv/educational-background",
    path: "/oneliv/educational-background",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnelivExperiencesRoute = OnelivExperiencesRouteImport.update({
  id: "/oneliv/experiences",
  path: "/oneliv/experiences",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivFaqRoute = OnelivFaqRouteImport.update({
  id: "/oneliv/faq",
  path: "/oneliv/faq",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivMedicalInstitutionsRoute =
  OnelivMedicalInstitutionsRouteImport.update({
    id: "/oneliv/medical-institutions",
    path: "/oneliv/medical-institutions",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnelivSocialMediaRoute = OnelivSocialMediaRouteImport.update({
  id: "/oneliv/social-media",
  path: "/oneliv/social-media",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivTreatmentFocusRoute = OnelivTreatmentFocusRouteImport.update({
  id: "/oneliv/treatment-focus",
  path: "/oneliv/treatment-focus",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivUseTermsRoute = OnelivUseTermsRouteImport.update({
  id: "/oneliv/use-terms",
  path: "/oneliv/use-terms",
  getParentRoute: () => rootRouteImport,
} as any);
const OnelivWelcomeRoute = OnelivWelcomeRouteImport.update({
  id: "/oneliv/welcome",
  path: "/oneliv/welcome",
  getParentRoute: () => rootRouteImport,
} as any);
const PatientsIndexRoute = PatientsIndexRouteImport.update({
  id: "/patients/",
  path: "/patients/",
  getParentRoute: () => rootRouteImport,
} as any);
const RecommendationIndexRoute = RecommendationIndexRouteImport.update({
  id: "/recommendation/",
  path: "/recommendation/",
  getParentRoute: () => rootRouteImport,
} as any);
const RecurringAppointmentsIndexRoute =
  RecurringAppointmentsIndexRouteImport.update({
    id: "/recurring-appointments/",
    path: "/recurring-appointments/",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsCodAgendamentoRecorrenteRoute =
  RecurringAppointmentsCodAgendamentoRecorrenteRouteImport.update({
    id: "/recurring-appointments/$codAgendamentoRecorrente",
    path: "/recurring-appointments/$codAgendamentoRecorrente",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/settings/",
  path: "/settings/",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsAssistRoute = SettingsAssistRouteImport.update({
  id: "/settings/assist",
  path: "/settings/assist",
  getParentRoute: () => rootRouteImport,
} as any);
const UpdateRequiredIndexRoute = UpdateRequiredIndexRouteImport.update({
  id: "/update-required/",
  path: "/update-required/",
  getParentRoute: () => rootRouteImport,
} as any);
const WaitingRoomIndexRoute = WaitingRoomIndexRouteImport.update({
  id: "/waiting-room/",
  path: "/waiting-room/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppointmentAppointmentIdCancelRecurrenceRoute =
  AppointmentAppointmentIdCancelRecurrenceRouteImport.update({
    id: "/appointment/$appointmentId/cancel-recurrence",
    path: "/appointment/$appointmentId/cancel-recurrence",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentAppointmentIdFlexiblePricingRoute =
  AppointmentAppointmentIdFlexiblePricingRouteImport.update({
    id: "/appointment/$appointmentId/flexible-pricing",
    path: "/appointment/$appointmentId/flexible-pricing",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentAppointmentIdPatientSwapRoute =
  AppointmentAppointmentIdPatientSwapRouteImport.update({
    id: "/appointment/$appointmentId/patient-swap",
    path: "/appointment/$appointmentId/patient-swap",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentAppointmentIdPatientSwapRecurrenceRoute =
  AppointmentAppointmentIdPatientSwapRecurrenceRouteImport.update({
    id: "/appointment/$appointmentId/patient-swap-recurrence",
    path: "/appointment/$appointmentId/patient-swap-recurrence",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentAppointmentIdPatientSwapSearchRoute =
  AppointmentAppointmentIdPatientSwapSearchRouteImport.update({
    id: "/appointment/$appointmentId/patient-swap-search",
    path: "/appointment/$appointmentId/patient-swap-search",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentAppointmentIdRescheduleRoute =
  AppointmentAppointmentIdRescheduleRouteImport.update({
    id: "/appointment/$appointmentId/reschedule",
    path: "/appointment/$appointmentId/reschedule",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentAppointmentIdReschedulePatientRoute =
  AppointmentAppointmentIdReschedulePatientRouteImport.update({
    id: "/appointment/$appointmentId/reschedule-patient",
    path: "/appointment/$appointmentId/reschedule-patient",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentAppointmentIdRescheduleRecurrenceRoute =
  AppointmentAppointmentIdRescheduleRecurrenceRouteImport.update({
    id: "/appointment/$appointmentId/reschedule-recurrence",
    path: "/appointment/$appointmentId/reschedule-recurrence",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentCreateIndexRoute = AppointmentCreateIndexRouteImport.update({
  id: "/appointment/create/",
  path: "/appointment/create/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppointmentCreateAvailableOptionsRoute =
  AppointmentCreateAvailableOptionsRouteImport.update({
    id: "/appointment/create/available-options",
    path: "/appointment/create/available-options",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentCreateFlexiblePricingRoute =
  AppointmentCreateFlexiblePricingRouteImport.update({
    id: "/appointment/create/flexible-pricing",
    path: "/appointment/create/flexible-pricing",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentCreatePatientRoute =
  AppointmentCreatePatientRouteImport.update({
    id: "/appointment/create/patient",
    path: "/appointment/create/patient",
    getParentRoute: () => rootRouteImport,
  } as any);
const AppointmentCreateSearchPatientRoute =
  AppointmentCreateSearchPatientRouteImport.update({
    id: "/appointment/create/search-patient",
    path: "/appointment/create/search-patient",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthFirstAccessCompleteRoute = AuthFirstAccessCompleteRouteImport.update({
  id: "/auth/first-access/complete",
  path: "/auth/first-access/complete",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthFirstAccessDefinePasswordRoute =
  AuthFirstAccessDefinePasswordRouteImport.update({
    id: "/auth/first-access/define-password",
    path: "/auth/first-access/define-password",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthFirstAccessDocumentRoute = AuthFirstAccessDocumentRouteImport.update({
  id: "/auth/first-access/document",
  path: "/auth/first-access/document",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthFirstAccessDocumentNotFoundRoute =
  AuthFirstAccessDocumentNotFoundRouteImport.update({
    id: "/auth/first-access/document-not-found",
    path: "/auth/first-access/document-not-found",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthFirstAccessVerifyEmailRoute =
  AuthFirstAccessVerifyEmailRouteImport.update({
    id: "/auth/first-access/verify-email",
    path: "/auth/first-access/verify-email",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthOauthAuthorizeRoute = AuthOauthAuthorizeRouteImport.update({
  id: "/auth/oauth/authorize",
  path: "/auth/oauth/authorize",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthPasswordResetCheckEmailRoute =
  AuthPasswordResetCheckEmailRouteImport.update({
    id: "/auth/password-reset/check-email",
    path: "/auth/password-reset/check-email",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthPasswordResetCreatePasswordRoute =
  AuthPasswordResetCreatePasswordRouteImport.update({
    id: "/auth/password-reset/create-password",
    path: "/auth/password-reset/create-password",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthPasswordResetForgotPasswordRoute =
  AuthPasswordResetForgotPasswordRouteImport.update({
    id: "/auth/password-reset/forgot-password",
    path: "/auth/password-reset/forgot-password",
    getParentRoute: () => rootRouteImport,
  } as any);
const AuthPasswordResetPasswordChangedRoute =
  AuthPasswordResetPasswordChangedRouteImport.update({
    id: "/auth/password-reset/password-changed",
    path: "/auth/password-reset/password-changed",
    getParentRoute: () => rootRouteImport,
  } as any);
const CalendarBatchAdjustIndexRoute =
  CalendarBatchAdjustIndexRouteImport.update({
    id: "/calendar/batch-adjust/",
    path: "/calendar/batch-adjust/",
    getParentRoute: () => rootRouteImport,
  } as any);
const CalendarBatchAdjustCancelRoute =
  CalendarBatchAdjustCancelRouteImport.update({
    id: "/calendar/batch-adjust/cancel",
    path: "/calendar/batch-adjust/cancel",
    getParentRoute: () => rootRouteImport,
  } as any);
const CalendarBatchAdjustMinutesRoute =
  CalendarBatchAdjustMinutesRouteImport.update({
    id: "/calendar/batch-adjust/minutes",
    path: "/calendar/batch-adjust/minutes",
    getParentRoute: () => rootRouteImport,
  } as any);
const CalendarBatchAdjustReviewRoute =
  CalendarBatchAdjustReviewRouteImport.update({
    id: "/calendar/batch-adjust/review",
    path: "/calendar/batch-adjust/review",
    getParentRoute: () => rootRouteImport,
  } as any);
const CalendarBatchAdjustSuccessRoute =
  CalendarBatchAdjustSuccessRouteImport.update({
    id: "/calendar/batch-adjust/success",
    path: "/calendar/batch-adjust/success",
    getParentRoute: () => rootRouteImport,
  } as any);
const CalendarUnavailableSlotsCreateRoute =
  CalendarUnavailableSlotsCreateRouteImport.update({
    id: "/calendar/unavailable-slots/create",
    path: "/calendar/unavailable-slots/create",
    getParentRoute: () => rootRouteImport,
  } as any);
const CustomWebsiteConfirmationIndexRoute =
  CustomWebsiteConfirmationIndexRouteImport.update({
    id: "/custom-website/confirmation/",
    path: "/custom-website/confirmation/",
    getParentRoute: () => rootRouteImport,
  } as any);
const CustomWebsiteConfirmationErrorRoute =
  CustomWebsiteConfirmationErrorRouteImport.update({
    id: "/custom-website/confirmation/error",
    path: "/custom-website/confirmation/error",
    getParentRoute: () => rootRouteImport,
  } as any);
const CustomWebsiteFormIndexRoute = CustomWebsiteFormIndexRouteImport.update({
  id: "/custom-website/form/",
  path: "/custom-website/form/",
  getParentRoute: () => rootRouteImport,
} as any);
const FlowsStepIdSubStepIdRoute = FlowsStepIdSubStepIdRouteImport.update({
  id: "/$subStepId",
  path: "/$subStepId",
  getParentRoute: () => FlowsStepIdRoute,
} as any);
const FlowsCompleteFlowIdRoute = FlowsCompleteFlowIdRouteImport.update({
  id: "/flows/complete/$flowId",
  path: "/flows/complete/$flowId",
  getParentRoute: () => rootRouteImport,
} as any);
const HomeAllFeaturesIndexRoute = HomeAllFeaturesIndexRouteImport.update({
  id: "/home/all-features/",
  path: "/home/all-features/",
  getParentRoute: () => rootRouteImport,
} as any);
const HomeNotificationCenterIndexRoute =
  HomeNotificationCenterIndexRouteImport.update({
    id: "/home/notification-center/",
    path: "/home/notification-center/",
    getParentRoute: () => rootRouteImport,
  } as any);
const HomeNotificationCenterAboutRoute =
  HomeNotificationCenterAboutRouteImport.update({
    id: "/home/notification-center/about",
    path: "/home/notification-center/about",
    getParentRoute: () => rootRouteImport,
  } as any);
const LocationsLocationIdIndexRoute =
  LocationsLocationIdIndexRouteImport.update({
    id: "/locations/$locationId/",
    path: "/locations/$locationId/",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingConsultingAcquisitionRoute =
  OnboardingConsultingAcquisitionRouteImport.update({
    id: "/onboarding/consulting/acquisition",
    path: "/onboarding/consulting/acquisition",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingConsultingCareerProblemRoute =
  OnboardingConsultingCareerProblemRouteImport.update({
    id: "/onboarding/consulting/career-problem",
    path: "/onboarding/consulting/career-problem",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingConsultingChannelsRoute =
  OnboardingConsultingChannelsRouteImport.update({
    id: "/onboarding/consulting/channels",
    path: "/onboarding/consulting/channels",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingConsultingExpectationRoute =
  OnboardingConsultingExpectationRouteImport.update({
    id: "/onboarding/consulting/expectation",
    path: "/onboarding/consulting/expectation",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingConsultingIntroRoute =
  OnboardingConsultingIntroRouteImport.update({
    id: "/onboarding/consulting/intro",
    path: "/onboarding/consulting/intro",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingConsultingSuccessRoute =
  OnboardingConsultingSuccessRouteImport.update({
    id: "/onboarding/consulting/success",
    path: "/onboarding/consulting/success",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstScheduleIndexRoute =
  OnboardingFirstScheduleIndexRouteImport.update({
    id: "/onboarding/first-schedule/",
    path: "/onboarding/first-schedule/",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstScheduleFirstAppointmentRoute =
  OnboardingFirstScheduleFirstAppointmentRouteImport.update({
    id: "/onboarding/first-schedule/first-appointment",
    path: "/onboarding/first-schedule/first-appointment",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstScheduleFollowUpRoute =
  OnboardingFirstScheduleFollowUpRouteImport.update({
    id: "/onboarding/first-schedule/follow-up",
    path: "/onboarding/first-schedule/follow-up",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstScheduleFollowUpDaysRoute =
  OnboardingFirstScheduleFollowUpDaysRouteImport.update({
    id: "/onboarding/first-schedule/follow-up-days",
    path: "/onboarding/first-schedule/follow-up-days",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstScheduleIntroRoute =
  OnboardingFirstScheduleIntroRouteImport.update({
    id: "/onboarding/first-schedule/intro",
    path: "/onboarding/first-schedule/intro",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstSchedulePreviewRoute =
  OnboardingFirstSchedulePreviewRouteImport.update({
    id: "/onboarding/first-schedule/preview",
    path: "/onboarding/first-schedule/preview",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstScheduleScheduleRoute =
  OnboardingFirstScheduleScheduleRouteImport.update({
    id: "/onboarding/first-schedule/schedule",
    path: "/onboarding/first-schedule/schedule",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingFirstScheduleSuccessRoute =
  OnboardingFirstScheduleSuccessRouteImport.update({
    id: "/onboarding/first-schedule/success",
    path: "/onboarding/first-schedule/success",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingIndexRoute =
  OnboardingWelcomeMeetingIndexRouteImport.update({
    id: "/onboarding/welcome-meeting/",
    path: "/onboarding/welcome-meeting/",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingDetailsRoute =
  OnboardingWelcomeMeetingDetailsRouteImport.update({
    id: "/onboarding/welcome-meeting/details",
    path: "/onboarding/welcome-meeting/details",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingDismissedRoute =
  OnboardingWelcomeMeetingDismissedRouteImport.update({
    id: "/onboarding/welcome-meeting/dismissed",
    path: "/onboarding/welcome-meeting/dismissed",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingFormatRoute =
  OnboardingWelcomeMeetingFormatRouteImport.update({
    id: "/onboarding/welcome-meeting/format",
    path: "/onboarding/welcome-meeting/format",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingLocationRoute =
  OnboardingWelcomeMeetingLocationRouteImport.update({
    id: "/onboarding/welcome-meeting/location",
    path: "/onboarding/welcome-meeting/location",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingScheduleRoute =
  OnboardingWelcomeMeetingScheduleRouteImport.update({
    id: "/onboarding/welcome-meeting/schedule",
    path: "/onboarding/welcome-meeting/schedule",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingSkipReasonRoute =
  OnboardingWelcomeMeetingSkipReasonRouteImport.update({
    id: "/onboarding/welcome-meeting/skip-reason",
    path: "/onboarding/welcome-meeting/skip-reason",
    getParentRoute: () => rootRouteImport,
  } as any);
const OnboardingWelcomeMeetingSuccessRoute =
  OnboardingWelcomeMeetingSuccessRouteImport.update({
    id: "/onboarding/welcome-meeting/success",
    path: "/onboarding/welcome-meeting/success",
    getParentRoute: () => rootRouteImport,
  } as any);
const PatientsPatientIdIndexRoute = PatientsPatientIdIndexRouteImport.update({
  id: "/patients/$patientId/",
  path: "/patients/$patientId/",
  getParentRoute: () => rootRouteImport,
} as any);
const PatientsPatientIdUpdateRoute = PatientsPatientIdUpdateRouteImport.update({
  id: "/patients/$patientId/update",
  path: "/patients/$patientId/update",
  getParentRoute: () => rootRouteImport,
} as any);
const RecommendationConfirmationIndexRoute =
  RecommendationConfirmationIndexRouteImport.update({
    id: "/recommendation/confirmation/",
    path: "/recommendation/confirmation/",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsCreateIndexRoute =
  RecurringAppointmentsCreateIndexRouteImport.update({
    id: "/recurring-appointments/create/",
    path: "/recurring-appointments/create/",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsCreateAvailabilityRoute =
  RecurringAppointmentsCreateAvailabilityRouteImport.update({
    id: "/recurring-appointments/create/availability",
    path: "/recurring-appointments/create/availability",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsCreatePatientRoute =
  RecurringAppointmentsCreatePatientRouteImport.update({
    id: "/recurring-appointments/create/patient",
    path: "/recurring-appointments/create/patient",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsCreateReviewRoute =
  RecurringAppointmentsCreateReviewRouteImport.update({
    id: "/recurring-appointments/create/review",
    path: "/recurring-appointments/create/review",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsCreateSearchPatientRoute =
  RecurringAppointmentsCreateSearchPatientRouteImport.update({
    id: "/recurring-appointments/create/search-patient",
    path: "/recurring-appointments/create/search-patient",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsCreateSuccessRoute =
  RecurringAppointmentsCreateSuccessRouteImport.update({
    id: "/recurring-appointments/create/success",
    path: "/recurring-appointments/create/success",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsExtendRecurringAppointmentIdRoute =
  RecurringAppointmentsExtendRecurringAppointmentIdRouteImport.update({
    id: "/recurring-appointments/extend/$recurringAppointmentId",
    path: "/recurring-appointments/extend/$recurringAppointmentId",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsExtendSuccessRoute =
  RecurringAppointmentsExtendSuccessRouteImport.update({
    id: "/recurring-appointments/extend/success",
    path: "/recurring-appointments/extend/success",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsRescheduleAvailabilityRoute =
  RecurringAppointmentsRescheduleAvailabilityRouteImport.update({
    id: "/recurring-appointments/reschedule/availability",
    path: "/recurring-appointments/reschedule/availability",
    getParentRoute: () => rootRouteImport,
  } as any);
const RecurringAppointmentsRescheduleReviewRoute =
  RecurringAppointmentsRescheduleReviewRouteImport.update({
    id: "/recurring-appointments/reschedule/review",
    path: "/recurring-appointments/reschedule/review",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsAssistIndexRoute = SettingsAssistIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SettingsAssistRoute,
} as any);
const SettingsBillingIndexRoute = SettingsBillingIndexRouteImport.update({
  id: "/settings/billing/",
  path: "/settings/billing/",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsBillingBillingItemIdRoute =
  SettingsBillingBillingItemIdRouteImport.update({
    id: "/settings/billing/$billingItemId",
    path: "/settings/billing/$billingItemId",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsBillingAboutRoute = SettingsBillingAboutRouteImport.update({
  id: "/settings/billing/about",
  path: "/settings/billing/about",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsBlogIndexRoute = SettingsBlogIndexRouteImport.update({
  id: "/settings/blog/",
  path: "/settings/blog/",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsBlogCreateRoute = SettingsBlogCreateRouteImport.update({
  id: "/settings/blog/create",
  path: "/settings/blog/create",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsCommunityIndexRoute = SettingsCommunityIndexRouteImport.update({
  id: "/settings/community/",
  path: "/settings/community/",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsGoogleCalendarIndexRoute =
  SettingsGoogleCalendarIndexRouteImport.update({
    id: "/settings/google-calendar/",
    path: "/settings/google-calendar/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsIndexRoute = SettingsPaymentsIndexRouteImport.update({
  id: "/settings/payments/",
  path: "/settings/payments/",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsPaymentsWelcomeRoute = SettingsPaymentsWelcomeRouteImport.update({
  id: "/settings/payments/welcome",
  path: "/settings/payments/welcome",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsProfessionalSiteIndexRoute =
  SettingsProfessionalSiteIndexRouteImport.update({
    id: "/settings/professional-site/",
    path: "/settings/professional-site/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileIndexRoute = SettingsProfileIndexRouteImport.update({
  id: "/settings/profile/",
  path: "/settings/profile/",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsReferralIndexRoute = SettingsReferralIndexRouteImport.update({
  id: "/settings/referral/",
  path: "/settings/referral/",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsReferralAboutRoute = SettingsReferralAboutRouteImport.update({
  id: "/settings/referral/about",
  path: "/settings/referral/about",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRegulatoryDocumentsIndexRoute =
  SettingsRegulatoryDocumentsIndexRouteImport.update({
    id: "/settings/regulatory-documents/",
    path: "/settings/regulatory-documents/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsConfirmationRoute =
  SettingsRegulatoryDocumentsConfirmationRouteImport.update({
    id: "/settings/regulatory-documents/confirmation",
    path: "/settings/regulatory-documents/confirmation",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsDeclarationLocationsRoute =
  SettingsRegulatoryDocumentsDeclarationLocationsRouteImport.update({
    id: "/settings/regulatory-documents/declaration-locations",
    path: "/settings/regulatory-documents/declaration-locations",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsDownloadRoute =
  SettingsRegulatoryDocumentsDownloadRouteImport.update({
    id: "/settings/regulatory-documents/download",
    path: "/settings/regulatory-documents/download",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsLocationsRoute =
  SettingsRegulatoryDocumentsLocationsRouteImport.update({
    id: "/settings/regulatory-documents/locations",
    path: "/settings/regulatory-documents/locations",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsReasonRoute =
  SettingsRegulatoryDocumentsReasonRouteImport.update({
    id: "/settings/regulatory-documents/reason",
    path: "/settings/regulatory-documents/reason",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsRequestsRoute =
  SettingsRegulatoryDocumentsRequestsRouteImport.update({
    id: "/settings/regulatory-documents/requests",
    path: "/settings/regulatory-documents/requests",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsReviewRoute =
  SettingsRegulatoryDocumentsReviewRouteImport.update({
    id: "/settings/regulatory-documents/review",
    path: "/settings/regulatory-documents/review",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsRegulatoryDocumentsStateRoute =
  SettingsRegulatoryDocumentsStateRouteImport.update({
    id: "/settings/regulatory-documents/state",
    path: "/settings/regulatory-documents/state",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesIndexRoute =
  SettingsReservedSchedulesIndexRouteImport.update({
    id: "/settings/reserved-schedules/",
    path: "/settings/reserved-schedules/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsIndexRoute =
  SettingsScheduleOptionsIndexRouteImport.update({
    id: "/settings/schedule-options/",
    path: "/settings/schedule-options/",
    getParentRoute: () => rootRouteImport,
  } as any);
const WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute =
  WaitingRoomFollowUpAppointmentReminderAppointmentIdRouteImport.update({
    id: "/waiting-room/follow-up-appointment-reminder/$appointmentId",
    path: "/waiting-room/follow-up-appointment-reminder/$appointmentId",
    getParentRoute: () => rootRouteImport,
  } as any);
const HomeInfoInfoItemIdIndexRoute = HomeInfoInfoItemIdIndexRouteImport.update({
  id: "/home/info/$infoItemId/",
  path: "/home/info/$infoItemId/",
  getParentRoute: () => rootRouteImport,
} as any);
const HomeInfoInfoItemIdConfirmationRoute =
  HomeInfoInfoItemIdConfirmationRouteImport.update({
    id: "/home/info/$infoItemId/confirmation",
    path: "/home/info/$infoItemId/confirmation",
    getParentRoute: () => rootRouteImport,
  } as any);
const HomeNotificationCenterIdIndexRoute =
  HomeNotificationCenterIdIndexRouteImport.update({
    id: "/home/notification-center/$id/",
    path: "/home/notification-center/$id/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsAssistAssistProAcceptanceIndexRoute =
  SettingsAssistAssistProAcceptanceIndexRouteImport.update({
    id: "/assist-pro-acceptance/",
    path: "/assist-pro-acceptance/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistContactsHistoryIndexRoute =
  SettingsAssistContactsHistoryIndexRouteImport.update({
    id: "/contacts-history/",
    path: "/contacts-history/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistCustomerAppointmentOverviewIndexRoute =
  SettingsAssistCustomerAppointmentOverviewIndexRouteImport.update({
    id: "/customer-appointment-overview/",
    path: "/customer-appointment-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistCustomerContactOverviewIndexRoute =
  SettingsAssistCustomerContactOverviewIndexRouteImport.update({
    id: "/customer-contact-overview/",
    path: "/customer-contact-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistCustomerSiteOverviewIndexRoute =
  SettingsAssistCustomerSiteOverviewIndexRouteImport.update({
    id: "/customer-site-overview/",
    path: "/customer-site-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistFeatureSettingsIndexRoute =
  SettingsAssistFeatureSettingsIndexRouteImport.update({
    id: "/feature-settings/",
    path: "/feature-settings/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistFollowUpAppointmentReminderIndexRoute =
  SettingsAssistFollowUpAppointmentReminderIndexRouteImport.update({
    id: "/follow-up-appointment-reminder/",
    path: "/follow-up-appointment-reminder/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistRescuedAppointmentOverviewIndexRoute =
  SettingsAssistRescuedAppointmentOverviewIndexRouteImport.update({
    id: "/rescued-appointment-overview/",
    path: "/rescued-appointment-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSecretaryDetailsIndexRoute =
  SettingsAssistSecretaryDetailsIndexRouteImport.update({
    id: "/secretary-details/",
    path: "/secretary-details/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSecretaryDetailsAppointmentInfosRoute =
  SettingsAssistSecretaryDetailsAppointmentInfosRouteImport.update({
    id: "/secretary-details/appointment-infos",
    path: "/secretary-details/appointment-infos",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSecretaryDetailsFaqRoute =
  SettingsAssistSecretaryDetailsFaqRouteImport.update({
    id: "/secretary-details/faq",
    path: "/secretary-details/faq",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSecretaryDetailsProfessionalInfosRoute =
  SettingsAssistSecretaryDetailsProfessionalInfosRouteImport.update({
    id: "/secretary-details/professional-infos",
    path: "/secretary-details/professional-infos",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSecretaryDetailsRestrictionsRoute =
  SettingsAssistSecretaryDetailsRestrictionsRouteImport.update({
    id: "/secretary-details/restrictions",
    path: "/secretary-details/restrictions",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSubscribeAssistProLegacyIndexRoute =
  SettingsAssistSubscribeAssistProLegacyIndexRouteImport.update({
    id: "/subscribe-assist-pro-legacy/",
    path: "/subscribe-assist-pro-legacy/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSubscribeAssistProIndexRoute =
  SettingsAssistSubscribeAssistProIndexRouteImport.update({
    id: "/subscribe-assist-pro/",
    path: "/subscribe-assist-pro/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSubscribedAssistIndexRoute =
  SettingsAssistSubscribedAssistIndexRouteImport.update({
    id: "/subscribed-assist/",
    path: "/subscribed-assist/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistTasksIndexRoute =
  SettingsAssistTasksIndexRouteImport.update({
    id: "/tasks/",
    path: "/tasks/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistUnsubscribeAssistProIndexRoute =
  SettingsAssistUnsubscribeAssistProIndexRouteImport.update({
    id: "/unsubscribe-assist-pro/",
    path: "/unsubscribe-assist-pro/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistUserTrackableLinksIndexRoute =
  SettingsAssistUserTrackableLinksIndexRouteImport.update({
    id: "/user-trackable-links/",
    path: "/user-trackable-links/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsBillingDetailsIndexRoute =
  SettingsBillingDetailsIndexRouteImport.update({
    id: "/settings/billing/details/",
    path: "/settings/billing/details/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsBlogUserPostIdIndexRoute =
  SettingsBlogUserPostIdIndexRouteImport.update({
    id: "/settings/blog/$userPostId/",
    path: "/settings/blog/$userPostId/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsBlogUserPostIdEditRoute =
  SettingsBlogUserPostIdEditRouteImport.update({
    id: "/settings/blog/$userPostId/edit",
    path: "/settings/blog/$userPostId/edit",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsBankAccountIndexRoute =
  SettingsPaymentsBankAccountIndexRouteImport.update({
    id: "/settings/payments/bank-account/",
    path: "/settings/payments/bank-account/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute =
  SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRouteImport.update({
    id: "/settings/payments/bank-account/change-bank-account-or-ownership",
    path: "/settings/payments/bank-account/change-bank-account-or-ownership",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsBankAccountUpdateRoute =
  SettingsPaymentsBankAccountUpdateRouteImport.update({
    id: "/settings/payments/bank-account/update",
    path: "/settings/payments/bank-account/update",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientIndexRoute =
  SettingsPaymentsCreateRecipientIndexRouteImport.update({
    id: "/settings/payments/create-recipient/",
    path: "/settings/payments/create-recipient/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientAddBankAccountRoute =
  SettingsPaymentsCreateRecipientAddBankAccountRouteImport.update({
    id: "/settings/payments/create-recipient/add-bank-account",
    path: "/settings/payments/create-recipient/add-bank-account",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientCheckCnpjRoute =
  SettingsPaymentsCreateRecipientCheckCnpjRouteImport.update({
    id: "/settings/payments/create-recipient/check-cnpj",
    path: "/settings/payments/create-recipient/check-cnpj",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientChooseHolderTypeRoute =
  SettingsPaymentsCreateRecipientChooseHolderTypeRouteImport.update({
    id: "/settings/payments/create-recipient/choose-holder-type",
    path: "/settings/payments/create-recipient/choose-holder-type",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientConfirmBankAccountRoute =
  SettingsPaymentsCreateRecipientConfirmBankAccountRouteImport.update({
    id: "/settings/payments/create-recipient/confirm-bank-account",
    path: "/settings/payments/create-recipient/confirm-bank-account",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientConfirmDocumentRoute =
  SettingsPaymentsCreateRecipientConfirmDocumentRouteImport.update({
    id: "/settings/payments/create-recipient/confirm-document",
    path: "/settings/payments/create-recipient/confirm-document",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientStatusRoute =
  SettingsPaymentsCreateRecipientStatusRouteImport.update({
    id: "/settings/payments/create-recipient/status",
    path: "/settings/payments/create-recipient/status",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateRecipientValidateDataRoute =
  SettingsPaymentsCreateRecipientValidateDataRouteImport.update({
    id: "/settings/payments/create-recipient/validate-data",
    path: "/settings/payments/create-recipient/validate-data",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateIndexRoute =
  SettingsPaymentsCreateIndexRouteImport.update({
    id: "/settings/payments/create/",
    path: "/settings/payments/create/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsCreateConfirmationRoute =
  SettingsPaymentsCreateConfirmationRouteImport.update({
    id: "/settings/payments/create/confirmation",
    path: "/settings/payments/create/confirmation",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsEvolutionChartsIndexRoute =
  SettingsPaymentsEvolutionChartsIndexRouteImport.update({
    id: "/settings/payments/evolution-charts/",
    path: "/settings/payments/evolution-charts/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsIndexRoute =
  SettingsPaymentsPatientPaymentsIndexRouteImport.update({
    id: "/settings/payments/patient-payments/",
    path: "/settings/payments/patient-payments/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute =
  SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRouteImport.update({
    id: "/settings/payments/patient-payments/about-payment-anticipation",
    path: "/settings/payments/patient-payments/about-payment-anticipation",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute =
  SettingsPaymentsPatientPaymentsAboutPaymentDetailsRouteImport.update({
    id: "/settings/payments/patient-payments/about-payment-details",
    path: "/settings/payments/patient-payments/about-payment-details",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsAboutPaymentsRoute =
  SettingsPaymentsPatientPaymentsAboutPaymentsRouteImport.update({
    id: "/settings/payments/patient-payments/about-payments",
    path: "/settings/payments/patient-payments/about-payments",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsDetailsRoute =
  SettingsPaymentsPatientPaymentsDetailsRouteImport.update({
    id: "/settings/payments/patient-payments/details",
    path: "/settings/payments/patient-payments/details",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsPaymentReceiptRoute =
  SettingsPaymentsPatientPaymentsPaymentReceiptRouteImport.update({
    id: "/settings/payments/patient-payments/payment-receipt",
    path: "/settings/payments/patient-payments/payment-receipt",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsRefundRoute =
  SettingsPaymentsPatientPaymentsRefundRouteImport.update({
    id: "/settings/payments/patient-payments/refund",
    path: "/settings/payments/patient-payments/refund",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsRefundReceiptRoute =
  SettingsPaymentsPatientPaymentsRefundReceiptRouteImport.update({
    id: "/settings/payments/patient-payments/refund-receipt",
    path: "/settings/payments/patient-payments/refund-receipt",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPayablesIndexRoute =
  SettingsPaymentsPayablesIndexRouteImport.update({
    id: "/settings/payments/payables/",
    path: "/settings/payments/payables/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPayablesAboutRoute =
  SettingsPaymentsPayablesAboutRouteImport.update({
    id: "/settings/payments/payables/about",
    path: "/settings/payments/payables/about",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsTermsOfServiceIndexRoute =
  SettingsPaymentsTermsOfServiceIndexRouteImport.update({
    id: "/settings/payments/terms-of-service/",
    path: "/settings/payments/terms-of-service/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfessionalSiteAboutIndexRoute =
  SettingsProfessionalSiteAboutIndexRouteImport.update({
    id: "/settings/professional-site/about/",
    path: "/settings/professional-site/about/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileCardIndexRoute =
  SettingsProfileCardIndexRouteImport.update({
    id: "/settings/profile/card/",
    path: "/settings/profile/card/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileCardCreateRoute =
  SettingsProfileCardCreateRouteImport.update({
    id: "/settings/profile/card/create",
    path: "/settings/profile/card/create",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfilePersonalDataIndexRoute =
  SettingsProfilePersonalDataIndexRouteImport.update({
    id: "/settings/profile/personal-data/",
    path: "/settings/profile/personal-data/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfilePersonalDataEditRoute =
  SettingsProfilePersonalDataEditRouteImport.update({
    id: "/settings/profile/personal-data/edit",
    path: "/settings/profile/personal-data/edit",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfilePersonalDataEditAddressRoute =
  SettingsProfilePersonalDataEditAddressRouteImport.update({
    id: "/settings/profile/personal-data/edit-address",
    path: "/settings/profile/personal-data/edit-address",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfilePlanIndexRoute =
  SettingsProfilePlanIndexRouteImport.update({
    id: "/settings/profile/plan/",
    path: "/settings/profile/plan/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileProfessionalDataIndexRoute =
  SettingsProfileProfessionalDataIndexRouteImport.update({
    id: "/settings/profile/professional-data/",
    path: "/settings/profile/professional-data/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileUpsertPublicPhoneIndexRoute =
  SettingsProfileUpsertPublicPhoneIndexRouteImport.update({
    id: "/settings/profile/upsert-public-phone/",
    path: "/settings/profile/upsert-public-phone/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileVehiclesIndexRoute =
  SettingsProfileVehiclesIndexRouteImport.update({
    id: "/settings/profile/vehicles/",
    path: "/settings/profile/vehicles/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileVehiclesVehicleIdRoute =
  SettingsProfileVehiclesVehicleIdRouteImport.update({
    id: "/settings/profile/vehicles/$vehicleId",
    path: "/settings/profile/vehicles/$vehicleId",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileVehiclesCreateRoute =
  SettingsProfileVehiclesCreateRouteImport.update({
    id: "/settings/profile/vehicles/create",
    path: "/settings/profile/vehicles/create",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesReservedScheduleIdIndexRoute =
  SettingsReservedSchedulesReservedScheduleIdIndexRouteImport.update({
    id: "/settings/reserved-schedules/$reservedScheduleId/",
    path: "/settings/reserved-schedules/$reservedScheduleId/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesReservedScheduleIdCancelRoute =
  SettingsReservedSchedulesReservedScheduleIdCancelRouteImport.update({
    id: "/settings/reserved-schedules/$reservedScheduleId/cancel",
    path: "/settings/reserved-schedules/$reservedScheduleId/cancel",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesCreateIndexRoute =
  SettingsReservedSchedulesCreateIndexRouteImport.update({
    id: "/settings/reserved-schedules/create/",
    path: "/settings/reserved-schedules/create/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesCreateConfirmRoute =
  SettingsReservedSchedulesCreateConfirmRouteImport.update({
    id: "/settings/reserved-schedules/create/confirm",
    path: "/settings/reserved-schedules/create/confirm",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesCreateLinkedScheduleRoute =
  SettingsReservedSchedulesCreateLinkedScheduleRouteImport.update({
    id: "/settings/reserved-schedules/create/linked-schedule",
    path: "/settings/reserved-schedules/create/linked-schedule",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesCreateSlotsRoute =
  SettingsReservedSchedulesCreateSlotsRouteImport.update({
    id: "/settings/reserved-schedules/create/slots",
    path: "/settings/reserved-schedules/create/slots",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsReservedSchedulesCreateStartingDayRoute =
  SettingsReservedSchedulesCreateStartingDayRouteImport.update({
    id: "/settings/reserved-schedules/create/starting-day",
    path: "/settings/reserved-schedules/create/starting-day",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsIndexRouteImport.update({
    id: "/settings/schedule-options/appointment-receiving-options/",
    path: "/settings/schedule-options/appointment-receiving-options/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsAppointmentTypesIndexRoute =
  SettingsScheduleOptionsAppointmentTypesIndexRouteImport.update({
    id: "/settings/schedule-options/appointment-types/",
    path: "/settings/schedule-options/appointment-types/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsPreferredRoomsIndexRoute =
  SettingsScheduleOptionsPreferredRoomsIndexRouteImport.update({
    id: "/settings/schedule-options/preferred-rooms/",
    path: "/settings/schedule-options/preferred-rooms/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsPreferredRoomsUnitIdRoute =
  SettingsScheduleOptionsPreferredRoomsUnitIdRouteImport.update({
    id: "/settings/schedule-options/preferred-rooms/$unitId",
    path: "/settings/schedule-options/preferred-rooms/$unitId",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsSchedulesIndexRoute =
  SettingsScheduleOptionsSchedulesIndexRouteImport.update({
    id: "/settings/schedule-options/schedules/",
    path: "/settings/schedule-options/schedules/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsSchedulesScheduleIdRoute =
  SettingsScheduleOptionsSchedulesScheduleIdRouteImport.update({
    id: "/settings/schedule-options/schedules/$scheduleId",
    path: "/settings/schedule-options/schedules/$scheduleId",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsSchedulesCreateRoute =
  SettingsScheduleOptionsSchedulesCreateRouteImport.update({
    id: "/settings/schedule-options/schedules/create",
    path: "/settings/schedule-options/schedules/create",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsServicePreferencesIndexRoute =
  SettingsScheduleOptionsServicePreferencesIndexRouteImport.update({
    id: "/settings/schedule-options/service-preferences/",
    path: "/settings/schedule-options/service-preferences/",
    getParentRoute: () => rootRouteImport,
  } as any);
const WaitingRoomCodAgendamentoChangeTimeIndexRoute =
  WaitingRoomCodAgendamentoChangeTimeIndexRouteImport.update({
    id: "/waiting-room/$codAgendamento/change-time/",
    path: "/waiting-room/$codAgendamento/change-time/",
    getParentRoute: () => rootRouteImport,
  } as any);
const WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute =
  WaitingRoomCodAgendamentoChoosePaymentChannelIndexRouteImport.update({
    id: "/waiting-room/$codAgendamento/choose-payment-channel/",
    path: "/waiting-room/$codAgendamento/choose-payment-channel/",
    getParentRoute: () => rootRouteImport,
  } as any);
const WaitingRoomCodAgendamentoMenuIndexRoute =
  WaitingRoomCodAgendamentoMenuIndexRouteImport.update({
    id: "/waiting-room/$codAgendamento/menu/",
    path: "/waiting-room/$codAgendamento/menu/",
    getParentRoute: () => rootRouteImport,
  } as any);
const WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute =
  WaitingRoomCodAgendamentoReceiveRoomNowIndexRouteImport.update({
    id: "/waiting-room/$codAgendamento/receive-room-now/",
    path: "/waiting-room/$codAgendamento/receive-room-now/",
    getParentRoute: () => rootRouteImport,
  } as any);
const WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute =
  WaitingRoomCodAgendamentoSendTotemPaymentIndexRouteImport.update({
    id: "/waiting-room/$codAgendamento/send-totem-payment/",
    path: "/waiting-room/$codAgendamento/send-totem-payment/",
    getParentRoute: () => rootRouteImport,
  } as any);
const WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute =
  WaitingRoomFollowUpAppointmentReminderPatientPatientIdRouteImport.update({
    id: "/waiting-room/follow-up-appointment-reminder/patient/$patientId",
    path: "/waiting-room/follow-up-appointment-reminder/patient/$patientId",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsAssistContactsHistoryContactIdIndexRoute =
  SettingsAssistContactsHistoryContactIdIndexRouteImport.update({
    id: "/contacts-history/$contactId/",
    path: "/contacts-history/$contactId/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistContactsHistoryAboutIndexRoute =
  SettingsAssistContactsHistoryAboutIndexRouteImport.update({
    id: "/contacts-history/about/",
    path: "/contacts-history/about/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistContactsHistoryEssentialIndexRoute =
  SettingsAssistContactsHistoryEssentialIndexRouteImport.update({
    id: "/contacts-history/essential/",
    path: "/contacts-history/essential/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistContactsHistoryTrialPeriodIndexRoute =
  SettingsAssistContactsHistoryTrialPeriodIndexRouteImport.update({
    id: "/contacts-history/trial-period/",
    path: "/contacts-history/trial-period/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute =
  SettingsAssistCustomerContactOverviewStoriesFeedIndexRouteImport.update({
    id: "/customer-contact-overview/stories-feed/",
    path: "/customer-contact-overview/stories-feed/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute =
  SettingsAssistFollowUpAppointmentReminderPatientsIndexRouteImport.update({
    id: "/follow-up-appointment-reminder/patients/",
    path: "/follow-up-appointment-reminder/patients/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistSubscribeAssistProConfirmIndexRoute =
  SettingsAssistSubscribeAssistProConfirmIndexRouteImport.update({
    id: "/subscribe-assist-pro/confirm/",
    path: "/subscribe-assist-pro/confirm/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistTasksTaskIdIndexRoute =
  SettingsAssistTasksTaskIdIndexRouteImport.update({
    id: "/tasks/$taskId/",
    path: "/tasks/$taskId/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute =
  SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRouteImport.update({
    id: "/unsubscribe-assist-pro/upsert-phone/",
    path: "/unsubscribe-assist-pro/upsert-phone/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute =
  SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRouteImport.update({
    id: "/user-trackable-links/$userTrackableLinkId/",
    path: "/user-trackable-links/$userTrackableLinkId/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistUserTrackableLinksCreateIndexRoute =
  SettingsAssistUserTrackableLinksCreateIndexRouteImport.update({
    id: "/user-trackable-links/create/",
    path: "/user-trackable-links/create/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsBillingDetailsBillingIdIndexRoute =
  SettingsBillingDetailsBillingIdIndexRouteImport.update({
    id: "/settings/billing/details/$billingId/",
    path: "/settings/billing/details/$billingId/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsBillingDetailsBillingIdBoletoRoute =
  SettingsBillingDetailsBillingIdBoletoRouteImport.update({
    id: "/settings/billing/details/$billingId/boleto",
    path: "/settings/billing/details/$billingId/boleto",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsBillingDetailsBillingIdPixRoute =
  SettingsBillingDetailsBillingIdPixRouteImport.update({
    id: "/settings/billing/details/$billingId/pix",
    path: "/settings/billing/details/$billingId/pix",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute =
  SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRouteImport.update(
    {
      id: "/settings/payments/patient-payments/$guid/change-online-payment-status",
      path: "/settings/payments/patient-payments/$guid/change-online-payment-status",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute =
  SettingsPaymentsPatientPaymentsFiltersFilterOriginsRouteImport.update({
    id: "/settings/payments/patient-payments/filters/filter-origins",
    path: "/settings/payments/patient-payments/filters/filter-origins",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute =
  SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRouteImport.update({
    id: "/settings/payments/patient-payments/filters/filter-payment-methods",
    path: "/settings/payments/patient-payments/filters/filter-payment-methods",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute =
  SettingsPaymentsPatientPaymentsFiltersFilterStatusRouteImport.update({
    id: "/settings/payments/patient-payments/filters/filter-status",
    path: "/settings/payments/patient-payments/filters/filter-status",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfilePlanCancelSubscriptionIndexRoute =
  SettingsProfilePlanCancelSubscriptionIndexRouteImport.update({
    id: "/settings/profile/plan/cancel-subscription/",
    path: "/settings/profile/plan/cancel-subscription/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfilePlanChangeIndexRoute =
  SettingsProfilePlanChangeIndexRouteImport.update({
    id: "/settings/profile/plan/change/",
    path: "/settings/profile/plan/change/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileProfessionalDataEditProfessionalDataRoute =
  SettingsProfileProfessionalDataEditProfessionalDataRouteImport.update({
    id: "/settings/profile/professional-data/edit/professional-data",
    path: "/settings/profile/professional-data/edit/professional-data",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute =
  SettingsProfileProfessionalDataEditProfessionalDataContactInformationRouteImport.update(
    {
      id: "/settings/profile/professional-data/edit/professional-data-contact-information",
      path: "/settings/profile/professional-data/edit/professional-data-contact-information",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute =
  SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRouteImport.update(
    {
      id: "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel",
      path: "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/",
      path: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config",
      path: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-receiving-options/create/",
      path: "/settings/schedule-options/appointment-receiving-options/create/",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-receiving-options/create/advanced-config",
      path: "/settings/schedule-options/appointment-receiving-options/create/advanced-config",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute =
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/",
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute =
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config",
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute =
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info",
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute =
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type",
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute =
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info",
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentTypesCreateIndexRoute =
  SettingsScheduleOptionsAppointmentTypesCreateIndexRouteImport.update({
    id: "/settings/schedule-options/appointment-types/create/",
    path: "/settings/schedule-options/appointment-types/create/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute =
  SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRouteImport.update(
    {
      id: "/settings/schedule-options/appointment-types/create/advanced-config",
      path: "/settings/schedule-options/appointment-types/create/advanced-config",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute =
  SettingsScheduleOptionsAppointmentTypesCreateConfirmRouteImport.update({
    id: "/settings/schedule-options/appointment-types/create/confirm",
    path: "/settings/schedule-options/appointment-types/create/confirm",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute =
  SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRouteImport.update({
    id: "/settings/schedule-options/appointment-types/create/patient-info",
    path: "/settings/schedule-options/appointment-types/create/patient-info",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsAppointmentTypesCreateReviewRoute =
  SettingsScheduleOptionsAppointmentTypesCreateReviewRouteImport.update({
    id: "/settings/schedule-options/appointment-types/create/review",
    path: "/settings/schedule-options/appointment-types/create/review",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute =
  SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRouteImport.update({
    id: "/settings/schedule-options/appointment-types/create/room-type",
    path: "/settings/schedule-options/appointment-types/create/room-type",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute =
  SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRouteImport.update({
    id: "/settings/schedule-options/appointment-types/create/secretary-info",
    path: "/settings/schedule-options/appointment-types/create/secretary-info",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute =
  SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRouteImport.update(
    {
      id: "/settings/schedule-options/service-preferences/edit/general-preferences",
      path: "/settings/schedule-options/service-preferences/edit/general-preferences",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute =
  SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRouteImport.update(
    {
      id: "/settings/schedule-options/service-preferences/edit/patient-preferences",
      path: "/settings/schedule-options/service-preferences/edit/patient-preferences",
      getParentRoute: () => rootRouteImport,
    } as any,
  );
const WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute =
  WaitingRoomCodAgendamentoChangeTimeConfirmIndexRouteImport.update({
    id: "/waiting-room/$codAgendamento/change-time/confirm/",
    path: "/waiting-room/$codAgendamento/change-time/confirm/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute =
  SettingsAssistContactsHistoryTrialPeriodContactIdIndexRouteImport.update({
    id: "/contacts-history/trial-period/$contactId/",
    path: "/contacts-history/trial-period/$contactId/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);
const SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute =
  SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRouteImport.update(
    {
      id: "/user-trackable-links/$userTrackableLinkId/report/",
      path: "/user-trackable-links/$userTrackableLinkId/report/",
      getParentRoute: () => SettingsAssistRoute,
    } as any,
  );
const SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute =
  SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRouteImport.update(
    {
      id: "/settings/billing/details/paymentBillingGroup/$billingIdGroup/",
      path: "/settings/billing/details/paymentBillingGroup/$billingIdGroup/",
      getParentRoute: () => rootRouteImport,
    } as any,
  );

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/add-payment-card/create": typeof AddPaymentCardCreateRoute;
  "/add-payment-card/success": typeof AddPaymentCardSuccessRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/auth/idp-callback": typeof AuthIdpCallbackRoute;
  "/auth/landing": typeof AuthLandingRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/logout": typeof AuthLogoutRoute;
  "/auth/oauth-callback": typeof AuthOauthCallbackRoute;
  "/auth/signin": typeof AuthSigninRoute;
  "/extend-time/$appointmentId": typeof ExtendTimeAppointmentIdRoute;
  "/flows/$stepId": typeof FlowsStepIdRouteWithChildren;
  "/google/callback": typeof GoogleCallbackRoute;
  "/oneliv/additional-info": typeof OnelivAdditionalInfoRoute;
  "/oneliv/basic-info": typeof OnelivBasicInfoRoute;
  "/oneliv/educational-background": typeof OnelivEducationalBackgroundRoute;
  "/oneliv/experiences": typeof OnelivExperiencesRoute;
  "/oneliv/faq": typeof OnelivFaqRoute;
  "/oneliv/medical-institutions": typeof OnelivMedicalInstitutionsRoute;
  "/oneliv/social-media": typeof OnelivSocialMediaRoute;
  "/oneliv/treatment-focus": typeof OnelivTreatmentFocusRoute;
  "/oneliv/use-terms": typeof OnelivUseTermsRoute;
  "/oneliv/welcome": typeof OnelivWelcomeRoute;
  "/recurring-appointments/$codAgendamentoRecorrente": typeof RecurringAppointmentsCodAgendamentoRecorrenteRoute;
  "/settings/assist": typeof SettingsAssistRouteWithChildren;
  "/access-blocked/": typeof AccessBlockedIndexRoute;
  "/add-payment-card/": typeof AddPaymentCardIndexRoute;
  "/caf-documents-blocked/": typeof CafDocumentsBlockedIndexRoute;
  "/calendar/": typeof CalendarIndexRoute;
  "/custom-website/": typeof CustomWebsiteIndexRoute;
  "/flows/": typeof FlowsIndexRoute;
  "/general-terms/": typeof GeneralTermsIndexRoute;
  "/home/": typeof HomeIndexRoute;
  "/locations/": typeof LocationsIndexRoute;
  "/patients/": typeof PatientsIndexRoute;
  "/recommendation/": typeof RecommendationIndexRoute;
  "/recurring-appointments/": typeof RecurringAppointmentsIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/update-required/": typeof UpdateRequiredIndexRoute;
  "/waiting-room/": typeof WaitingRoomIndexRoute;
  "/appointment/$appointmentId/cancel-recurrence": typeof AppointmentAppointmentIdCancelRecurrenceRoute;
  "/appointment/$appointmentId/flexible-pricing": typeof AppointmentAppointmentIdFlexiblePricingRoute;
  "/appointment/$appointmentId/patient-swap": typeof AppointmentAppointmentIdPatientSwapRoute;
  "/appointment/$appointmentId/patient-swap-recurrence": typeof AppointmentAppointmentIdPatientSwapRecurrenceRoute;
  "/appointment/$appointmentId/patient-swap-search": typeof AppointmentAppointmentIdPatientSwapSearchRoute;
  "/appointment/$appointmentId/reschedule": typeof AppointmentAppointmentIdRescheduleRoute;
  "/appointment/$appointmentId/reschedule-patient": typeof AppointmentAppointmentIdReschedulePatientRoute;
  "/appointment/$appointmentId/reschedule-recurrence": typeof AppointmentAppointmentIdRescheduleRecurrenceRoute;
  "/appointment/create/available-options": typeof AppointmentCreateAvailableOptionsRoute;
  "/appointment/create/flexible-pricing": typeof AppointmentCreateFlexiblePricingRoute;
  "/appointment/create/patient": typeof AppointmentCreatePatientRoute;
  "/appointment/create/search-patient": typeof AppointmentCreateSearchPatientRoute;
  "/auth/first-access/complete": typeof AuthFirstAccessCompleteRoute;
  "/auth/first-access/define-password": typeof AuthFirstAccessDefinePasswordRoute;
  "/auth/first-access/document": typeof AuthFirstAccessDocumentRoute;
  "/auth/first-access/document-not-found": typeof AuthFirstAccessDocumentNotFoundRoute;
  "/auth/first-access/verify-email": typeof AuthFirstAccessVerifyEmailRoute;
  "/auth/oauth/authorize": typeof AuthOauthAuthorizeRoute;
  "/auth/password-reset/check-email": typeof AuthPasswordResetCheckEmailRoute;
  "/auth/password-reset/create-password": typeof AuthPasswordResetCreatePasswordRoute;
  "/auth/password-reset/forgot-password": typeof AuthPasswordResetForgotPasswordRoute;
  "/auth/password-reset/password-changed": typeof AuthPasswordResetPasswordChangedRoute;
  "/calendar/batch-adjust/cancel": typeof CalendarBatchAdjustCancelRoute;
  "/calendar/batch-adjust/minutes": typeof CalendarBatchAdjustMinutesRoute;
  "/calendar/batch-adjust/review": typeof CalendarBatchAdjustReviewRoute;
  "/calendar/batch-adjust/success": typeof CalendarBatchAdjustSuccessRoute;
  "/calendar/unavailable-slots/create": typeof CalendarUnavailableSlotsCreateRoute;
  "/custom-website/confirmation/error": typeof CustomWebsiteConfirmationErrorRoute;
  "/flows/$stepId/$subStepId": typeof FlowsStepIdSubStepIdRoute;
  "/flows/complete/$flowId": typeof FlowsCompleteFlowIdRoute;
  "/home/notification-center/about": typeof HomeNotificationCenterAboutRoute;
  "/onboarding/consulting/acquisition": typeof OnboardingConsultingAcquisitionRoute;
  "/onboarding/consulting/career-problem": typeof OnboardingConsultingCareerProblemRoute;
  "/onboarding/consulting/channels": typeof OnboardingConsultingChannelsRoute;
  "/onboarding/consulting/expectation": typeof OnboardingConsultingExpectationRoute;
  "/onboarding/consulting/intro": typeof OnboardingConsultingIntroRoute;
  "/onboarding/consulting/success": typeof OnboardingConsultingSuccessRoute;
  "/onboarding/first-schedule/first-appointment": typeof OnboardingFirstScheduleFirstAppointmentRoute;
  "/onboarding/first-schedule/follow-up": typeof OnboardingFirstScheduleFollowUpRoute;
  "/onboarding/first-schedule/follow-up-days": typeof OnboardingFirstScheduleFollowUpDaysRoute;
  "/onboarding/first-schedule/intro": typeof OnboardingFirstScheduleIntroRoute;
  "/onboarding/first-schedule/preview": typeof OnboardingFirstSchedulePreviewRoute;
  "/onboarding/first-schedule/schedule": typeof OnboardingFirstScheduleScheduleRoute;
  "/onboarding/first-schedule/success": typeof OnboardingFirstScheduleSuccessRoute;
  "/onboarding/welcome-meeting/details": typeof OnboardingWelcomeMeetingDetailsRoute;
  "/onboarding/welcome-meeting/dismissed": typeof OnboardingWelcomeMeetingDismissedRoute;
  "/onboarding/welcome-meeting/format": typeof OnboardingWelcomeMeetingFormatRoute;
  "/onboarding/welcome-meeting/location": typeof OnboardingWelcomeMeetingLocationRoute;
  "/onboarding/welcome-meeting/schedule": typeof OnboardingWelcomeMeetingScheduleRoute;
  "/onboarding/welcome-meeting/skip-reason": typeof OnboardingWelcomeMeetingSkipReasonRoute;
  "/onboarding/welcome-meeting/success": typeof OnboardingWelcomeMeetingSuccessRoute;
  "/patients/$patientId/update": typeof PatientsPatientIdUpdateRoute;
  "/recurring-appointments/create/availability": typeof RecurringAppointmentsCreateAvailabilityRoute;
  "/recurring-appointments/create/patient": typeof RecurringAppointmentsCreatePatientRoute;
  "/recurring-appointments/create/review": typeof RecurringAppointmentsCreateReviewRoute;
  "/recurring-appointments/create/search-patient": typeof RecurringAppointmentsCreateSearchPatientRoute;
  "/recurring-appointments/create/success": typeof RecurringAppointmentsCreateSuccessRoute;
  "/recurring-appointments/extend/$recurringAppointmentId": typeof RecurringAppointmentsExtendRecurringAppointmentIdRoute;
  "/recurring-appointments/extend/success": typeof RecurringAppointmentsExtendSuccessRoute;
  "/recurring-appointments/reschedule/availability": typeof RecurringAppointmentsRescheduleAvailabilityRoute;
  "/recurring-appointments/reschedule/review": typeof RecurringAppointmentsRescheduleReviewRoute;
  "/settings/billing/$billingItemId": typeof SettingsBillingBillingItemIdRoute;
  "/settings/billing/about": typeof SettingsBillingAboutRoute;
  "/settings/blog/create": typeof SettingsBlogCreateRoute;
  "/settings/payments/welcome": typeof SettingsPaymentsWelcomeRoute;
  "/settings/referral/about": typeof SettingsReferralAboutRoute;
  "/settings/regulatory-documents/confirmation": typeof SettingsRegulatoryDocumentsConfirmationRoute;
  "/settings/regulatory-documents/declaration-locations": typeof SettingsRegulatoryDocumentsDeclarationLocationsRoute;
  "/settings/regulatory-documents/download": typeof SettingsRegulatoryDocumentsDownloadRoute;
  "/settings/regulatory-documents/locations": typeof SettingsRegulatoryDocumentsLocationsRoute;
  "/settings/regulatory-documents/reason": typeof SettingsRegulatoryDocumentsReasonRoute;
  "/settings/regulatory-documents/requests": typeof SettingsRegulatoryDocumentsRequestsRoute;
  "/settings/regulatory-documents/review": typeof SettingsRegulatoryDocumentsReviewRoute;
  "/settings/regulatory-documents/state": typeof SettingsRegulatoryDocumentsStateRoute;
  "/waiting-room/follow-up-appointment-reminder/$appointmentId": typeof WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute;
  "/appointment/create/": typeof AppointmentCreateIndexRoute;
  "/calendar/batch-adjust/": typeof CalendarBatchAdjustIndexRoute;
  "/custom-website/confirmation/": typeof CustomWebsiteConfirmationIndexRoute;
  "/custom-website/form/": typeof CustomWebsiteFormIndexRoute;
  "/home/all-features/": typeof HomeAllFeaturesIndexRoute;
  "/home/notification-center/": typeof HomeNotificationCenterIndexRoute;
  "/locations/$locationId/": typeof LocationsLocationIdIndexRoute;
  "/onboarding/first-schedule/": typeof OnboardingFirstScheduleIndexRoute;
  "/onboarding/welcome-meeting/": typeof OnboardingWelcomeMeetingIndexRoute;
  "/patients/$patientId/": typeof PatientsPatientIdIndexRoute;
  "/recommendation/confirmation/": typeof RecommendationConfirmationIndexRoute;
  "/recurring-appointments/create/": typeof RecurringAppointmentsCreateIndexRoute;
  "/settings/assist/": typeof SettingsAssistIndexRoute;
  "/settings/billing/": typeof SettingsBillingIndexRoute;
  "/settings/blog/": typeof SettingsBlogIndexRoute;
  "/settings/community/": typeof SettingsCommunityIndexRoute;
  "/settings/google-calendar/": typeof SettingsGoogleCalendarIndexRoute;
  "/settings/payments/": typeof SettingsPaymentsIndexRoute;
  "/settings/professional-site/": typeof SettingsProfessionalSiteIndexRoute;
  "/settings/profile/": typeof SettingsProfileIndexRoute;
  "/settings/referral/": typeof SettingsReferralIndexRoute;
  "/settings/regulatory-documents/": typeof SettingsRegulatoryDocumentsIndexRoute;
  "/settings/reserved-schedules/": typeof SettingsReservedSchedulesIndexRoute;
  "/settings/schedule-options/": typeof SettingsScheduleOptionsIndexRoute;
  "/home/info/$infoItemId/confirmation": typeof HomeInfoInfoItemIdConfirmationRoute;
  "/settings/assist/secretary-details/appointment-infos": typeof SettingsAssistSecretaryDetailsAppointmentInfosRoute;
  "/settings/assist/secretary-details/faq": typeof SettingsAssistSecretaryDetailsFaqRoute;
  "/settings/assist/secretary-details/professional-infos": typeof SettingsAssistSecretaryDetailsProfessionalInfosRoute;
  "/settings/assist/secretary-details/restrictions": typeof SettingsAssistSecretaryDetailsRestrictionsRoute;
  "/settings/blog/$userPostId/edit": typeof SettingsBlogUserPostIdEditRoute;
  "/settings/payments/bank-account/change-bank-account-or-ownership": typeof SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute;
  "/settings/payments/bank-account/update": typeof SettingsPaymentsBankAccountUpdateRoute;
  "/settings/payments/create-recipient/add-bank-account": typeof SettingsPaymentsCreateRecipientAddBankAccountRoute;
  "/settings/payments/create-recipient/check-cnpj": typeof SettingsPaymentsCreateRecipientCheckCnpjRoute;
  "/settings/payments/create-recipient/choose-holder-type": typeof SettingsPaymentsCreateRecipientChooseHolderTypeRoute;
  "/settings/payments/create-recipient/confirm-bank-account": typeof SettingsPaymentsCreateRecipientConfirmBankAccountRoute;
  "/settings/payments/create-recipient/confirm-document": typeof SettingsPaymentsCreateRecipientConfirmDocumentRoute;
  "/settings/payments/create-recipient/status": typeof SettingsPaymentsCreateRecipientStatusRoute;
  "/settings/payments/create-recipient/validate-data": typeof SettingsPaymentsCreateRecipientValidateDataRoute;
  "/settings/payments/create/confirmation": typeof SettingsPaymentsCreateConfirmationRoute;
  "/settings/payments/patient-payments/about-payment-anticipation": typeof SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute;
  "/settings/payments/patient-payments/about-payment-details": typeof SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute;
  "/settings/payments/patient-payments/about-payments": typeof SettingsPaymentsPatientPaymentsAboutPaymentsRoute;
  "/settings/payments/patient-payments/details": typeof SettingsPaymentsPatientPaymentsDetailsRoute;
  "/settings/payments/patient-payments/payment-receipt": typeof SettingsPaymentsPatientPaymentsPaymentReceiptRoute;
  "/settings/payments/patient-payments/refund": typeof SettingsPaymentsPatientPaymentsRefundRoute;
  "/settings/payments/patient-payments/refund-receipt": typeof SettingsPaymentsPatientPaymentsRefundReceiptRoute;
  "/settings/payments/payables/about": typeof SettingsPaymentsPayablesAboutRoute;
  "/settings/profile/card/create": typeof SettingsProfileCardCreateRoute;
  "/settings/profile/personal-data/edit": typeof SettingsProfilePersonalDataEditRoute;
  "/settings/profile/personal-data/edit-address": typeof SettingsProfilePersonalDataEditAddressRoute;
  "/settings/profile/vehicles/$vehicleId": typeof SettingsProfileVehiclesVehicleIdRoute;
  "/settings/profile/vehicles/create": typeof SettingsProfileVehiclesCreateRoute;
  "/settings/reserved-schedules/$reservedScheduleId/cancel": typeof SettingsReservedSchedulesReservedScheduleIdCancelRoute;
  "/settings/reserved-schedules/create/confirm": typeof SettingsReservedSchedulesCreateConfirmRoute;
  "/settings/reserved-schedules/create/linked-schedule": typeof SettingsReservedSchedulesCreateLinkedScheduleRoute;
  "/settings/reserved-schedules/create/slots": typeof SettingsReservedSchedulesCreateSlotsRoute;
  "/settings/reserved-schedules/create/starting-day": typeof SettingsReservedSchedulesCreateStartingDayRoute;
  "/settings/schedule-options/preferred-rooms/$unitId": typeof SettingsScheduleOptionsPreferredRoomsUnitIdRoute;
  "/settings/schedule-options/schedules/$scheduleId": typeof SettingsScheduleOptionsSchedulesScheduleIdRoute;
  "/settings/schedule-options/schedules/create": typeof SettingsScheduleOptionsSchedulesCreateRoute;
  "/waiting-room/follow-up-appointment-reminder/patient/$patientId": typeof WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute;
  "/home/info/$infoItemId/": typeof HomeInfoInfoItemIdIndexRoute;
  "/home/notification-center/$id/": typeof HomeNotificationCenterIdIndexRoute;
  "/settings/assist/assist-pro-acceptance/": typeof SettingsAssistAssistProAcceptanceIndexRoute;
  "/settings/assist/contacts-history/": typeof SettingsAssistContactsHistoryIndexRoute;
  "/settings/assist/customer-appointment-overview/": typeof SettingsAssistCustomerAppointmentOverviewIndexRoute;
  "/settings/assist/customer-contact-overview/": typeof SettingsAssistCustomerContactOverviewIndexRoute;
  "/settings/assist/customer-site-overview/": typeof SettingsAssistCustomerSiteOverviewIndexRoute;
  "/settings/assist/feature-settings/": typeof SettingsAssistFeatureSettingsIndexRoute;
  "/settings/assist/follow-up-appointment-reminder/": typeof SettingsAssistFollowUpAppointmentReminderIndexRoute;
  "/settings/assist/rescued-appointment-overview/": typeof SettingsAssistRescuedAppointmentOverviewIndexRoute;
  "/settings/assist/secretary-details/": typeof SettingsAssistSecretaryDetailsIndexRoute;
  "/settings/assist/subscribe-assist-pro-legacy/": typeof SettingsAssistSubscribeAssistProLegacyIndexRoute;
  "/settings/assist/subscribe-assist-pro/": typeof SettingsAssistSubscribeAssistProIndexRoute;
  "/settings/assist/subscribed-assist/": typeof SettingsAssistSubscribedAssistIndexRoute;
  "/settings/assist/tasks/": typeof SettingsAssistTasksIndexRoute;
  "/settings/assist/unsubscribe-assist-pro/": typeof SettingsAssistUnsubscribeAssistProIndexRoute;
  "/settings/assist/user-trackable-links/": typeof SettingsAssistUserTrackableLinksIndexRoute;
  "/settings/billing/details/": typeof SettingsBillingDetailsIndexRoute;
  "/settings/blog/$userPostId/": typeof SettingsBlogUserPostIdIndexRoute;
  "/settings/payments/bank-account/": typeof SettingsPaymentsBankAccountIndexRoute;
  "/settings/payments/create-recipient/": typeof SettingsPaymentsCreateRecipientIndexRoute;
  "/settings/payments/create/": typeof SettingsPaymentsCreateIndexRoute;
  "/settings/payments/evolution-charts/": typeof SettingsPaymentsEvolutionChartsIndexRoute;
  "/settings/payments/patient-payments/": typeof SettingsPaymentsPatientPaymentsIndexRoute;
  "/settings/payments/payables/": typeof SettingsPaymentsPayablesIndexRoute;
  "/settings/payments/terms-of-service/": typeof SettingsPaymentsTermsOfServiceIndexRoute;
  "/settings/professional-site/about/": typeof SettingsProfessionalSiteAboutIndexRoute;
  "/settings/profile/card/": typeof SettingsProfileCardIndexRoute;
  "/settings/profile/personal-data/": typeof SettingsProfilePersonalDataIndexRoute;
  "/settings/profile/plan/": typeof SettingsProfilePlanIndexRoute;
  "/settings/profile/professional-data/": typeof SettingsProfileProfessionalDataIndexRoute;
  "/settings/profile/upsert-public-phone/": typeof SettingsProfileUpsertPublicPhoneIndexRoute;
  "/settings/profile/vehicles/": typeof SettingsProfileVehiclesIndexRoute;
  "/settings/reserved-schedules/$reservedScheduleId/": typeof SettingsReservedSchedulesReservedScheduleIdIndexRoute;
  "/settings/reserved-schedules/create/": typeof SettingsReservedSchedulesCreateIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/": typeof SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute;
  "/settings/schedule-options/appointment-types/": typeof SettingsScheduleOptionsAppointmentTypesIndexRoute;
  "/settings/schedule-options/preferred-rooms/": typeof SettingsScheduleOptionsPreferredRoomsIndexRoute;
  "/settings/schedule-options/schedules/": typeof SettingsScheduleOptionsSchedulesIndexRoute;
  "/settings/schedule-options/service-preferences/": typeof SettingsScheduleOptionsServicePreferencesIndexRoute;
  "/waiting-room/$codAgendamento/change-time/": typeof WaitingRoomCodAgendamentoChangeTimeIndexRoute;
  "/waiting-room/$codAgendamento/choose-payment-channel/": typeof WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute;
  "/waiting-room/$codAgendamento/menu/": typeof WaitingRoomCodAgendamentoMenuIndexRoute;
  "/waiting-room/$codAgendamento/receive-room-now/": typeof WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute;
  "/waiting-room/$codAgendamento/send-totem-payment/": typeof WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute;
  "/settings/billing/details/$billingId/boleto": typeof SettingsBillingDetailsBillingIdBoletoRoute;
  "/settings/billing/details/$billingId/pix": typeof SettingsBillingDetailsBillingIdPixRoute;
  "/settings/payments/patient-payments/$guid/change-online-payment-status": typeof SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute;
  "/settings/payments/patient-payments/filters/filter-origins": typeof SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute;
  "/settings/payments/patient-payments/filters/filter-payment-methods": typeof SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute;
  "/settings/payments/patient-payments/filters/filter-status": typeof SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute;
  "/settings/profile/professional-data/edit/professional-data": typeof SettingsProfileProfessionalDataEditProfessionalDataRoute;
  "/settings/profile/professional-data/edit/professional-data-contact-information": typeof SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute;
  "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel": typeof SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute;
  "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config": typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute;
  "/settings/schedule-options/appointment-receiving-options/create/advanced-config": typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute;
  "/settings/schedule-options/appointment-types/create/advanced-config": typeof SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/create/confirm": typeof SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute;
  "/settings/schedule-options/appointment-types/create/patient-info": typeof SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute;
  "/settings/schedule-options/appointment-types/create/review": typeof SettingsScheduleOptionsAppointmentTypesCreateReviewRoute;
  "/settings/schedule-options/appointment-types/create/room-type": typeof SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute;
  "/settings/schedule-options/appointment-types/create/secretary-info": typeof SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute;
  "/settings/schedule-options/service-preferences/edit/general-preferences": typeof SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute;
  "/settings/schedule-options/service-preferences/edit/patient-preferences": typeof SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute;
  "/settings/assist/contacts-history/$contactId/": typeof SettingsAssistContactsHistoryContactIdIndexRoute;
  "/settings/assist/contacts-history/about/": typeof SettingsAssistContactsHistoryAboutIndexRoute;
  "/settings/assist/contacts-history/essential/": typeof SettingsAssistContactsHistoryEssentialIndexRoute;
  "/settings/assist/contacts-history/trial-period/": typeof SettingsAssistContactsHistoryTrialPeriodIndexRoute;
  "/settings/assist/customer-contact-overview/stories-feed/": typeof SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute;
  "/settings/assist/follow-up-appointment-reminder/patients/": typeof SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute;
  "/settings/assist/subscribe-assist-pro/confirm/": typeof SettingsAssistSubscribeAssistProConfirmIndexRoute;
  "/settings/assist/tasks/$taskId/": typeof SettingsAssistTasksTaskIdIndexRoute;
  "/settings/assist/unsubscribe-assist-pro/upsert-phone/": typeof SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute;
  "/settings/assist/user-trackable-links/$userTrackableLinkId/": typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute;
  "/settings/assist/user-trackable-links/create/": typeof SettingsAssistUserTrackableLinksCreateIndexRoute;
  "/settings/billing/details/$billingId/": typeof SettingsBillingDetailsBillingIdIndexRoute;
  "/settings/profile/plan/cancel-subscription/": typeof SettingsProfilePlanCancelSubscriptionIndexRoute;
  "/settings/profile/plan/change/": typeof SettingsProfilePlanChangeIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/": typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/create/": typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute;
  "/settings/schedule-options/appointment-types/create/": typeof SettingsScheduleOptionsAppointmentTypesCreateIndexRoute;
  "/waiting-room/$codAgendamento/change-time/confirm/": typeof WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute;
  "/settings/assist/contacts-history/trial-period/$contactId/": typeof SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute;
  "/settings/assist/user-trackable-links/$userTrackableLinkId/report/": typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute;
  "/settings/billing/details/paymentBillingGroup/$billingIdGroup/": typeof SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/add-payment-card/create": typeof AddPaymentCardCreateRoute;
  "/add-payment-card/success": typeof AddPaymentCardSuccessRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/auth/idp-callback": typeof AuthIdpCallbackRoute;
  "/auth/landing": typeof AuthLandingRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/logout": typeof AuthLogoutRoute;
  "/auth/oauth-callback": typeof AuthOauthCallbackRoute;
  "/auth/signin": typeof AuthSigninRoute;
  "/extend-time/$appointmentId": typeof ExtendTimeAppointmentIdRoute;
  "/flows/$stepId": typeof FlowsStepIdRouteWithChildren;
  "/google/callback": typeof GoogleCallbackRoute;
  "/oneliv/additional-info": typeof OnelivAdditionalInfoRoute;
  "/oneliv/basic-info": typeof OnelivBasicInfoRoute;
  "/oneliv/educational-background": typeof OnelivEducationalBackgroundRoute;
  "/oneliv/experiences": typeof OnelivExperiencesRoute;
  "/oneliv/faq": typeof OnelivFaqRoute;
  "/oneliv/medical-institutions": typeof OnelivMedicalInstitutionsRoute;
  "/oneliv/social-media": typeof OnelivSocialMediaRoute;
  "/oneliv/treatment-focus": typeof OnelivTreatmentFocusRoute;
  "/oneliv/use-terms": typeof OnelivUseTermsRoute;
  "/oneliv/welcome": typeof OnelivWelcomeRoute;
  "/recurring-appointments/$codAgendamentoRecorrente": typeof RecurringAppointmentsCodAgendamentoRecorrenteRoute;
  "/access-blocked": typeof AccessBlockedIndexRoute;
  "/add-payment-card": typeof AddPaymentCardIndexRoute;
  "/caf-documents-blocked": typeof CafDocumentsBlockedIndexRoute;
  "/calendar": typeof CalendarIndexRoute;
  "/custom-website": typeof CustomWebsiteIndexRoute;
  "/flows": typeof FlowsIndexRoute;
  "/general-terms": typeof GeneralTermsIndexRoute;
  "/home": typeof HomeIndexRoute;
  "/locations": typeof LocationsIndexRoute;
  "/patients": typeof PatientsIndexRoute;
  "/recommendation": typeof RecommendationIndexRoute;
  "/recurring-appointments": typeof RecurringAppointmentsIndexRoute;
  "/settings": typeof SettingsIndexRoute;
  "/update-required": typeof UpdateRequiredIndexRoute;
  "/waiting-room": typeof WaitingRoomIndexRoute;
  "/appointment/$appointmentId/cancel-recurrence": typeof AppointmentAppointmentIdCancelRecurrenceRoute;
  "/appointment/$appointmentId/flexible-pricing": typeof AppointmentAppointmentIdFlexiblePricingRoute;
  "/appointment/$appointmentId/patient-swap": typeof AppointmentAppointmentIdPatientSwapRoute;
  "/appointment/$appointmentId/patient-swap-recurrence": typeof AppointmentAppointmentIdPatientSwapRecurrenceRoute;
  "/appointment/$appointmentId/patient-swap-search": typeof AppointmentAppointmentIdPatientSwapSearchRoute;
  "/appointment/$appointmentId/reschedule": typeof AppointmentAppointmentIdRescheduleRoute;
  "/appointment/$appointmentId/reschedule-patient": typeof AppointmentAppointmentIdReschedulePatientRoute;
  "/appointment/$appointmentId/reschedule-recurrence": typeof AppointmentAppointmentIdRescheduleRecurrenceRoute;
  "/appointment/create/available-options": typeof AppointmentCreateAvailableOptionsRoute;
  "/appointment/create/flexible-pricing": typeof AppointmentCreateFlexiblePricingRoute;
  "/appointment/create/patient": typeof AppointmentCreatePatientRoute;
  "/appointment/create/search-patient": typeof AppointmentCreateSearchPatientRoute;
  "/auth/first-access/complete": typeof AuthFirstAccessCompleteRoute;
  "/auth/first-access/define-password": typeof AuthFirstAccessDefinePasswordRoute;
  "/auth/first-access/document": typeof AuthFirstAccessDocumentRoute;
  "/auth/first-access/document-not-found": typeof AuthFirstAccessDocumentNotFoundRoute;
  "/auth/first-access/verify-email": typeof AuthFirstAccessVerifyEmailRoute;
  "/auth/oauth/authorize": typeof AuthOauthAuthorizeRoute;
  "/auth/password-reset/check-email": typeof AuthPasswordResetCheckEmailRoute;
  "/auth/password-reset/create-password": typeof AuthPasswordResetCreatePasswordRoute;
  "/auth/password-reset/forgot-password": typeof AuthPasswordResetForgotPasswordRoute;
  "/auth/password-reset/password-changed": typeof AuthPasswordResetPasswordChangedRoute;
  "/calendar/batch-adjust/cancel": typeof CalendarBatchAdjustCancelRoute;
  "/calendar/batch-adjust/minutes": typeof CalendarBatchAdjustMinutesRoute;
  "/calendar/batch-adjust/review": typeof CalendarBatchAdjustReviewRoute;
  "/calendar/batch-adjust/success": typeof CalendarBatchAdjustSuccessRoute;
  "/calendar/unavailable-slots/create": typeof CalendarUnavailableSlotsCreateRoute;
  "/custom-website/confirmation/error": typeof CustomWebsiteConfirmationErrorRoute;
  "/flows/$stepId/$subStepId": typeof FlowsStepIdSubStepIdRoute;
  "/flows/complete/$flowId": typeof FlowsCompleteFlowIdRoute;
  "/home/notification-center/about": typeof HomeNotificationCenterAboutRoute;
  "/onboarding/consulting/acquisition": typeof OnboardingConsultingAcquisitionRoute;
  "/onboarding/consulting/career-problem": typeof OnboardingConsultingCareerProblemRoute;
  "/onboarding/consulting/channels": typeof OnboardingConsultingChannelsRoute;
  "/onboarding/consulting/expectation": typeof OnboardingConsultingExpectationRoute;
  "/onboarding/consulting/intro": typeof OnboardingConsultingIntroRoute;
  "/onboarding/consulting/success": typeof OnboardingConsultingSuccessRoute;
  "/onboarding/first-schedule/first-appointment": typeof OnboardingFirstScheduleFirstAppointmentRoute;
  "/onboarding/first-schedule/follow-up": typeof OnboardingFirstScheduleFollowUpRoute;
  "/onboarding/first-schedule/follow-up-days": typeof OnboardingFirstScheduleFollowUpDaysRoute;
  "/onboarding/first-schedule/intro": typeof OnboardingFirstScheduleIntroRoute;
  "/onboarding/first-schedule/preview": typeof OnboardingFirstSchedulePreviewRoute;
  "/onboarding/first-schedule/schedule": typeof OnboardingFirstScheduleScheduleRoute;
  "/onboarding/first-schedule/success": typeof OnboardingFirstScheduleSuccessRoute;
  "/onboarding/welcome-meeting/details": typeof OnboardingWelcomeMeetingDetailsRoute;
  "/onboarding/welcome-meeting/dismissed": typeof OnboardingWelcomeMeetingDismissedRoute;
  "/onboarding/welcome-meeting/format": typeof OnboardingWelcomeMeetingFormatRoute;
  "/onboarding/welcome-meeting/location": typeof OnboardingWelcomeMeetingLocationRoute;
  "/onboarding/welcome-meeting/schedule": typeof OnboardingWelcomeMeetingScheduleRoute;
  "/onboarding/welcome-meeting/skip-reason": typeof OnboardingWelcomeMeetingSkipReasonRoute;
  "/onboarding/welcome-meeting/success": typeof OnboardingWelcomeMeetingSuccessRoute;
  "/patients/$patientId/update": typeof PatientsPatientIdUpdateRoute;
  "/recurring-appointments/create/availability": typeof RecurringAppointmentsCreateAvailabilityRoute;
  "/recurring-appointments/create/patient": typeof RecurringAppointmentsCreatePatientRoute;
  "/recurring-appointments/create/review": typeof RecurringAppointmentsCreateReviewRoute;
  "/recurring-appointments/create/search-patient": typeof RecurringAppointmentsCreateSearchPatientRoute;
  "/recurring-appointments/create/success": typeof RecurringAppointmentsCreateSuccessRoute;
  "/recurring-appointments/extend/$recurringAppointmentId": typeof RecurringAppointmentsExtendRecurringAppointmentIdRoute;
  "/recurring-appointments/extend/success": typeof RecurringAppointmentsExtendSuccessRoute;
  "/recurring-appointments/reschedule/availability": typeof RecurringAppointmentsRescheduleAvailabilityRoute;
  "/recurring-appointments/reschedule/review": typeof RecurringAppointmentsRescheduleReviewRoute;
  "/settings/billing/$billingItemId": typeof SettingsBillingBillingItemIdRoute;
  "/settings/billing/about": typeof SettingsBillingAboutRoute;
  "/settings/blog/create": typeof SettingsBlogCreateRoute;
  "/settings/payments/welcome": typeof SettingsPaymentsWelcomeRoute;
  "/settings/referral/about": typeof SettingsReferralAboutRoute;
  "/settings/regulatory-documents/confirmation": typeof SettingsRegulatoryDocumentsConfirmationRoute;
  "/settings/regulatory-documents/declaration-locations": typeof SettingsRegulatoryDocumentsDeclarationLocationsRoute;
  "/settings/regulatory-documents/download": typeof SettingsRegulatoryDocumentsDownloadRoute;
  "/settings/regulatory-documents/locations": typeof SettingsRegulatoryDocumentsLocationsRoute;
  "/settings/regulatory-documents/reason": typeof SettingsRegulatoryDocumentsReasonRoute;
  "/settings/regulatory-documents/requests": typeof SettingsRegulatoryDocumentsRequestsRoute;
  "/settings/regulatory-documents/review": typeof SettingsRegulatoryDocumentsReviewRoute;
  "/settings/regulatory-documents/state": typeof SettingsRegulatoryDocumentsStateRoute;
  "/waiting-room/follow-up-appointment-reminder/$appointmentId": typeof WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute;
  "/appointment/create": typeof AppointmentCreateIndexRoute;
  "/calendar/batch-adjust": typeof CalendarBatchAdjustIndexRoute;
  "/custom-website/confirmation": typeof CustomWebsiteConfirmationIndexRoute;
  "/custom-website/form": typeof CustomWebsiteFormIndexRoute;
  "/home/all-features": typeof HomeAllFeaturesIndexRoute;
  "/home/notification-center": typeof HomeNotificationCenterIndexRoute;
  "/locations/$locationId": typeof LocationsLocationIdIndexRoute;
  "/onboarding/first-schedule": typeof OnboardingFirstScheduleIndexRoute;
  "/onboarding/welcome-meeting": typeof OnboardingWelcomeMeetingIndexRoute;
  "/patients/$patientId": typeof PatientsPatientIdIndexRoute;
  "/recommendation/confirmation": typeof RecommendationConfirmationIndexRoute;
  "/recurring-appointments/create": typeof RecurringAppointmentsCreateIndexRoute;
  "/settings/assist": typeof SettingsAssistIndexRoute;
  "/settings/billing": typeof SettingsBillingIndexRoute;
  "/settings/blog": typeof SettingsBlogIndexRoute;
  "/settings/community": typeof SettingsCommunityIndexRoute;
  "/settings/google-calendar": typeof SettingsGoogleCalendarIndexRoute;
  "/settings/payments": typeof SettingsPaymentsIndexRoute;
  "/settings/professional-site": typeof SettingsProfessionalSiteIndexRoute;
  "/settings/profile": typeof SettingsProfileIndexRoute;
  "/settings/referral": typeof SettingsReferralIndexRoute;
  "/settings/regulatory-documents": typeof SettingsRegulatoryDocumentsIndexRoute;
  "/settings/reserved-schedules": typeof SettingsReservedSchedulesIndexRoute;
  "/settings/schedule-options": typeof SettingsScheduleOptionsIndexRoute;
  "/home/info/$infoItemId/confirmation": typeof HomeInfoInfoItemIdConfirmationRoute;
  "/settings/assist/secretary-details/appointment-infos": typeof SettingsAssistSecretaryDetailsAppointmentInfosRoute;
  "/settings/assist/secretary-details/faq": typeof SettingsAssistSecretaryDetailsFaqRoute;
  "/settings/assist/secretary-details/professional-infos": typeof SettingsAssistSecretaryDetailsProfessionalInfosRoute;
  "/settings/assist/secretary-details/restrictions": typeof SettingsAssistSecretaryDetailsRestrictionsRoute;
  "/settings/blog/$userPostId/edit": typeof SettingsBlogUserPostIdEditRoute;
  "/settings/payments/bank-account/change-bank-account-or-ownership": typeof SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute;
  "/settings/payments/bank-account/update": typeof SettingsPaymentsBankAccountUpdateRoute;
  "/settings/payments/create-recipient/add-bank-account": typeof SettingsPaymentsCreateRecipientAddBankAccountRoute;
  "/settings/payments/create-recipient/check-cnpj": typeof SettingsPaymentsCreateRecipientCheckCnpjRoute;
  "/settings/payments/create-recipient/choose-holder-type": typeof SettingsPaymentsCreateRecipientChooseHolderTypeRoute;
  "/settings/payments/create-recipient/confirm-bank-account": typeof SettingsPaymentsCreateRecipientConfirmBankAccountRoute;
  "/settings/payments/create-recipient/confirm-document": typeof SettingsPaymentsCreateRecipientConfirmDocumentRoute;
  "/settings/payments/create-recipient/status": typeof SettingsPaymentsCreateRecipientStatusRoute;
  "/settings/payments/create-recipient/validate-data": typeof SettingsPaymentsCreateRecipientValidateDataRoute;
  "/settings/payments/create/confirmation": typeof SettingsPaymentsCreateConfirmationRoute;
  "/settings/payments/patient-payments/about-payment-anticipation": typeof SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute;
  "/settings/payments/patient-payments/about-payment-details": typeof SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute;
  "/settings/payments/patient-payments/about-payments": typeof SettingsPaymentsPatientPaymentsAboutPaymentsRoute;
  "/settings/payments/patient-payments/details": typeof SettingsPaymentsPatientPaymentsDetailsRoute;
  "/settings/payments/patient-payments/payment-receipt": typeof SettingsPaymentsPatientPaymentsPaymentReceiptRoute;
  "/settings/payments/patient-payments/refund": typeof SettingsPaymentsPatientPaymentsRefundRoute;
  "/settings/payments/patient-payments/refund-receipt": typeof SettingsPaymentsPatientPaymentsRefundReceiptRoute;
  "/settings/payments/payables/about": typeof SettingsPaymentsPayablesAboutRoute;
  "/settings/profile/card/create": typeof SettingsProfileCardCreateRoute;
  "/settings/profile/personal-data/edit": typeof SettingsProfilePersonalDataEditRoute;
  "/settings/profile/personal-data/edit-address": typeof SettingsProfilePersonalDataEditAddressRoute;
  "/settings/profile/vehicles/$vehicleId": typeof SettingsProfileVehiclesVehicleIdRoute;
  "/settings/profile/vehicles/create": typeof SettingsProfileVehiclesCreateRoute;
  "/settings/reserved-schedules/$reservedScheduleId/cancel": typeof SettingsReservedSchedulesReservedScheduleIdCancelRoute;
  "/settings/reserved-schedules/create/confirm": typeof SettingsReservedSchedulesCreateConfirmRoute;
  "/settings/reserved-schedules/create/linked-schedule": typeof SettingsReservedSchedulesCreateLinkedScheduleRoute;
  "/settings/reserved-schedules/create/slots": typeof SettingsReservedSchedulesCreateSlotsRoute;
  "/settings/reserved-schedules/create/starting-day": typeof SettingsReservedSchedulesCreateStartingDayRoute;
  "/settings/schedule-options/preferred-rooms/$unitId": typeof SettingsScheduleOptionsPreferredRoomsUnitIdRoute;
  "/settings/schedule-options/schedules/$scheduleId": typeof SettingsScheduleOptionsSchedulesScheduleIdRoute;
  "/settings/schedule-options/schedules/create": typeof SettingsScheduleOptionsSchedulesCreateRoute;
  "/waiting-room/follow-up-appointment-reminder/patient/$patientId": typeof WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute;
  "/home/info/$infoItemId": typeof HomeInfoInfoItemIdIndexRoute;
  "/home/notification-center/$id": typeof HomeNotificationCenterIdIndexRoute;
  "/settings/assist/assist-pro-acceptance": typeof SettingsAssistAssistProAcceptanceIndexRoute;
  "/settings/assist/contacts-history": typeof SettingsAssistContactsHistoryIndexRoute;
  "/settings/assist/customer-appointment-overview": typeof SettingsAssistCustomerAppointmentOverviewIndexRoute;
  "/settings/assist/customer-contact-overview": typeof SettingsAssistCustomerContactOverviewIndexRoute;
  "/settings/assist/customer-site-overview": typeof SettingsAssistCustomerSiteOverviewIndexRoute;
  "/settings/assist/feature-settings": typeof SettingsAssistFeatureSettingsIndexRoute;
  "/settings/assist/follow-up-appointment-reminder": typeof SettingsAssistFollowUpAppointmentReminderIndexRoute;
  "/settings/assist/rescued-appointment-overview": typeof SettingsAssistRescuedAppointmentOverviewIndexRoute;
  "/settings/assist/secretary-details": typeof SettingsAssistSecretaryDetailsIndexRoute;
  "/settings/assist/subscribe-assist-pro-legacy": typeof SettingsAssistSubscribeAssistProLegacyIndexRoute;
  "/settings/assist/subscribe-assist-pro": typeof SettingsAssistSubscribeAssistProIndexRoute;
  "/settings/assist/subscribed-assist": typeof SettingsAssistSubscribedAssistIndexRoute;
  "/settings/assist/tasks": typeof SettingsAssistTasksIndexRoute;
  "/settings/assist/unsubscribe-assist-pro": typeof SettingsAssistUnsubscribeAssistProIndexRoute;
  "/settings/assist/user-trackable-links": typeof SettingsAssistUserTrackableLinksIndexRoute;
  "/settings/billing/details": typeof SettingsBillingDetailsIndexRoute;
  "/settings/blog/$userPostId": typeof SettingsBlogUserPostIdIndexRoute;
  "/settings/payments/bank-account": typeof SettingsPaymentsBankAccountIndexRoute;
  "/settings/payments/create-recipient": typeof SettingsPaymentsCreateRecipientIndexRoute;
  "/settings/payments/create": typeof SettingsPaymentsCreateIndexRoute;
  "/settings/payments/evolution-charts": typeof SettingsPaymentsEvolutionChartsIndexRoute;
  "/settings/payments/patient-payments": typeof SettingsPaymentsPatientPaymentsIndexRoute;
  "/settings/payments/payables": typeof SettingsPaymentsPayablesIndexRoute;
  "/settings/payments/terms-of-service": typeof SettingsPaymentsTermsOfServiceIndexRoute;
  "/settings/professional-site/about": typeof SettingsProfessionalSiteAboutIndexRoute;
  "/settings/profile/card": typeof SettingsProfileCardIndexRoute;
  "/settings/profile/personal-data": typeof SettingsProfilePersonalDataIndexRoute;
  "/settings/profile/plan": typeof SettingsProfilePlanIndexRoute;
  "/settings/profile/professional-data": typeof SettingsProfileProfessionalDataIndexRoute;
  "/settings/profile/upsert-public-phone": typeof SettingsProfileUpsertPublicPhoneIndexRoute;
  "/settings/profile/vehicles": typeof SettingsProfileVehiclesIndexRoute;
  "/settings/reserved-schedules/$reservedScheduleId": typeof SettingsReservedSchedulesReservedScheduleIdIndexRoute;
  "/settings/reserved-schedules/create": typeof SettingsReservedSchedulesCreateIndexRoute;
  "/settings/schedule-options/appointment-receiving-options": typeof SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute;
  "/settings/schedule-options/appointment-types": typeof SettingsScheduleOptionsAppointmentTypesIndexRoute;
  "/settings/schedule-options/preferred-rooms": typeof SettingsScheduleOptionsPreferredRoomsIndexRoute;
  "/settings/schedule-options/schedules": typeof SettingsScheduleOptionsSchedulesIndexRoute;
  "/settings/schedule-options/service-preferences": typeof SettingsScheduleOptionsServicePreferencesIndexRoute;
  "/waiting-room/$codAgendamento/change-time": typeof WaitingRoomCodAgendamentoChangeTimeIndexRoute;
  "/waiting-room/$codAgendamento/choose-payment-channel": typeof WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute;
  "/waiting-room/$codAgendamento/menu": typeof WaitingRoomCodAgendamentoMenuIndexRoute;
  "/waiting-room/$codAgendamento/receive-room-now": typeof WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute;
  "/waiting-room/$codAgendamento/send-totem-payment": typeof WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute;
  "/settings/billing/details/$billingId/boleto": typeof SettingsBillingDetailsBillingIdBoletoRoute;
  "/settings/billing/details/$billingId/pix": typeof SettingsBillingDetailsBillingIdPixRoute;
  "/settings/payments/patient-payments/$guid/change-online-payment-status": typeof SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute;
  "/settings/payments/patient-payments/filters/filter-origins": typeof SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute;
  "/settings/payments/patient-payments/filters/filter-payment-methods": typeof SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute;
  "/settings/payments/patient-payments/filters/filter-status": typeof SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute;
  "/settings/profile/professional-data/edit/professional-data": typeof SettingsProfileProfessionalDataEditProfessionalDataRoute;
  "/settings/profile/professional-data/edit/professional-data-contact-information": typeof SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute;
  "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel": typeof SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute;
  "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config": typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute;
  "/settings/schedule-options/appointment-receiving-options/create/advanced-config": typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute;
  "/settings/schedule-options/appointment-types/create/advanced-config": typeof SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/create/confirm": typeof SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute;
  "/settings/schedule-options/appointment-types/create/patient-info": typeof SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute;
  "/settings/schedule-options/appointment-types/create/review": typeof SettingsScheduleOptionsAppointmentTypesCreateReviewRoute;
  "/settings/schedule-options/appointment-types/create/room-type": typeof SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute;
  "/settings/schedule-options/appointment-types/create/secretary-info": typeof SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute;
  "/settings/schedule-options/service-preferences/edit/general-preferences": typeof SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute;
  "/settings/schedule-options/service-preferences/edit/patient-preferences": typeof SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute;
  "/settings/assist/contacts-history/$contactId": typeof SettingsAssistContactsHistoryContactIdIndexRoute;
  "/settings/assist/contacts-history/about": typeof SettingsAssistContactsHistoryAboutIndexRoute;
  "/settings/assist/contacts-history/essential": typeof SettingsAssistContactsHistoryEssentialIndexRoute;
  "/settings/assist/contacts-history/trial-period": typeof SettingsAssistContactsHistoryTrialPeriodIndexRoute;
  "/settings/assist/customer-contact-overview/stories-feed": typeof SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute;
  "/settings/assist/follow-up-appointment-reminder/patients": typeof SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute;
  "/settings/assist/subscribe-assist-pro/confirm": typeof SettingsAssistSubscribeAssistProConfirmIndexRoute;
  "/settings/assist/tasks/$taskId": typeof SettingsAssistTasksTaskIdIndexRoute;
  "/settings/assist/unsubscribe-assist-pro/upsert-phone": typeof SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute;
  "/settings/assist/user-trackable-links/$userTrackableLinkId": typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute;
  "/settings/assist/user-trackable-links/create": typeof SettingsAssistUserTrackableLinksCreateIndexRoute;
  "/settings/billing/details/$billingId": typeof SettingsBillingDetailsBillingIdIndexRoute;
  "/settings/profile/plan/cancel-subscription": typeof SettingsProfilePlanCancelSubscriptionIndexRoute;
  "/settings/profile/plan/change": typeof SettingsProfilePlanChangeIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId": typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/create": typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute;
  "/settings/schedule-options/appointment-types/create": typeof SettingsScheduleOptionsAppointmentTypesCreateIndexRoute;
  "/waiting-room/$codAgendamento/change-time/confirm": typeof WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute;
  "/settings/assist/contacts-history/trial-period/$contactId": typeof SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute;
  "/settings/assist/user-trackable-links/$userTrackableLinkId/report": typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute;
  "/settings/billing/details/paymentBillingGroup/$billingIdGroup": typeof SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/add-payment-card/create": typeof AddPaymentCardCreateRoute;
  "/add-payment-card/success": typeof AddPaymentCardSuccessRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/auth/idp-callback": typeof AuthIdpCallbackRoute;
  "/auth/landing": typeof AuthLandingRoute;
  "/auth/login": typeof AuthLoginRoute;
  "/auth/logout": typeof AuthLogoutRoute;
  "/auth/oauth-callback": typeof AuthOauthCallbackRoute;
  "/auth/signin": typeof AuthSigninRoute;
  "/extend-time/$appointmentId": typeof ExtendTimeAppointmentIdRoute;
  "/flows/$stepId": typeof FlowsStepIdRouteWithChildren;
  "/google/callback": typeof GoogleCallbackRoute;
  "/oneliv/additional-info": typeof OnelivAdditionalInfoRoute;
  "/oneliv/basic-info": typeof OnelivBasicInfoRoute;
  "/oneliv/educational-background": typeof OnelivEducationalBackgroundRoute;
  "/oneliv/experiences": typeof OnelivExperiencesRoute;
  "/oneliv/faq": typeof OnelivFaqRoute;
  "/oneliv/medical-institutions": typeof OnelivMedicalInstitutionsRoute;
  "/oneliv/social-media": typeof OnelivSocialMediaRoute;
  "/oneliv/treatment-focus": typeof OnelivTreatmentFocusRoute;
  "/oneliv/use-terms": typeof OnelivUseTermsRoute;
  "/oneliv/welcome": typeof OnelivWelcomeRoute;
  "/recurring-appointments/$codAgendamentoRecorrente": typeof RecurringAppointmentsCodAgendamentoRecorrenteRoute;
  "/settings/assist": typeof SettingsAssistRouteWithChildren;
  "/access-blocked/": typeof AccessBlockedIndexRoute;
  "/add-payment-card/": typeof AddPaymentCardIndexRoute;
  "/caf-documents-blocked/": typeof CafDocumentsBlockedIndexRoute;
  "/calendar/": typeof CalendarIndexRoute;
  "/custom-website/": typeof CustomWebsiteIndexRoute;
  "/flows/": typeof FlowsIndexRoute;
  "/general-terms/": typeof GeneralTermsIndexRoute;
  "/home/": typeof HomeIndexRoute;
  "/locations/": typeof LocationsIndexRoute;
  "/patients/": typeof PatientsIndexRoute;
  "/recommendation/": typeof RecommendationIndexRoute;
  "/recurring-appointments/": typeof RecurringAppointmentsIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/update-required/": typeof UpdateRequiredIndexRoute;
  "/waiting-room/": typeof WaitingRoomIndexRoute;
  "/appointment/$appointmentId/cancel-recurrence": typeof AppointmentAppointmentIdCancelRecurrenceRoute;
  "/appointment/$appointmentId/flexible-pricing": typeof AppointmentAppointmentIdFlexiblePricingRoute;
  "/appointment/$appointmentId/patient-swap": typeof AppointmentAppointmentIdPatientSwapRoute;
  "/appointment/$appointmentId/patient-swap-recurrence": typeof AppointmentAppointmentIdPatientSwapRecurrenceRoute;
  "/appointment/$appointmentId/patient-swap-search": typeof AppointmentAppointmentIdPatientSwapSearchRoute;
  "/appointment/$appointmentId/reschedule": typeof AppointmentAppointmentIdRescheduleRoute;
  "/appointment/$appointmentId/reschedule-patient": typeof AppointmentAppointmentIdReschedulePatientRoute;
  "/appointment/$appointmentId/reschedule-recurrence": typeof AppointmentAppointmentIdRescheduleRecurrenceRoute;
  "/appointment/create/available-options": typeof AppointmentCreateAvailableOptionsRoute;
  "/appointment/create/flexible-pricing": typeof AppointmentCreateFlexiblePricingRoute;
  "/appointment/create/patient": typeof AppointmentCreatePatientRoute;
  "/appointment/create/search-patient": typeof AppointmentCreateSearchPatientRoute;
  "/auth/first-access/complete": typeof AuthFirstAccessCompleteRoute;
  "/auth/first-access/define-password": typeof AuthFirstAccessDefinePasswordRoute;
  "/auth/first-access/document": typeof AuthFirstAccessDocumentRoute;
  "/auth/first-access/document-not-found": typeof AuthFirstAccessDocumentNotFoundRoute;
  "/auth/first-access/verify-email": typeof AuthFirstAccessVerifyEmailRoute;
  "/auth/oauth/authorize": typeof AuthOauthAuthorizeRoute;
  "/auth/password-reset/check-email": typeof AuthPasswordResetCheckEmailRoute;
  "/auth/password-reset/create-password": typeof AuthPasswordResetCreatePasswordRoute;
  "/auth/password-reset/forgot-password": typeof AuthPasswordResetForgotPasswordRoute;
  "/auth/password-reset/password-changed": typeof AuthPasswordResetPasswordChangedRoute;
  "/calendar/batch-adjust/cancel": typeof CalendarBatchAdjustCancelRoute;
  "/calendar/batch-adjust/minutes": typeof CalendarBatchAdjustMinutesRoute;
  "/calendar/batch-adjust/review": typeof CalendarBatchAdjustReviewRoute;
  "/calendar/batch-adjust/success": typeof CalendarBatchAdjustSuccessRoute;
  "/calendar/unavailable-slots/create": typeof CalendarUnavailableSlotsCreateRoute;
  "/custom-website/confirmation/error": typeof CustomWebsiteConfirmationErrorRoute;
  "/flows/$stepId/$subStepId": typeof FlowsStepIdSubStepIdRoute;
  "/flows/complete/$flowId": typeof FlowsCompleteFlowIdRoute;
  "/home/notification-center/about": typeof HomeNotificationCenterAboutRoute;
  "/onboarding/consulting/acquisition": typeof OnboardingConsultingAcquisitionRoute;
  "/onboarding/consulting/career-problem": typeof OnboardingConsultingCareerProblemRoute;
  "/onboarding/consulting/channels": typeof OnboardingConsultingChannelsRoute;
  "/onboarding/consulting/expectation": typeof OnboardingConsultingExpectationRoute;
  "/onboarding/consulting/intro": typeof OnboardingConsultingIntroRoute;
  "/onboarding/consulting/success": typeof OnboardingConsultingSuccessRoute;
  "/onboarding/first-schedule/first-appointment": typeof OnboardingFirstScheduleFirstAppointmentRoute;
  "/onboarding/first-schedule/follow-up": typeof OnboardingFirstScheduleFollowUpRoute;
  "/onboarding/first-schedule/follow-up-days": typeof OnboardingFirstScheduleFollowUpDaysRoute;
  "/onboarding/first-schedule/intro": typeof OnboardingFirstScheduleIntroRoute;
  "/onboarding/first-schedule/preview": typeof OnboardingFirstSchedulePreviewRoute;
  "/onboarding/first-schedule/schedule": typeof OnboardingFirstScheduleScheduleRoute;
  "/onboarding/first-schedule/success": typeof OnboardingFirstScheduleSuccessRoute;
  "/onboarding/welcome-meeting/details": typeof OnboardingWelcomeMeetingDetailsRoute;
  "/onboarding/welcome-meeting/dismissed": typeof OnboardingWelcomeMeetingDismissedRoute;
  "/onboarding/welcome-meeting/format": typeof OnboardingWelcomeMeetingFormatRoute;
  "/onboarding/welcome-meeting/location": typeof OnboardingWelcomeMeetingLocationRoute;
  "/onboarding/welcome-meeting/schedule": typeof OnboardingWelcomeMeetingScheduleRoute;
  "/onboarding/welcome-meeting/skip-reason": typeof OnboardingWelcomeMeetingSkipReasonRoute;
  "/onboarding/welcome-meeting/success": typeof OnboardingWelcomeMeetingSuccessRoute;
  "/patients/$patientId/update": typeof PatientsPatientIdUpdateRoute;
  "/recurring-appointments/create/availability": typeof RecurringAppointmentsCreateAvailabilityRoute;
  "/recurring-appointments/create/patient": typeof RecurringAppointmentsCreatePatientRoute;
  "/recurring-appointments/create/review": typeof RecurringAppointmentsCreateReviewRoute;
  "/recurring-appointments/create/search-patient": typeof RecurringAppointmentsCreateSearchPatientRoute;
  "/recurring-appointments/create/success": typeof RecurringAppointmentsCreateSuccessRoute;
  "/recurring-appointments/extend/$recurringAppointmentId": typeof RecurringAppointmentsExtendRecurringAppointmentIdRoute;
  "/recurring-appointments/extend/success": typeof RecurringAppointmentsExtendSuccessRoute;
  "/recurring-appointments/reschedule/availability": typeof RecurringAppointmentsRescheduleAvailabilityRoute;
  "/recurring-appointments/reschedule/review": typeof RecurringAppointmentsRescheduleReviewRoute;
  "/settings/billing/$billingItemId": typeof SettingsBillingBillingItemIdRoute;
  "/settings/billing/about": typeof SettingsBillingAboutRoute;
  "/settings/blog/create": typeof SettingsBlogCreateRoute;
  "/settings/payments/welcome": typeof SettingsPaymentsWelcomeRoute;
  "/settings/referral/about": typeof SettingsReferralAboutRoute;
  "/settings/regulatory-documents/confirmation": typeof SettingsRegulatoryDocumentsConfirmationRoute;
  "/settings/regulatory-documents/declaration-locations": typeof SettingsRegulatoryDocumentsDeclarationLocationsRoute;
  "/settings/regulatory-documents/download": typeof SettingsRegulatoryDocumentsDownloadRoute;
  "/settings/regulatory-documents/locations": typeof SettingsRegulatoryDocumentsLocationsRoute;
  "/settings/regulatory-documents/reason": typeof SettingsRegulatoryDocumentsReasonRoute;
  "/settings/regulatory-documents/requests": typeof SettingsRegulatoryDocumentsRequestsRoute;
  "/settings/regulatory-documents/review": typeof SettingsRegulatoryDocumentsReviewRoute;
  "/settings/regulatory-documents/state": typeof SettingsRegulatoryDocumentsStateRoute;
  "/waiting-room/follow-up-appointment-reminder/$appointmentId": typeof WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute;
  "/appointment/create/": typeof AppointmentCreateIndexRoute;
  "/calendar/batch-adjust/": typeof CalendarBatchAdjustIndexRoute;
  "/custom-website/confirmation/": typeof CustomWebsiteConfirmationIndexRoute;
  "/custom-website/form/": typeof CustomWebsiteFormIndexRoute;
  "/home/all-features/": typeof HomeAllFeaturesIndexRoute;
  "/home/notification-center/": typeof HomeNotificationCenterIndexRoute;
  "/locations/$locationId/": typeof LocationsLocationIdIndexRoute;
  "/onboarding/first-schedule/": typeof OnboardingFirstScheduleIndexRoute;
  "/onboarding/welcome-meeting/": typeof OnboardingWelcomeMeetingIndexRoute;
  "/patients/$patientId/": typeof PatientsPatientIdIndexRoute;
  "/recommendation/confirmation/": typeof RecommendationConfirmationIndexRoute;
  "/recurring-appointments/create/": typeof RecurringAppointmentsCreateIndexRoute;
  "/settings/assist/": typeof SettingsAssistIndexRoute;
  "/settings/billing/": typeof SettingsBillingIndexRoute;
  "/settings/blog/": typeof SettingsBlogIndexRoute;
  "/settings/community/": typeof SettingsCommunityIndexRoute;
  "/settings/google-calendar/": typeof SettingsGoogleCalendarIndexRoute;
  "/settings/payments/": typeof SettingsPaymentsIndexRoute;
  "/settings/professional-site/": typeof SettingsProfessionalSiteIndexRoute;
  "/settings/profile/": typeof SettingsProfileIndexRoute;
  "/settings/referral/": typeof SettingsReferralIndexRoute;
  "/settings/regulatory-documents/": typeof SettingsRegulatoryDocumentsIndexRoute;
  "/settings/reserved-schedules/": typeof SettingsReservedSchedulesIndexRoute;
  "/settings/schedule-options/": typeof SettingsScheduleOptionsIndexRoute;
  "/home/info/$infoItemId/confirmation": typeof HomeInfoInfoItemIdConfirmationRoute;
  "/settings/assist/secretary-details/appointment-infos": typeof SettingsAssistSecretaryDetailsAppointmentInfosRoute;
  "/settings/assist/secretary-details/faq": typeof SettingsAssistSecretaryDetailsFaqRoute;
  "/settings/assist/secretary-details/professional-infos": typeof SettingsAssistSecretaryDetailsProfessionalInfosRoute;
  "/settings/assist/secretary-details/restrictions": typeof SettingsAssistSecretaryDetailsRestrictionsRoute;
  "/settings/blog/$userPostId/edit": typeof SettingsBlogUserPostIdEditRoute;
  "/settings/payments/bank-account/change-bank-account-or-ownership": typeof SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute;
  "/settings/payments/bank-account/update": typeof SettingsPaymentsBankAccountUpdateRoute;
  "/settings/payments/create-recipient/add-bank-account": typeof SettingsPaymentsCreateRecipientAddBankAccountRoute;
  "/settings/payments/create-recipient/check-cnpj": typeof SettingsPaymentsCreateRecipientCheckCnpjRoute;
  "/settings/payments/create-recipient/choose-holder-type": typeof SettingsPaymentsCreateRecipientChooseHolderTypeRoute;
  "/settings/payments/create-recipient/confirm-bank-account": typeof SettingsPaymentsCreateRecipientConfirmBankAccountRoute;
  "/settings/payments/create-recipient/confirm-document": typeof SettingsPaymentsCreateRecipientConfirmDocumentRoute;
  "/settings/payments/create-recipient/status": typeof SettingsPaymentsCreateRecipientStatusRoute;
  "/settings/payments/create-recipient/validate-data": typeof SettingsPaymentsCreateRecipientValidateDataRoute;
  "/settings/payments/create/confirmation": typeof SettingsPaymentsCreateConfirmationRoute;
  "/settings/payments/patient-payments/about-payment-anticipation": typeof SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute;
  "/settings/payments/patient-payments/about-payment-details": typeof SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute;
  "/settings/payments/patient-payments/about-payments": typeof SettingsPaymentsPatientPaymentsAboutPaymentsRoute;
  "/settings/payments/patient-payments/details": typeof SettingsPaymentsPatientPaymentsDetailsRoute;
  "/settings/payments/patient-payments/payment-receipt": typeof SettingsPaymentsPatientPaymentsPaymentReceiptRoute;
  "/settings/payments/patient-payments/refund": typeof SettingsPaymentsPatientPaymentsRefundRoute;
  "/settings/payments/patient-payments/refund-receipt": typeof SettingsPaymentsPatientPaymentsRefundReceiptRoute;
  "/settings/payments/payables/about": typeof SettingsPaymentsPayablesAboutRoute;
  "/settings/profile/card/create": typeof SettingsProfileCardCreateRoute;
  "/settings/profile/personal-data/edit": typeof SettingsProfilePersonalDataEditRoute;
  "/settings/profile/personal-data/edit-address": typeof SettingsProfilePersonalDataEditAddressRoute;
  "/settings/profile/vehicles/$vehicleId": typeof SettingsProfileVehiclesVehicleIdRoute;
  "/settings/profile/vehicles/create": typeof SettingsProfileVehiclesCreateRoute;
  "/settings/reserved-schedules/$reservedScheduleId/cancel": typeof SettingsReservedSchedulesReservedScheduleIdCancelRoute;
  "/settings/reserved-schedules/create/confirm": typeof SettingsReservedSchedulesCreateConfirmRoute;
  "/settings/reserved-schedules/create/linked-schedule": typeof SettingsReservedSchedulesCreateLinkedScheduleRoute;
  "/settings/reserved-schedules/create/slots": typeof SettingsReservedSchedulesCreateSlotsRoute;
  "/settings/reserved-schedules/create/starting-day": typeof SettingsReservedSchedulesCreateStartingDayRoute;
  "/settings/schedule-options/preferred-rooms/$unitId": typeof SettingsScheduleOptionsPreferredRoomsUnitIdRoute;
  "/settings/schedule-options/schedules/$scheduleId": typeof SettingsScheduleOptionsSchedulesScheduleIdRoute;
  "/settings/schedule-options/schedules/create": typeof SettingsScheduleOptionsSchedulesCreateRoute;
  "/waiting-room/follow-up-appointment-reminder/patient/$patientId": typeof WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute;
  "/home/info/$infoItemId/": typeof HomeInfoInfoItemIdIndexRoute;
  "/home/notification-center/$id/": typeof HomeNotificationCenterIdIndexRoute;
  "/settings/assist/assist-pro-acceptance/": typeof SettingsAssistAssistProAcceptanceIndexRoute;
  "/settings/assist/contacts-history/": typeof SettingsAssistContactsHistoryIndexRoute;
  "/settings/assist/customer-appointment-overview/": typeof SettingsAssistCustomerAppointmentOverviewIndexRoute;
  "/settings/assist/customer-contact-overview/": typeof SettingsAssistCustomerContactOverviewIndexRoute;
  "/settings/assist/customer-site-overview/": typeof SettingsAssistCustomerSiteOverviewIndexRoute;
  "/settings/assist/feature-settings/": typeof SettingsAssistFeatureSettingsIndexRoute;
  "/settings/assist/follow-up-appointment-reminder/": typeof SettingsAssistFollowUpAppointmentReminderIndexRoute;
  "/settings/assist/rescued-appointment-overview/": typeof SettingsAssistRescuedAppointmentOverviewIndexRoute;
  "/settings/assist/secretary-details/": typeof SettingsAssistSecretaryDetailsIndexRoute;
  "/settings/assist/subscribe-assist-pro-legacy/": typeof SettingsAssistSubscribeAssistProLegacyIndexRoute;
  "/settings/assist/subscribe-assist-pro/": typeof SettingsAssistSubscribeAssistProIndexRoute;
  "/settings/assist/subscribed-assist/": typeof SettingsAssistSubscribedAssistIndexRoute;
  "/settings/assist/tasks/": typeof SettingsAssistTasksIndexRoute;
  "/settings/assist/unsubscribe-assist-pro/": typeof SettingsAssistUnsubscribeAssistProIndexRoute;
  "/settings/assist/user-trackable-links/": typeof SettingsAssistUserTrackableLinksIndexRoute;
  "/settings/billing/details/": typeof SettingsBillingDetailsIndexRoute;
  "/settings/blog/$userPostId/": typeof SettingsBlogUserPostIdIndexRoute;
  "/settings/payments/bank-account/": typeof SettingsPaymentsBankAccountIndexRoute;
  "/settings/payments/create-recipient/": typeof SettingsPaymentsCreateRecipientIndexRoute;
  "/settings/payments/create/": typeof SettingsPaymentsCreateIndexRoute;
  "/settings/payments/evolution-charts/": typeof SettingsPaymentsEvolutionChartsIndexRoute;
  "/settings/payments/patient-payments/": typeof SettingsPaymentsPatientPaymentsIndexRoute;
  "/settings/payments/payables/": typeof SettingsPaymentsPayablesIndexRoute;
  "/settings/payments/terms-of-service/": typeof SettingsPaymentsTermsOfServiceIndexRoute;
  "/settings/professional-site/about/": typeof SettingsProfessionalSiteAboutIndexRoute;
  "/settings/profile/card/": typeof SettingsProfileCardIndexRoute;
  "/settings/profile/personal-data/": typeof SettingsProfilePersonalDataIndexRoute;
  "/settings/profile/plan/": typeof SettingsProfilePlanIndexRoute;
  "/settings/profile/professional-data/": typeof SettingsProfileProfessionalDataIndexRoute;
  "/settings/profile/upsert-public-phone/": typeof SettingsProfileUpsertPublicPhoneIndexRoute;
  "/settings/profile/vehicles/": typeof SettingsProfileVehiclesIndexRoute;
  "/settings/reserved-schedules/$reservedScheduleId/": typeof SettingsReservedSchedulesReservedScheduleIdIndexRoute;
  "/settings/reserved-schedules/create/": typeof SettingsReservedSchedulesCreateIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/": typeof SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute;
  "/settings/schedule-options/appointment-types/": typeof SettingsScheduleOptionsAppointmentTypesIndexRoute;
  "/settings/schedule-options/preferred-rooms/": typeof SettingsScheduleOptionsPreferredRoomsIndexRoute;
  "/settings/schedule-options/schedules/": typeof SettingsScheduleOptionsSchedulesIndexRoute;
  "/settings/schedule-options/service-preferences/": typeof SettingsScheduleOptionsServicePreferencesIndexRoute;
  "/waiting-room/$codAgendamento/change-time/": typeof WaitingRoomCodAgendamentoChangeTimeIndexRoute;
  "/waiting-room/$codAgendamento/choose-payment-channel/": typeof WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute;
  "/waiting-room/$codAgendamento/menu/": typeof WaitingRoomCodAgendamentoMenuIndexRoute;
  "/waiting-room/$codAgendamento/receive-room-now/": typeof WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute;
  "/waiting-room/$codAgendamento/send-totem-payment/": typeof WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute;
  "/settings/billing/details/$billingId/boleto": typeof SettingsBillingDetailsBillingIdBoletoRoute;
  "/settings/billing/details/$billingId/pix": typeof SettingsBillingDetailsBillingIdPixRoute;
  "/settings/payments/patient-payments/$guid/change-online-payment-status": typeof SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute;
  "/settings/payments/patient-payments/filters/filter-origins": typeof SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute;
  "/settings/payments/patient-payments/filters/filter-payment-methods": typeof SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute;
  "/settings/payments/patient-payments/filters/filter-status": typeof SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute;
  "/settings/profile/professional-data/edit/professional-data": typeof SettingsProfileProfessionalDataEditProfessionalDataRoute;
  "/settings/profile/professional-data/edit/professional-data-contact-information": typeof SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute;
  "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel": typeof SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute;
  "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config": typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute;
  "/settings/schedule-options/appointment-receiving-options/create/advanced-config": typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute;
  "/settings/schedule-options/appointment-types/create/advanced-config": typeof SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute;
  "/settings/schedule-options/appointment-types/create/confirm": typeof SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute;
  "/settings/schedule-options/appointment-types/create/patient-info": typeof SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute;
  "/settings/schedule-options/appointment-types/create/review": typeof SettingsScheduleOptionsAppointmentTypesCreateReviewRoute;
  "/settings/schedule-options/appointment-types/create/room-type": typeof SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute;
  "/settings/schedule-options/appointment-types/create/secretary-info": typeof SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute;
  "/settings/schedule-options/service-preferences/edit/general-preferences": typeof SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute;
  "/settings/schedule-options/service-preferences/edit/patient-preferences": typeof SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute;
  "/settings/assist/contacts-history/$contactId/": typeof SettingsAssistContactsHistoryContactIdIndexRoute;
  "/settings/assist/contacts-history/about/": typeof SettingsAssistContactsHistoryAboutIndexRoute;
  "/settings/assist/contacts-history/essential/": typeof SettingsAssistContactsHistoryEssentialIndexRoute;
  "/settings/assist/contacts-history/trial-period/": typeof SettingsAssistContactsHistoryTrialPeriodIndexRoute;
  "/settings/assist/customer-contact-overview/stories-feed/": typeof SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute;
  "/settings/assist/follow-up-appointment-reminder/patients/": typeof SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute;
  "/settings/assist/subscribe-assist-pro/confirm/": typeof SettingsAssistSubscribeAssistProConfirmIndexRoute;
  "/settings/assist/tasks/$taskId/": typeof SettingsAssistTasksTaskIdIndexRoute;
  "/settings/assist/unsubscribe-assist-pro/upsert-phone/": typeof SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute;
  "/settings/assist/user-trackable-links/$userTrackableLinkId/": typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute;
  "/settings/assist/user-trackable-links/create/": typeof SettingsAssistUserTrackableLinksCreateIndexRoute;
  "/settings/billing/details/$billingId/": typeof SettingsBillingDetailsBillingIdIndexRoute;
  "/settings/profile/plan/cancel-subscription/": typeof SettingsProfilePlanCancelSubscriptionIndexRoute;
  "/settings/profile/plan/change/": typeof SettingsProfilePlanChangeIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/": typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute;
  "/settings/schedule-options/appointment-receiving-options/create/": typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute;
  "/settings/schedule-options/appointment-types/$appointmentTypeId/": typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute;
  "/settings/schedule-options/appointment-types/create/": typeof SettingsScheduleOptionsAppointmentTypesCreateIndexRoute;
  "/waiting-room/$codAgendamento/change-time/confirm/": typeof WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute;
  "/settings/assist/contacts-history/trial-period/$contactId/": typeof SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute;
  "/settings/assist/user-trackable-links/$userTrackableLinkId/report/": typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute;
  "/settings/billing/details/paymentBillingGroup/$billingIdGroup/": typeof SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/add-payment-card/create"
    | "/add-payment-card/success"
    | "/auth/callback"
    | "/auth/idp-callback"
    | "/auth/landing"
    | "/auth/login"
    | "/auth/logout"
    | "/auth/oauth-callback"
    | "/auth/signin"
    | "/extend-time/$appointmentId"
    | "/flows/$stepId"
    | "/google/callback"
    | "/oneliv/additional-info"
    | "/oneliv/basic-info"
    | "/oneliv/educational-background"
    | "/oneliv/experiences"
    | "/oneliv/faq"
    | "/oneliv/medical-institutions"
    | "/oneliv/social-media"
    | "/oneliv/treatment-focus"
    | "/oneliv/use-terms"
    | "/oneliv/welcome"
    | "/recurring-appointments/$codAgendamentoRecorrente"
    | "/settings/assist"
    | "/access-blocked/"
    | "/add-payment-card/"
    | "/caf-documents-blocked/"
    | "/calendar/"
    | "/custom-website/"
    | "/flows/"
    | "/general-terms/"
    | "/home/"
    | "/locations/"
    | "/patients/"
    | "/recommendation/"
    | "/recurring-appointments/"
    | "/settings/"
    | "/update-required/"
    | "/waiting-room/"
    | "/appointment/$appointmentId/cancel-recurrence"
    | "/appointment/$appointmentId/flexible-pricing"
    | "/appointment/$appointmentId/patient-swap"
    | "/appointment/$appointmentId/patient-swap-recurrence"
    | "/appointment/$appointmentId/patient-swap-search"
    | "/appointment/$appointmentId/reschedule"
    | "/appointment/$appointmentId/reschedule-patient"
    | "/appointment/$appointmentId/reschedule-recurrence"
    | "/appointment/create/available-options"
    | "/appointment/create/flexible-pricing"
    | "/appointment/create/patient"
    | "/appointment/create/search-patient"
    | "/auth/first-access/complete"
    | "/auth/first-access/define-password"
    | "/auth/first-access/document"
    | "/auth/first-access/document-not-found"
    | "/auth/first-access/verify-email"
    | "/auth/oauth/authorize"
    | "/auth/password-reset/check-email"
    | "/auth/password-reset/create-password"
    | "/auth/password-reset/forgot-password"
    | "/auth/password-reset/password-changed"
    | "/calendar/batch-adjust/cancel"
    | "/calendar/batch-adjust/minutes"
    | "/calendar/batch-adjust/review"
    | "/calendar/batch-adjust/success"
    | "/calendar/unavailable-slots/create"
    | "/custom-website/confirmation/error"
    | "/flows/$stepId/$subStepId"
    | "/flows/complete/$flowId"
    | "/home/notification-center/about"
    | "/onboarding/consulting/acquisition"
    | "/onboarding/consulting/career-problem"
    | "/onboarding/consulting/channels"
    | "/onboarding/consulting/expectation"
    | "/onboarding/consulting/intro"
    | "/onboarding/consulting/success"
    | "/onboarding/first-schedule/first-appointment"
    | "/onboarding/first-schedule/follow-up"
    | "/onboarding/first-schedule/follow-up-days"
    | "/onboarding/first-schedule/intro"
    | "/onboarding/first-schedule/preview"
    | "/onboarding/first-schedule/schedule"
    | "/onboarding/first-schedule/success"
    | "/onboarding/welcome-meeting/details"
    | "/onboarding/welcome-meeting/dismissed"
    | "/onboarding/welcome-meeting/format"
    | "/onboarding/welcome-meeting/location"
    | "/onboarding/welcome-meeting/schedule"
    | "/onboarding/welcome-meeting/skip-reason"
    | "/onboarding/welcome-meeting/success"
    | "/patients/$patientId/update"
    | "/recurring-appointments/create/availability"
    | "/recurring-appointments/create/patient"
    | "/recurring-appointments/create/review"
    | "/recurring-appointments/create/search-patient"
    | "/recurring-appointments/create/success"
    | "/recurring-appointments/extend/$recurringAppointmentId"
    | "/recurring-appointments/extend/success"
    | "/recurring-appointments/reschedule/availability"
    | "/recurring-appointments/reschedule/review"
    | "/settings/billing/$billingItemId"
    | "/settings/billing/about"
    | "/settings/blog/create"
    | "/settings/payments/welcome"
    | "/settings/referral/about"
    | "/settings/regulatory-documents/confirmation"
    | "/settings/regulatory-documents/declaration-locations"
    | "/settings/regulatory-documents/download"
    | "/settings/regulatory-documents/locations"
    | "/settings/regulatory-documents/reason"
    | "/settings/regulatory-documents/requests"
    | "/settings/regulatory-documents/review"
    | "/settings/regulatory-documents/state"
    | "/waiting-room/follow-up-appointment-reminder/$appointmentId"
    | "/appointment/create/"
    | "/calendar/batch-adjust/"
    | "/custom-website/confirmation/"
    | "/custom-website/form/"
    | "/home/all-features/"
    | "/home/notification-center/"
    | "/locations/$locationId/"
    | "/onboarding/first-schedule/"
    | "/onboarding/welcome-meeting/"
    | "/patients/$patientId/"
    | "/recommendation/confirmation/"
    | "/recurring-appointments/create/"
    | "/settings/assist/"
    | "/settings/billing/"
    | "/settings/blog/"
    | "/settings/community/"
    | "/settings/google-calendar/"
    | "/settings/payments/"
    | "/settings/professional-site/"
    | "/settings/profile/"
    | "/settings/referral/"
    | "/settings/regulatory-documents/"
    | "/settings/reserved-schedules/"
    | "/settings/schedule-options/"
    | "/home/info/$infoItemId/confirmation"
    | "/settings/assist/secretary-details/appointment-infos"
    | "/settings/assist/secretary-details/faq"
    | "/settings/assist/secretary-details/professional-infos"
    | "/settings/assist/secretary-details/restrictions"
    | "/settings/blog/$userPostId/edit"
    | "/settings/payments/bank-account/change-bank-account-or-ownership"
    | "/settings/payments/bank-account/update"
    | "/settings/payments/create-recipient/add-bank-account"
    | "/settings/payments/create-recipient/check-cnpj"
    | "/settings/payments/create-recipient/choose-holder-type"
    | "/settings/payments/create-recipient/confirm-bank-account"
    | "/settings/payments/create-recipient/confirm-document"
    | "/settings/payments/create-recipient/status"
    | "/settings/payments/create-recipient/validate-data"
    | "/settings/payments/create/confirmation"
    | "/settings/payments/patient-payments/about-payment-anticipation"
    | "/settings/payments/patient-payments/about-payment-details"
    | "/settings/payments/patient-payments/about-payments"
    | "/settings/payments/patient-payments/details"
    | "/settings/payments/patient-payments/payment-receipt"
    | "/settings/payments/patient-payments/refund"
    | "/settings/payments/patient-payments/refund-receipt"
    | "/settings/payments/payables/about"
    | "/settings/profile/card/create"
    | "/settings/profile/personal-data/edit"
    | "/settings/profile/personal-data/edit-address"
    | "/settings/profile/vehicles/$vehicleId"
    | "/settings/profile/vehicles/create"
    | "/settings/reserved-schedules/$reservedScheduleId/cancel"
    | "/settings/reserved-schedules/create/confirm"
    | "/settings/reserved-schedules/create/linked-schedule"
    | "/settings/reserved-schedules/create/slots"
    | "/settings/reserved-schedules/create/starting-day"
    | "/settings/schedule-options/preferred-rooms/$unitId"
    | "/settings/schedule-options/schedules/$scheduleId"
    | "/settings/schedule-options/schedules/create"
    | "/waiting-room/follow-up-appointment-reminder/patient/$patientId"
    | "/home/info/$infoItemId/"
    | "/home/notification-center/$id/"
    | "/settings/assist/assist-pro-acceptance/"
    | "/settings/assist/contacts-history/"
    | "/settings/assist/customer-appointment-overview/"
    | "/settings/assist/customer-contact-overview/"
    | "/settings/assist/customer-site-overview/"
    | "/settings/assist/feature-settings/"
    | "/settings/assist/follow-up-appointment-reminder/"
    | "/settings/assist/rescued-appointment-overview/"
    | "/settings/assist/secretary-details/"
    | "/settings/assist/subscribe-assist-pro-legacy/"
    | "/settings/assist/subscribe-assist-pro/"
    | "/settings/assist/subscribed-assist/"
    | "/settings/assist/tasks/"
    | "/settings/assist/unsubscribe-assist-pro/"
    | "/settings/assist/user-trackable-links/"
    | "/settings/billing/details/"
    | "/settings/blog/$userPostId/"
    | "/settings/payments/bank-account/"
    | "/settings/payments/create-recipient/"
    | "/settings/payments/create/"
    | "/settings/payments/evolution-charts/"
    | "/settings/payments/patient-payments/"
    | "/settings/payments/payables/"
    | "/settings/payments/terms-of-service/"
    | "/settings/professional-site/about/"
    | "/settings/profile/card/"
    | "/settings/profile/personal-data/"
    | "/settings/profile/plan/"
    | "/settings/profile/professional-data/"
    | "/settings/profile/upsert-public-phone/"
    | "/settings/profile/vehicles/"
    | "/settings/reserved-schedules/$reservedScheduleId/"
    | "/settings/reserved-schedules/create/"
    | "/settings/schedule-options/appointment-receiving-options/"
    | "/settings/schedule-options/appointment-types/"
    | "/settings/schedule-options/preferred-rooms/"
    | "/settings/schedule-options/schedules/"
    | "/settings/schedule-options/service-preferences/"
    | "/waiting-room/$codAgendamento/change-time/"
    | "/waiting-room/$codAgendamento/choose-payment-channel/"
    | "/waiting-room/$codAgendamento/menu/"
    | "/waiting-room/$codAgendamento/receive-room-now/"
    | "/waiting-room/$codAgendamento/send-totem-payment/"
    | "/settings/billing/details/$billingId/boleto"
    | "/settings/billing/details/$billingId/pix"
    | "/settings/payments/patient-payments/$guid/change-online-payment-status"
    | "/settings/payments/patient-payments/filters/filter-origins"
    | "/settings/payments/patient-payments/filters/filter-payment-methods"
    | "/settings/payments/patient-payments/filters/filter-status"
    | "/settings/profile/professional-data/edit/professional-data"
    | "/settings/profile/professional-data/edit/professional-data-contact-information"
    | "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel"
    | "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config"
    | "/settings/schedule-options/appointment-receiving-options/create/advanced-config"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info"
    | "/settings/schedule-options/appointment-types/create/advanced-config"
    | "/settings/schedule-options/appointment-types/create/confirm"
    | "/settings/schedule-options/appointment-types/create/patient-info"
    | "/settings/schedule-options/appointment-types/create/review"
    | "/settings/schedule-options/appointment-types/create/room-type"
    | "/settings/schedule-options/appointment-types/create/secretary-info"
    | "/settings/schedule-options/service-preferences/edit/general-preferences"
    | "/settings/schedule-options/service-preferences/edit/patient-preferences"
    | "/settings/assist/contacts-history/$contactId/"
    | "/settings/assist/contacts-history/about/"
    | "/settings/assist/contacts-history/essential/"
    | "/settings/assist/contacts-history/trial-period/"
    | "/settings/assist/customer-contact-overview/stories-feed/"
    | "/settings/assist/follow-up-appointment-reminder/patients/"
    | "/settings/assist/subscribe-assist-pro/confirm/"
    | "/settings/assist/tasks/$taskId/"
    | "/settings/assist/unsubscribe-assist-pro/upsert-phone/"
    | "/settings/assist/user-trackable-links/$userTrackableLinkId/"
    | "/settings/assist/user-trackable-links/create/"
    | "/settings/billing/details/$billingId/"
    | "/settings/profile/plan/cancel-subscription/"
    | "/settings/profile/plan/change/"
    | "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/"
    | "/settings/schedule-options/appointment-receiving-options/create/"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/"
    | "/settings/schedule-options/appointment-types/create/"
    | "/waiting-room/$codAgendamento/change-time/confirm/"
    | "/settings/assist/contacts-history/trial-period/$contactId/"
    | "/settings/assist/user-trackable-links/$userTrackableLinkId/report/"
    | "/settings/billing/details/paymentBillingGroup/$billingIdGroup/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/add-payment-card/create"
    | "/add-payment-card/success"
    | "/auth/callback"
    | "/auth/idp-callback"
    | "/auth/landing"
    | "/auth/login"
    | "/auth/logout"
    | "/auth/oauth-callback"
    | "/auth/signin"
    | "/extend-time/$appointmentId"
    | "/flows/$stepId"
    | "/google/callback"
    | "/oneliv/additional-info"
    | "/oneliv/basic-info"
    | "/oneliv/educational-background"
    | "/oneliv/experiences"
    | "/oneliv/faq"
    | "/oneliv/medical-institutions"
    | "/oneliv/social-media"
    | "/oneliv/treatment-focus"
    | "/oneliv/use-terms"
    | "/oneliv/welcome"
    | "/recurring-appointments/$codAgendamentoRecorrente"
    | "/access-blocked"
    | "/add-payment-card"
    | "/caf-documents-blocked"
    | "/calendar"
    | "/custom-website"
    | "/flows"
    | "/general-terms"
    | "/home"
    | "/locations"
    | "/patients"
    | "/recommendation"
    | "/recurring-appointments"
    | "/settings"
    | "/update-required"
    | "/waiting-room"
    | "/appointment/$appointmentId/cancel-recurrence"
    | "/appointment/$appointmentId/flexible-pricing"
    | "/appointment/$appointmentId/patient-swap"
    | "/appointment/$appointmentId/patient-swap-recurrence"
    | "/appointment/$appointmentId/patient-swap-search"
    | "/appointment/$appointmentId/reschedule"
    | "/appointment/$appointmentId/reschedule-patient"
    | "/appointment/$appointmentId/reschedule-recurrence"
    | "/appointment/create/available-options"
    | "/appointment/create/flexible-pricing"
    | "/appointment/create/patient"
    | "/appointment/create/search-patient"
    | "/auth/first-access/complete"
    | "/auth/first-access/define-password"
    | "/auth/first-access/document"
    | "/auth/first-access/document-not-found"
    | "/auth/first-access/verify-email"
    | "/auth/oauth/authorize"
    | "/auth/password-reset/check-email"
    | "/auth/password-reset/create-password"
    | "/auth/password-reset/forgot-password"
    | "/auth/password-reset/password-changed"
    | "/calendar/batch-adjust/cancel"
    | "/calendar/batch-adjust/minutes"
    | "/calendar/batch-adjust/review"
    | "/calendar/batch-adjust/success"
    | "/calendar/unavailable-slots/create"
    | "/custom-website/confirmation/error"
    | "/flows/$stepId/$subStepId"
    | "/flows/complete/$flowId"
    | "/home/notification-center/about"
    | "/onboarding/consulting/acquisition"
    | "/onboarding/consulting/career-problem"
    | "/onboarding/consulting/channels"
    | "/onboarding/consulting/expectation"
    | "/onboarding/consulting/intro"
    | "/onboarding/consulting/success"
    | "/onboarding/first-schedule/first-appointment"
    | "/onboarding/first-schedule/follow-up"
    | "/onboarding/first-schedule/follow-up-days"
    | "/onboarding/first-schedule/intro"
    | "/onboarding/first-schedule/preview"
    | "/onboarding/first-schedule/schedule"
    | "/onboarding/first-schedule/success"
    | "/onboarding/welcome-meeting/details"
    | "/onboarding/welcome-meeting/dismissed"
    | "/onboarding/welcome-meeting/format"
    | "/onboarding/welcome-meeting/location"
    | "/onboarding/welcome-meeting/schedule"
    | "/onboarding/welcome-meeting/skip-reason"
    | "/onboarding/welcome-meeting/success"
    | "/patients/$patientId/update"
    | "/recurring-appointments/create/availability"
    | "/recurring-appointments/create/patient"
    | "/recurring-appointments/create/review"
    | "/recurring-appointments/create/search-patient"
    | "/recurring-appointments/create/success"
    | "/recurring-appointments/extend/$recurringAppointmentId"
    | "/recurring-appointments/extend/success"
    | "/recurring-appointments/reschedule/availability"
    | "/recurring-appointments/reschedule/review"
    | "/settings/billing/$billingItemId"
    | "/settings/billing/about"
    | "/settings/blog/create"
    | "/settings/payments/welcome"
    | "/settings/referral/about"
    | "/settings/regulatory-documents/confirmation"
    | "/settings/regulatory-documents/declaration-locations"
    | "/settings/regulatory-documents/download"
    | "/settings/regulatory-documents/locations"
    | "/settings/regulatory-documents/reason"
    | "/settings/regulatory-documents/requests"
    | "/settings/regulatory-documents/review"
    | "/settings/regulatory-documents/state"
    | "/waiting-room/follow-up-appointment-reminder/$appointmentId"
    | "/appointment/create"
    | "/calendar/batch-adjust"
    | "/custom-website/confirmation"
    | "/custom-website/form"
    | "/home/all-features"
    | "/home/notification-center"
    | "/locations/$locationId"
    | "/onboarding/first-schedule"
    | "/onboarding/welcome-meeting"
    | "/patients/$patientId"
    | "/recommendation/confirmation"
    | "/recurring-appointments/create"
    | "/settings/assist"
    | "/settings/billing"
    | "/settings/blog"
    | "/settings/community"
    | "/settings/google-calendar"
    | "/settings/payments"
    | "/settings/professional-site"
    | "/settings/profile"
    | "/settings/referral"
    | "/settings/regulatory-documents"
    | "/settings/reserved-schedules"
    | "/settings/schedule-options"
    | "/home/info/$infoItemId/confirmation"
    | "/settings/assist/secretary-details/appointment-infos"
    | "/settings/assist/secretary-details/faq"
    | "/settings/assist/secretary-details/professional-infos"
    | "/settings/assist/secretary-details/restrictions"
    | "/settings/blog/$userPostId/edit"
    | "/settings/payments/bank-account/change-bank-account-or-ownership"
    | "/settings/payments/bank-account/update"
    | "/settings/payments/create-recipient/add-bank-account"
    | "/settings/payments/create-recipient/check-cnpj"
    | "/settings/payments/create-recipient/choose-holder-type"
    | "/settings/payments/create-recipient/confirm-bank-account"
    | "/settings/payments/create-recipient/confirm-document"
    | "/settings/payments/create-recipient/status"
    | "/settings/payments/create-recipient/validate-data"
    | "/settings/payments/create/confirmation"
    | "/settings/payments/patient-payments/about-payment-anticipation"
    | "/settings/payments/patient-payments/about-payment-details"
    | "/settings/payments/patient-payments/about-payments"
    | "/settings/payments/patient-payments/details"
    | "/settings/payments/patient-payments/payment-receipt"
    | "/settings/payments/patient-payments/refund"
    | "/settings/payments/patient-payments/refund-receipt"
    | "/settings/payments/payables/about"
    | "/settings/profile/card/create"
    | "/settings/profile/personal-data/edit"
    | "/settings/profile/personal-data/edit-address"
    | "/settings/profile/vehicles/$vehicleId"
    | "/settings/profile/vehicles/create"
    | "/settings/reserved-schedules/$reservedScheduleId/cancel"
    | "/settings/reserved-schedules/create/confirm"
    | "/settings/reserved-schedules/create/linked-schedule"
    | "/settings/reserved-schedules/create/slots"
    | "/settings/reserved-schedules/create/starting-day"
    | "/settings/schedule-options/preferred-rooms/$unitId"
    | "/settings/schedule-options/schedules/$scheduleId"
    | "/settings/schedule-options/schedules/create"
    | "/waiting-room/follow-up-appointment-reminder/patient/$patientId"
    | "/home/info/$infoItemId"
    | "/home/notification-center/$id"
    | "/settings/assist/assist-pro-acceptance"
    | "/settings/assist/contacts-history"
    | "/settings/assist/customer-appointment-overview"
    | "/settings/assist/customer-contact-overview"
    | "/settings/assist/customer-site-overview"
    | "/settings/assist/feature-settings"
    | "/settings/assist/follow-up-appointment-reminder"
    | "/settings/assist/rescued-appointment-overview"
    | "/settings/assist/secretary-details"
    | "/settings/assist/subscribe-assist-pro-legacy"
    | "/settings/assist/subscribe-assist-pro"
    | "/settings/assist/subscribed-assist"
    | "/settings/assist/tasks"
    | "/settings/assist/unsubscribe-assist-pro"
    | "/settings/assist/user-trackable-links"
    | "/settings/billing/details"
    | "/settings/blog/$userPostId"
    | "/settings/payments/bank-account"
    | "/settings/payments/create-recipient"
    | "/settings/payments/create"
    | "/settings/payments/evolution-charts"
    | "/settings/payments/patient-payments"
    | "/settings/payments/payables"
    | "/settings/payments/terms-of-service"
    | "/settings/professional-site/about"
    | "/settings/profile/card"
    | "/settings/profile/personal-data"
    | "/settings/profile/plan"
    | "/settings/profile/professional-data"
    | "/settings/profile/upsert-public-phone"
    | "/settings/profile/vehicles"
    | "/settings/reserved-schedules/$reservedScheduleId"
    | "/settings/reserved-schedules/create"
    | "/settings/schedule-options/appointment-receiving-options"
    | "/settings/schedule-options/appointment-types"
    | "/settings/schedule-options/preferred-rooms"
    | "/settings/schedule-options/schedules"
    | "/settings/schedule-options/service-preferences"
    | "/waiting-room/$codAgendamento/change-time"
    | "/waiting-room/$codAgendamento/choose-payment-channel"
    | "/waiting-room/$codAgendamento/menu"
    | "/waiting-room/$codAgendamento/receive-room-now"
    | "/waiting-room/$codAgendamento/send-totem-payment"
    | "/settings/billing/details/$billingId/boleto"
    | "/settings/billing/details/$billingId/pix"
    | "/settings/payments/patient-payments/$guid/change-online-payment-status"
    | "/settings/payments/patient-payments/filters/filter-origins"
    | "/settings/payments/patient-payments/filters/filter-payment-methods"
    | "/settings/payments/patient-payments/filters/filter-status"
    | "/settings/profile/professional-data/edit/professional-data"
    | "/settings/profile/professional-data/edit/professional-data-contact-information"
    | "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel"
    | "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config"
    | "/settings/schedule-options/appointment-receiving-options/create/advanced-config"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info"
    | "/settings/schedule-options/appointment-types/create/advanced-config"
    | "/settings/schedule-options/appointment-types/create/confirm"
    | "/settings/schedule-options/appointment-types/create/patient-info"
    | "/settings/schedule-options/appointment-types/create/review"
    | "/settings/schedule-options/appointment-types/create/room-type"
    | "/settings/schedule-options/appointment-types/create/secretary-info"
    | "/settings/schedule-options/service-preferences/edit/general-preferences"
    | "/settings/schedule-options/service-preferences/edit/patient-preferences"
    | "/settings/assist/contacts-history/$contactId"
    | "/settings/assist/contacts-history/about"
    | "/settings/assist/contacts-history/essential"
    | "/settings/assist/contacts-history/trial-period"
    | "/settings/assist/customer-contact-overview/stories-feed"
    | "/settings/assist/follow-up-appointment-reminder/patients"
    | "/settings/assist/subscribe-assist-pro/confirm"
    | "/settings/assist/tasks/$taskId"
    | "/settings/assist/unsubscribe-assist-pro/upsert-phone"
    | "/settings/assist/user-trackable-links/$userTrackableLinkId"
    | "/settings/assist/user-trackable-links/create"
    | "/settings/billing/details/$billingId"
    | "/settings/profile/plan/cancel-subscription"
    | "/settings/profile/plan/change"
    | "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId"
    | "/settings/schedule-options/appointment-receiving-options/create"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId"
    | "/settings/schedule-options/appointment-types/create"
    | "/waiting-room/$codAgendamento/change-time/confirm"
    | "/settings/assist/contacts-history/trial-period/$contactId"
    | "/settings/assist/user-trackable-links/$userTrackableLinkId/report"
    | "/settings/billing/details/paymentBillingGroup/$billingIdGroup";
  id:
    | "__root__"
    | "/"
    | "/add-payment-card/create"
    | "/add-payment-card/success"
    | "/auth/callback"
    | "/auth/idp-callback"
    | "/auth/landing"
    | "/auth/login"
    | "/auth/logout"
    | "/auth/oauth-callback"
    | "/auth/signin"
    | "/extend-time/$appointmentId"
    | "/flows/$stepId"
    | "/google/callback"
    | "/oneliv/additional-info"
    | "/oneliv/basic-info"
    | "/oneliv/educational-background"
    | "/oneliv/experiences"
    | "/oneliv/faq"
    | "/oneliv/medical-institutions"
    | "/oneliv/social-media"
    | "/oneliv/treatment-focus"
    | "/oneliv/use-terms"
    | "/oneliv/welcome"
    | "/recurring-appointments/$codAgendamentoRecorrente"
    | "/settings/assist"
    | "/access-blocked/"
    | "/add-payment-card/"
    | "/caf-documents-blocked/"
    | "/calendar/"
    | "/custom-website/"
    | "/flows/"
    | "/general-terms/"
    | "/home/"
    | "/locations/"
    | "/patients/"
    | "/recommendation/"
    | "/recurring-appointments/"
    | "/settings/"
    | "/update-required/"
    | "/waiting-room/"
    | "/appointment/$appointmentId/cancel-recurrence"
    | "/appointment/$appointmentId/flexible-pricing"
    | "/appointment/$appointmentId/patient-swap"
    | "/appointment/$appointmentId/patient-swap-recurrence"
    | "/appointment/$appointmentId/patient-swap-search"
    | "/appointment/$appointmentId/reschedule"
    | "/appointment/$appointmentId/reschedule-patient"
    | "/appointment/$appointmentId/reschedule-recurrence"
    | "/appointment/create/available-options"
    | "/appointment/create/flexible-pricing"
    | "/appointment/create/patient"
    | "/appointment/create/search-patient"
    | "/auth/first-access/complete"
    | "/auth/first-access/define-password"
    | "/auth/first-access/document"
    | "/auth/first-access/document-not-found"
    | "/auth/first-access/verify-email"
    | "/auth/oauth/authorize"
    | "/auth/password-reset/check-email"
    | "/auth/password-reset/create-password"
    | "/auth/password-reset/forgot-password"
    | "/auth/password-reset/password-changed"
    | "/calendar/batch-adjust/cancel"
    | "/calendar/batch-adjust/minutes"
    | "/calendar/batch-adjust/review"
    | "/calendar/batch-adjust/success"
    | "/calendar/unavailable-slots/create"
    | "/custom-website/confirmation/error"
    | "/flows/$stepId/$subStepId"
    | "/flows/complete/$flowId"
    | "/home/notification-center/about"
    | "/onboarding/consulting/acquisition"
    | "/onboarding/consulting/career-problem"
    | "/onboarding/consulting/channels"
    | "/onboarding/consulting/expectation"
    | "/onboarding/consulting/intro"
    | "/onboarding/consulting/success"
    | "/onboarding/first-schedule/first-appointment"
    | "/onboarding/first-schedule/follow-up"
    | "/onboarding/first-schedule/follow-up-days"
    | "/onboarding/first-schedule/intro"
    | "/onboarding/first-schedule/preview"
    | "/onboarding/first-schedule/schedule"
    | "/onboarding/first-schedule/success"
    | "/onboarding/welcome-meeting/details"
    | "/onboarding/welcome-meeting/dismissed"
    | "/onboarding/welcome-meeting/format"
    | "/onboarding/welcome-meeting/location"
    | "/onboarding/welcome-meeting/schedule"
    | "/onboarding/welcome-meeting/skip-reason"
    | "/onboarding/welcome-meeting/success"
    | "/patients/$patientId/update"
    | "/recurring-appointments/create/availability"
    | "/recurring-appointments/create/patient"
    | "/recurring-appointments/create/review"
    | "/recurring-appointments/create/search-patient"
    | "/recurring-appointments/create/success"
    | "/recurring-appointments/extend/$recurringAppointmentId"
    | "/recurring-appointments/extend/success"
    | "/recurring-appointments/reschedule/availability"
    | "/recurring-appointments/reschedule/review"
    | "/settings/billing/$billingItemId"
    | "/settings/billing/about"
    | "/settings/blog/create"
    | "/settings/payments/welcome"
    | "/settings/referral/about"
    | "/settings/regulatory-documents/confirmation"
    | "/settings/regulatory-documents/declaration-locations"
    | "/settings/regulatory-documents/download"
    | "/settings/regulatory-documents/locations"
    | "/settings/regulatory-documents/reason"
    | "/settings/regulatory-documents/requests"
    | "/settings/regulatory-documents/review"
    | "/settings/regulatory-documents/state"
    | "/waiting-room/follow-up-appointment-reminder/$appointmentId"
    | "/appointment/create/"
    | "/calendar/batch-adjust/"
    | "/custom-website/confirmation/"
    | "/custom-website/form/"
    | "/home/all-features/"
    | "/home/notification-center/"
    | "/locations/$locationId/"
    | "/onboarding/first-schedule/"
    | "/onboarding/welcome-meeting/"
    | "/patients/$patientId/"
    | "/recommendation/confirmation/"
    | "/recurring-appointments/create/"
    | "/settings/assist/"
    | "/settings/billing/"
    | "/settings/blog/"
    | "/settings/community/"
    | "/settings/google-calendar/"
    | "/settings/payments/"
    | "/settings/professional-site/"
    | "/settings/profile/"
    | "/settings/referral/"
    | "/settings/regulatory-documents/"
    | "/settings/reserved-schedules/"
    | "/settings/schedule-options/"
    | "/home/info/$infoItemId/confirmation"
    | "/settings/assist/secretary-details/appointment-infos"
    | "/settings/assist/secretary-details/faq"
    | "/settings/assist/secretary-details/professional-infos"
    | "/settings/assist/secretary-details/restrictions"
    | "/settings/blog/$userPostId/edit"
    | "/settings/payments/bank-account/change-bank-account-or-ownership"
    | "/settings/payments/bank-account/update"
    | "/settings/payments/create-recipient/add-bank-account"
    | "/settings/payments/create-recipient/check-cnpj"
    | "/settings/payments/create-recipient/choose-holder-type"
    | "/settings/payments/create-recipient/confirm-bank-account"
    | "/settings/payments/create-recipient/confirm-document"
    | "/settings/payments/create-recipient/status"
    | "/settings/payments/create-recipient/validate-data"
    | "/settings/payments/create/confirmation"
    | "/settings/payments/patient-payments/about-payment-anticipation"
    | "/settings/payments/patient-payments/about-payment-details"
    | "/settings/payments/patient-payments/about-payments"
    | "/settings/payments/patient-payments/details"
    | "/settings/payments/patient-payments/payment-receipt"
    | "/settings/payments/patient-payments/refund"
    | "/settings/payments/patient-payments/refund-receipt"
    | "/settings/payments/payables/about"
    | "/settings/profile/card/create"
    | "/settings/profile/personal-data/edit"
    | "/settings/profile/personal-data/edit-address"
    | "/settings/profile/vehicles/$vehicleId"
    | "/settings/profile/vehicles/create"
    | "/settings/reserved-schedules/$reservedScheduleId/cancel"
    | "/settings/reserved-schedules/create/confirm"
    | "/settings/reserved-schedules/create/linked-schedule"
    | "/settings/reserved-schedules/create/slots"
    | "/settings/reserved-schedules/create/starting-day"
    | "/settings/schedule-options/preferred-rooms/$unitId"
    | "/settings/schedule-options/schedules/$scheduleId"
    | "/settings/schedule-options/schedules/create"
    | "/waiting-room/follow-up-appointment-reminder/patient/$patientId"
    | "/home/info/$infoItemId/"
    | "/home/notification-center/$id/"
    | "/settings/assist/assist-pro-acceptance/"
    | "/settings/assist/contacts-history/"
    | "/settings/assist/customer-appointment-overview/"
    | "/settings/assist/customer-contact-overview/"
    | "/settings/assist/customer-site-overview/"
    | "/settings/assist/feature-settings/"
    | "/settings/assist/follow-up-appointment-reminder/"
    | "/settings/assist/rescued-appointment-overview/"
    | "/settings/assist/secretary-details/"
    | "/settings/assist/subscribe-assist-pro-legacy/"
    | "/settings/assist/subscribe-assist-pro/"
    | "/settings/assist/subscribed-assist/"
    | "/settings/assist/tasks/"
    | "/settings/assist/unsubscribe-assist-pro/"
    | "/settings/assist/user-trackable-links/"
    | "/settings/billing/details/"
    | "/settings/blog/$userPostId/"
    | "/settings/payments/bank-account/"
    | "/settings/payments/create-recipient/"
    | "/settings/payments/create/"
    | "/settings/payments/evolution-charts/"
    | "/settings/payments/patient-payments/"
    | "/settings/payments/payables/"
    | "/settings/payments/terms-of-service/"
    | "/settings/professional-site/about/"
    | "/settings/profile/card/"
    | "/settings/profile/personal-data/"
    | "/settings/profile/plan/"
    | "/settings/profile/professional-data/"
    | "/settings/profile/upsert-public-phone/"
    | "/settings/profile/vehicles/"
    | "/settings/reserved-schedules/$reservedScheduleId/"
    | "/settings/reserved-schedules/create/"
    | "/settings/schedule-options/appointment-receiving-options/"
    | "/settings/schedule-options/appointment-types/"
    | "/settings/schedule-options/preferred-rooms/"
    | "/settings/schedule-options/schedules/"
    | "/settings/schedule-options/service-preferences/"
    | "/waiting-room/$codAgendamento/change-time/"
    | "/waiting-room/$codAgendamento/choose-payment-channel/"
    | "/waiting-room/$codAgendamento/menu/"
    | "/waiting-room/$codAgendamento/receive-room-now/"
    | "/waiting-room/$codAgendamento/send-totem-payment/"
    | "/settings/billing/details/$billingId/boleto"
    | "/settings/billing/details/$billingId/pix"
    | "/settings/payments/patient-payments/$guid/change-online-payment-status"
    | "/settings/payments/patient-payments/filters/filter-origins"
    | "/settings/payments/patient-payments/filters/filter-payment-methods"
    | "/settings/payments/patient-payments/filters/filter-status"
    | "/settings/profile/professional-data/edit/professional-data"
    | "/settings/profile/professional-data/edit/professional-data-contact-information"
    | "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel"
    | "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config"
    | "/settings/schedule-options/appointment-receiving-options/create/advanced-config"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info"
    | "/settings/schedule-options/appointment-types/create/advanced-config"
    | "/settings/schedule-options/appointment-types/create/confirm"
    | "/settings/schedule-options/appointment-types/create/patient-info"
    | "/settings/schedule-options/appointment-types/create/review"
    | "/settings/schedule-options/appointment-types/create/room-type"
    | "/settings/schedule-options/appointment-types/create/secretary-info"
    | "/settings/schedule-options/service-preferences/edit/general-preferences"
    | "/settings/schedule-options/service-preferences/edit/patient-preferences"
    | "/settings/assist/contacts-history/$contactId/"
    | "/settings/assist/contacts-history/about/"
    | "/settings/assist/contacts-history/essential/"
    | "/settings/assist/contacts-history/trial-period/"
    | "/settings/assist/customer-contact-overview/stories-feed/"
    | "/settings/assist/follow-up-appointment-reminder/patients/"
    | "/settings/assist/subscribe-assist-pro/confirm/"
    | "/settings/assist/tasks/$taskId/"
    | "/settings/assist/unsubscribe-assist-pro/upsert-phone/"
    | "/settings/assist/user-trackable-links/$userTrackableLinkId/"
    | "/settings/assist/user-trackable-links/create/"
    | "/settings/billing/details/$billingId/"
    | "/settings/profile/plan/cancel-subscription/"
    | "/settings/profile/plan/change/"
    | "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/"
    | "/settings/schedule-options/appointment-receiving-options/create/"
    | "/settings/schedule-options/appointment-types/$appointmentTypeId/"
    | "/settings/schedule-options/appointment-types/create/"
    | "/waiting-room/$codAgendamento/change-time/confirm/"
    | "/settings/assist/contacts-history/trial-period/$contactId/"
    | "/settings/assist/user-trackable-links/$userTrackableLinkId/report/"
    | "/settings/billing/details/paymentBillingGroup/$billingIdGroup/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AddPaymentCardCreateRoute: typeof AddPaymentCardCreateRoute;
  AddPaymentCardSuccessRoute: typeof AddPaymentCardSuccessRoute;
  AuthCallbackRoute: typeof AuthCallbackRoute;
  AuthIdpCallbackRoute: typeof AuthIdpCallbackRoute;
  AuthLandingRoute: typeof AuthLandingRoute;
  AuthLoginRoute: typeof AuthLoginRoute;
  AuthLogoutRoute: typeof AuthLogoutRoute;
  AuthOauthCallbackRoute: typeof AuthOauthCallbackRoute;
  AuthSigninRoute: typeof AuthSigninRoute;
  ExtendTimeAppointmentIdRoute: typeof ExtendTimeAppointmentIdRoute;
  FlowsStepIdRoute: typeof FlowsStepIdRouteWithChildren;
  GoogleCallbackRoute: typeof GoogleCallbackRoute;
  OnelivAdditionalInfoRoute: typeof OnelivAdditionalInfoRoute;
  OnelivBasicInfoRoute: typeof OnelivBasicInfoRoute;
  OnelivEducationalBackgroundRoute: typeof OnelivEducationalBackgroundRoute;
  OnelivExperiencesRoute: typeof OnelivExperiencesRoute;
  OnelivFaqRoute: typeof OnelivFaqRoute;
  OnelivMedicalInstitutionsRoute: typeof OnelivMedicalInstitutionsRoute;
  OnelivSocialMediaRoute: typeof OnelivSocialMediaRoute;
  OnelivTreatmentFocusRoute: typeof OnelivTreatmentFocusRoute;
  OnelivUseTermsRoute: typeof OnelivUseTermsRoute;
  OnelivWelcomeRoute: typeof OnelivWelcomeRoute;
  RecurringAppointmentsCodAgendamentoRecorrenteRoute: typeof RecurringAppointmentsCodAgendamentoRecorrenteRoute;
  SettingsAssistRoute: typeof SettingsAssistRouteWithChildren;
  AccessBlockedIndexRoute: typeof AccessBlockedIndexRoute;
  AddPaymentCardIndexRoute: typeof AddPaymentCardIndexRoute;
  CafDocumentsBlockedIndexRoute: typeof CafDocumentsBlockedIndexRoute;
  CalendarIndexRoute: typeof CalendarIndexRoute;
  CustomWebsiteIndexRoute: typeof CustomWebsiteIndexRoute;
  FlowsIndexRoute: typeof FlowsIndexRoute;
  GeneralTermsIndexRoute: typeof GeneralTermsIndexRoute;
  HomeIndexRoute: typeof HomeIndexRoute;
  LocationsIndexRoute: typeof LocationsIndexRoute;
  PatientsIndexRoute: typeof PatientsIndexRoute;
  RecommendationIndexRoute: typeof RecommendationIndexRoute;
  RecurringAppointmentsIndexRoute: typeof RecurringAppointmentsIndexRoute;
  SettingsIndexRoute: typeof SettingsIndexRoute;
  UpdateRequiredIndexRoute: typeof UpdateRequiredIndexRoute;
  WaitingRoomIndexRoute: typeof WaitingRoomIndexRoute;
  AppointmentAppointmentIdCancelRecurrenceRoute: typeof AppointmentAppointmentIdCancelRecurrenceRoute;
  AppointmentAppointmentIdFlexiblePricingRoute: typeof AppointmentAppointmentIdFlexiblePricingRoute;
  AppointmentAppointmentIdPatientSwapRoute: typeof AppointmentAppointmentIdPatientSwapRoute;
  AppointmentAppointmentIdPatientSwapRecurrenceRoute: typeof AppointmentAppointmentIdPatientSwapRecurrenceRoute;
  AppointmentAppointmentIdPatientSwapSearchRoute: typeof AppointmentAppointmentIdPatientSwapSearchRoute;
  AppointmentAppointmentIdRescheduleRoute: typeof AppointmentAppointmentIdRescheduleRoute;
  AppointmentAppointmentIdReschedulePatientRoute: typeof AppointmentAppointmentIdReschedulePatientRoute;
  AppointmentAppointmentIdRescheduleRecurrenceRoute: typeof AppointmentAppointmentIdRescheduleRecurrenceRoute;
  AppointmentCreateAvailableOptionsRoute: typeof AppointmentCreateAvailableOptionsRoute;
  AppointmentCreateFlexiblePricingRoute: typeof AppointmentCreateFlexiblePricingRoute;
  AppointmentCreatePatientRoute: typeof AppointmentCreatePatientRoute;
  AppointmentCreateSearchPatientRoute: typeof AppointmentCreateSearchPatientRoute;
  AuthFirstAccessCompleteRoute: typeof AuthFirstAccessCompleteRoute;
  AuthFirstAccessDefinePasswordRoute: typeof AuthFirstAccessDefinePasswordRoute;
  AuthFirstAccessDocumentRoute: typeof AuthFirstAccessDocumentRoute;
  AuthFirstAccessDocumentNotFoundRoute: typeof AuthFirstAccessDocumentNotFoundRoute;
  AuthFirstAccessVerifyEmailRoute: typeof AuthFirstAccessVerifyEmailRoute;
  AuthOauthAuthorizeRoute: typeof AuthOauthAuthorizeRoute;
  AuthPasswordResetCheckEmailRoute: typeof AuthPasswordResetCheckEmailRoute;
  AuthPasswordResetCreatePasswordRoute: typeof AuthPasswordResetCreatePasswordRoute;
  AuthPasswordResetForgotPasswordRoute: typeof AuthPasswordResetForgotPasswordRoute;
  AuthPasswordResetPasswordChangedRoute: typeof AuthPasswordResetPasswordChangedRoute;
  CalendarBatchAdjustCancelRoute: typeof CalendarBatchAdjustCancelRoute;
  CalendarBatchAdjustMinutesRoute: typeof CalendarBatchAdjustMinutesRoute;
  CalendarBatchAdjustReviewRoute: typeof CalendarBatchAdjustReviewRoute;
  CalendarBatchAdjustSuccessRoute: typeof CalendarBatchAdjustSuccessRoute;
  CalendarUnavailableSlotsCreateRoute: typeof CalendarUnavailableSlotsCreateRoute;
  CustomWebsiteConfirmationErrorRoute: typeof CustomWebsiteConfirmationErrorRoute;
  FlowsCompleteFlowIdRoute: typeof FlowsCompleteFlowIdRoute;
  HomeNotificationCenterAboutRoute: typeof HomeNotificationCenterAboutRoute;
  OnboardingConsultingAcquisitionRoute: typeof OnboardingConsultingAcquisitionRoute;
  OnboardingConsultingCareerProblemRoute: typeof OnboardingConsultingCareerProblemRoute;
  OnboardingConsultingChannelsRoute: typeof OnboardingConsultingChannelsRoute;
  OnboardingConsultingExpectationRoute: typeof OnboardingConsultingExpectationRoute;
  OnboardingConsultingIntroRoute: typeof OnboardingConsultingIntroRoute;
  OnboardingConsultingSuccessRoute: typeof OnboardingConsultingSuccessRoute;
  OnboardingFirstScheduleFirstAppointmentRoute: typeof OnboardingFirstScheduleFirstAppointmentRoute;
  OnboardingFirstScheduleFollowUpRoute: typeof OnboardingFirstScheduleFollowUpRoute;
  OnboardingFirstScheduleFollowUpDaysRoute: typeof OnboardingFirstScheduleFollowUpDaysRoute;
  OnboardingFirstScheduleIntroRoute: typeof OnboardingFirstScheduleIntroRoute;
  OnboardingFirstSchedulePreviewRoute: typeof OnboardingFirstSchedulePreviewRoute;
  OnboardingFirstScheduleScheduleRoute: typeof OnboardingFirstScheduleScheduleRoute;
  OnboardingFirstScheduleSuccessRoute: typeof OnboardingFirstScheduleSuccessRoute;
  OnboardingWelcomeMeetingDetailsRoute: typeof OnboardingWelcomeMeetingDetailsRoute;
  OnboardingWelcomeMeetingDismissedRoute: typeof OnboardingWelcomeMeetingDismissedRoute;
  OnboardingWelcomeMeetingFormatRoute: typeof OnboardingWelcomeMeetingFormatRoute;
  OnboardingWelcomeMeetingLocationRoute: typeof OnboardingWelcomeMeetingLocationRoute;
  OnboardingWelcomeMeetingScheduleRoute: typeof OnboardingWelcomeMeetingScheduleRoute;
  OnboardingWelcomeMeetingSkipReasonRoute: typeof OnboardingWelcomeMeetingSkipReasonRoute;
  OnboardingWelcomeMeetingSuccessRoute: typeof OnboardingWelcomeMeetingSuccessRoute;
  PatientsPatientIdUpdateRoute: typeof PatientsPatientIdUpdateRoute;
  RecurringAppointmentsCreateAvailabilityRoute: typeof RecurringAppointmentsCreateAvailabilityRoute;
  RecurringAppointmentsCreatePatientRoute: typeof RecurringAppointmentsCreatePatientRoute;
  RecurringAppointmentsCreateReviewRoute: typeof RecurringAppointmentsCreateReviewRoute;
  RecurringAppointmentsCreateSearchPatientRoute: typeof RecurringAppointmentsCreateSearchPatientRoute;
  RecurringAppointmentsCreateSuccessRoute: typeof RecurringAppointmentsCreateSuccessRoute;
  RecurringAppointmentsExtendRecurringAppointmentIdRoute: typeof RecurringAppointmentsExtendRecurringAppointmentIdRoute;
  RecurringAppointmentsExtendSuccessRoute: typeof RecurringAppointmentsExtendSuccessRoute;
  RecurringAppointmentsRescheduleAvailabilityRoute: typeof RecurringAppointmentsRescheduleAvailabilityRoute;
  RecurringAppointmentsRescheduleReviewRoute: typeof RecurringAppointmentsRescheduleReviewRoute;
  SettingsBillingBillingItemIdRoute: typeof SettingsBillingBillingItemIdRoute;
  SettingsBillingAboutRoute: typeof SettingsBillingAboutRoute;
  SettingsBlogCreateRoute: typeof SettingsBlogCreateRoute;
  SettingsPaymentsWelcomeRoute: typeof SettingsPaymentsWelcomeRoute;
  SettingsReferralAboutRoute: typeof SettingsReferralAboutRoute;
  SettingsRegulatoryDocumentsConfirmationRoute: typeof SettingsRegulatoryDocumentsConfirmationRoute;
  SettingsRegulatoryDocumentsDeclarationLocationsRoute: typeof SettingsRegulatoryDocumentsDeclarationLocationsRoute;
  SettingsRegulatoryDocumentsDownloadRoute: typeof SettingsRegulatoryDocumentsDownloadRoute;
  SettingsRegulatoryDocumentsLocationsRoute: typeof SettingsRegulatoryDocumentsLocationsRoute;
  SettingsRegulatoryDocumentsReasonRoute: typeof SettingsRegulatoryDocumentsReasonRoute;
  SettingsRegulatoryDocumentsRequestsRoute: typeof SettingsRegulatoryDocumentsRequestsRoute;
  SettingsRegulatoryDocumentsReviewRoute: typeof SettingsRegulatoryDocumentsReviewRoute;
  SettingsRegulatoryDocumentsStateRoute: typeof SettingsRegulatoryDocumentsStateRoute;
  WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute: typeof WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute;
  AppointmentCreateIndexRoute: typeof AppointmentCreateIndexRoute;
  CalendarBatchAdjustIndexRoute: typeof CalendarBatchAdjustIndexRoute;
  CustomWebsiteConfirmationIndexRoute: typeof CustomWebsiteConfirmationIndexRoute;
  CustomWebsiteFormIndexRoute: typeof CustomWebsiteFormIndexRoute;
  HomeAllFeaturesIndexRoute: typeof HomeAllFeaturesIndexRoute;
  HomeNotificationCenterIndexRoute: typeof HomeNotificationCenterIndexRoute;
  LocationsLocationIdIndexRoute: typeof LocationsLocationIdIndexRoute;
  OnboardingFirstScheduleIndexRoute: typeof OnboardingFirstScheduleIndexRoute;
  OnboardingWelcomeMeetingIndexRoute: typeof OnboardingWelcomeMeetingIndexRoute;
  PatientsPatientIdIndexRoute: typeof PatientsPatientIdIndexRoute;
  RecommendationConfirmationIndexRoute: typeof RecommendationConfirmationIndexRoute;
  RecurringAppointmentsCreateIndexRoute: typeof RecurringAppointmentsCreateIndexRoute;
  SettingsBillingIndexRoute: typeof SettingsBillingIndexRoute;
  SettingsBlogIndexRoute: typeof SettingsBlogIndexRoute;
  SettingsCommunityIndexRoute: typeof SettingsCommunityIndexRoute;
  SettingsGoogleCalendarIndexRoute: typeof SettingsGoogleCalendarIndexRoute;
  SettingsPaymentsIndexRoute: typeof SettingsPaymentsIndexRoute;
  SettingsProfessionalSiteIndexRoute: typeof SettingsProfessionalSiteIndexRoute;
  SettingsProfileIndexRoute: typeof SettingsProfileIndexRoute;
  SettingsReferralIndexRoute: typeof SettingsReferralIndexRoute;
  SettingsRegulatoryDocumentsIndexRoute: typeof SettingsRegulatoryDocumentsIndexRoute;
  SettingsReservedSchedulesIndexRoute: typeof SettingsReservedSchedulesIndexRoute;
  SettingsScheduleOptionsIndexRoute: typeof SettingsScheduleOptionsIndexRoute;
  HomeInfoInfoItemIdConfirmationRoute: typeof HomeInfoInfoItemIdConfirmationRoute;
  SettingsBlogUserPostIdEditRoute: typeof SettingsBlogUserPostIdEditRoute;
  SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute: typeof SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute;
  SettingsPaymentsBankAccountUpdateRoute: typeof SettingsPaymentsBankAccountUpdateRoute;
  SettingsPaymentsCreateRecipientAddBankAccountRoute: typeof SettingsPaymentsCreateRecipientAddBankAccountRoute;
  SettingsPaymentsCreateRecipientCheckCnpjRoute: typeof SettingsPaymentsCreateRecipientCheckCnpjRoute;
  SettingsPaymentsCreateRecipientChooseHolderTypeRoute: typeof SettingsPaymentsCreateRecipientChooseHolderTypeRoute;
  SettingsPaymentsCreateRecipientConfirmBankAccountRoute: typeof SettingsPaymentsCreateRecipientConfirmBankAccountRoute;
  SettingsPaymentsCreateRecipientConfirmDocumentRoute: typeof SettingsPaymentsCreateRecipientConfirmDocumentRoute;
  SettingsPaymentsCreateRecipientStatusRoute: typeof SettingsPaymentsCreateRecipientStatusRoute;
  SettingsPaymentsCreateRecipientValidateDataRoute: typeof SettingsPaymentsCreateRecipientValidateDataRoute;
  SettingsPaymentsCreateConfirmationRoute: typeof SettingsPaymentsCreateConfirmationRoute;
  SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute;
  SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute;
  SettingsPaymentsPatientPaymentsAboutPaymentsRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentsRoute;
  SettingsPaymentsPatientPaymentsDetailsRoute: typeof SettingsPaymentsPatientPaymentsDetailsRoute;
  SettingsPaymentsPatientPaymentsPaymentReceiptRoute: typeof SettingsPaymentsPatientPaymentsPaymentReceiptRoute;
  SettingsPaymentsPatientPaymentsRefundRoute: typeof SettingsPaymentsPatientPaymentsRefundRoute;
  SettingsPaymentsPatientPaymentsRefundReceiptRoute: typeof SettingsPaymentsPatientPaymentsRefundReceiptRoute;
  SettingsPaymentsPayablesAboutRoute: typeof SettingsPaymentsPayablesAboutRoute;
  SettingsProfileCardCreateRoute: typeof SettingsProfileCardCreateRoute;
  SettingsProfilePersonalDataEditRoute: typeof SettingsProfilePersonalDataEditRoute;
  SettingsProfilePersonalDataEditAddressRoute: typeof SettingsProfilePersonalDataEditAddressRoute;
  SettingsProfileVehiclesVehicleIdRoute: typeof SettingsProfileVehiclesVehicleIdRoute;
  SettingsProfileVehiclesCreateRoute: typeof SettingsProfileVehiclesCreateRoute;
  SettingsReservedSchedulesReservedScheduleIdCancelRoute: typeof SettingsReservedSchedulesReservedScheduleIdCancelRoute;
  SettingsReservedSchedulesCreateConfirmRoute: typeof SettingsReservedSchedulesCreateConfirmRoute;
  SettingsReservedSchedulesCreateLinkedScheduleRoute: typeof SettingsReservedSchedulesCreateLinkedScheduleRoute;
  SettingsReservedSchedulesCreateSlotsRoute: typeof SettingsReservedSchedulesCreateSlotsRoute;
  SettingsReservedSchedulesCreateStartingDayRoute: typeof SettingsReservedSchedulesCreateStartingDayRoute;
  SettingsScheduleOptionsPreferredRoomsUnitIdRoute: typeof SettingsScheduleOptionsPreferredRoomsUnitIdRoute;
  SettingsScheduleOptionsSchedulesScheduleIdRoute: typeof SettingsScheduleOptionsSchedulesScheduleIdRoute;
  SettingsScheduleOptionsSchedulesCreateRoute: typeof SettingsScheduleOptionsSchedulesCreateRoute;
  WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute: typeof WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute;
  HomeInfoInfoItemIdIndexRoute: typeof HomeInfoInfoItemIdIndexRoute;
  HomeNotificationCenterIdIndexRoute: typeof HomeNotificationCenterIdIndexRoute;
  SettingsBillingDetailsIndexRoute: typeof SettingsBillingDetailsIndexRoute;
  SettingsBlogUserPostIdIndexRoute: typeof SettingsBlogUserPostIdIndexRoute;
  SettingsPaymentsBankAccountIndexRoute: typeof SettingsPaymentsBankAccountIndexRoute;
  SettingsPaymentsCreateRecipientIndexRoute: typeof SettingsPaymentsCreateRecipientIndexRoute;
  SettingsPaymentsCreateIndexRoute: typeof SettingsPaymentsCreateIndexRoute;
  SettingsPaymentsEvolutionChartsIndexRoute: typeof SettingsPaymentsEvolutionChartsIndexRoute;
  SettingsPaymentsPatientPaymentsIndexRoute: typeof SettingsPaymentsPatientPaymentsIndexRoute;
  SettingsPaymentsPayablesIndexRoute: typeof SettingsPaymentsPayablesIndexRoute;
  SettingsPaymentsTermsOfServiceIndexRoute: typeof SettingsPaymentsTermsOfServiceIndexRoute;
  SettingsProfessionalSiteAboutIndexRoute: typeof SettingsProfessionalSiteAboutIndexRoute;
  SettingsProfileCardIndexRoute: typeof SettingsProfileCardIndexRoute;
  SettingsProfilePersonalDataIndexRoute: typeof SettingsProfilePersonalDataIndexRoute;
  SettingsProfilePlanIndexRoute: typeof SettingsProfilePlanIndexRoute;
  SettingsProfileProfessionalDataIndexRoute: typeof SettingsProfileProfessionalDataIndexRoute;
  SettingsProfileUpsertPublicPhoneIndexRoute: typeof SettingsProfileUpsertPublicPhoneIndexRoute;
  SettingsProfileVehiclesIndexRoute: typeof SettingsProfileVehiclesIndexRoute;
  SettingsReservedSchedulesReservedScheduleIdIndexRoute: typeof SettingsReservedSchedulesReservedScheduleIdIndexRoute;
  SettingsReservedSchedulesCreateIndexRoute: typeof SettingsReservedSchedulesCreateIndexRoute;
  SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute;
  SettingsScheduleOptionsAppointmentTypesIndexRoute: typeof SettingsScheduleOptionsAppointmentTypesIndexRoute;
  SettingsScheduleOptionsPreferredRoomsIndexRoute: typeof SettingsScheduleOptionsPreferredRoomsIndexRoute;
  SettingsScheduleOptionsSchedulesIndexRoute: typeof SettingsScheduleOptionsSchedulesIndexRoute;
  SettingsScheduleOptionsServicePreferencesIndexRoute: typeof SettingsScheduleOptionsServicePreferencesIndexRoute;
  WaitingRoomCodAgendamentoChangeTimeIndexRoute: typeof WaitingRoomCodAgendamentoChangeTimeIndexRoute;
  WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute: typeof WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute;
  WaitingRoomCodAgendamentoMenuIndexRoute: typeof WaitingRoomCodAgendamentoMenuIndexRoute;
  WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute: typeof WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute;
  WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute: typeof WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute;
  SettingsBillingDetailsBillingIdBoletoRoute: typeof SettingsBillingDetailsBillingIdBoletoRoute;
  SettingsBillingDetailsBillingIdPixRoute: typeof SettingsBillingDetailsBillingIdPixRoute;
  SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute: typeof SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute;
  SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute;
  SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute;
  SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute;
  SettingsProfileProfessionalDataEditProfessionalDataRoute: typeof SettingsProfileProfessionalDataEditProfessionalDataRoute;
  SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute: typeof SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute;
  SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute: typeof SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute;
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute;
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute;
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute;
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute;
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute;
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute;
  SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute;
  SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute;
  SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute: typeof SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute;
  SettingsScheduleOptionsAppointmentTypesCreateReviewRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateReviewRoute;
  SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute;
  SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute;
  SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute: typeof SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute;
  SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute: typeof SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute;
  SettingsBillingDetailsBillingIdIndexRoute: typeof SettingsBillingDetailsBillingIdIndexRoute;
  SettingsProfilePlanCancelSubscriptionIndexRoute: typeof SettingsProfilePlanCancelSubscriptionIndexRoute;
  SettingsProfilePlanChangeIndexRoute: typeof SettingsProfilePlanChangeIndexRoute;
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute;
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute;
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute;
  SettingsScheduleOptionsAppointmentTypesCreateIndexRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateIndexRoute;
  WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute: typeof WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute;
  SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute: typeof SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/access-blocked/": {
      id: "/access-blocked/";
      path: "/access-blocked";
      fullPath: "/access-blocked/";
      preLoaderRoute: typeof AccessBlockedIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/add-payment-card/": {
      id: "/add-payment-card/";
      path: "/add-payment-card";
      fullPath: "/add-payment-card/";
      preLoaderRoute: typeof AddPaymentCardIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/add-payment-card/create": {
      id: "/add-payment-card/create";
      path: "/add-payment-card/create";
      fullPath: "/add-payment-card/create";
      preLoaderRoute: typeof AddPaymentCardCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/add-payment-card/success": {
      id: "/add-payment-card/success";
      path: "/add-payment-card/success";
      fullPath: "/add-payment-card/success";
      preLoaderRoute: typeof AddPaymentCardSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/callback": {
      id: "/auth/callback";
      path: "/auth/callback";
      fullPath: "/auth/callback";
      preLoaderRoute: typeof AuthCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/idp-callback": {
      id: "/auth/idp-callback";
      path: "/auth/idp-callback";
      fullPath: "/auth/idp-callback";
      preLoaderRoute: typeof AuthIdpCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/landing": {
      id: "/auth/landing";
      path: "/auth/landing";
      fullPath: "/auth/landing";
      preLoaderRoute: typeof AuthLandingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/login": {
      id: "/auth/login";
      path: "/auth/login";
      fullPath: "/auth/login";
      preLoaderRoute: typeof AuthLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/logout": {
      id: "/auth/logout";
      path: "/auth/logout";
      fullPath: "/auth/logout";
      preLoaderRoute: typeof AuthLogoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/oauth-callback": {
      id: "/auth/oauth-callback";
      path: "/auth/oauth-callback";
      fullPath: "/auth/oauth-callback";
      preLoaderRoute: typeof AuthOauthCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/signin": {
      id: "/auth/signin";
      path: "/auth/signin";
      fullPath: "/auth/signin";
      preLoaderRoute: typeof AuthSigninRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/caf-documents-blocked/": {
      id: "/caf-documents-blocked/";
      path: "/caf-documents-blocked";
      fullPath: "/caf-documents-blocked/";
      preLoaderRoute: typeof CafDocumentsBlockedIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar/": {
      id: "/calendar/";
      path: "/calendar";
      fullPath: "/calendar/";
      preLoaderRoute: typeof CalendarIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/custom-website/": {
      id: "/custom-website/";
      path: "/custom-website";
      fullPath: "/custom-website/";
      preLoaderRoute: typeof CustomWebsiteIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/extend-time/$appointmentId": {
      id: "/extend-time/$appointmentId";
      path: "/extend-time/$appointmentId";
      fullPath: "/extend-time/$appointmentId";
      preLoaderRoute: typeof ExtendTimeAppointmentIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/flows/": {
      id: "/flows/";
      path: "/flows";
      fullPath: "/flows/";
      preLoaderRoute: typeof FlowsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/flows/$stepId": {
      id: "/flows/$stepId";
      path: "/flows/$stepId";
      fullPath: "/flows/$stepId";
      preLoaderRoute: typeof FlowsStepIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/general-terms/": {
      id: "/general-terms/";
      path: "/general-terms";
      fullPath: "/general-terms/";
      preLoaderRoute: typeof GeneralTermsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/google/callback": {
      id: "/google/callback";
      path: "/google/callback";
      fullPath: "/google/callback";
      preLoaderRoute: typeof GoogleCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/home/": {
      id: "/home/";
      path: "/home";
      fullPath: "/home/";
      preLoaderRoute: typeof HomeIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/locations/": {
      id: "/locations/";
      path: "/locations";
      fullPath: "/locations/";
      preLoaderRoute: typeof LocationsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/additional-info": {
      id: "/oneliv/additional-info";
      path: "/oneliv/additional-info";
      fullPath: "/oneliv/additional-info";
      preLoaderRoute: typeof OnelivAdditionalInfoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/basic-info": {
      id: "/oneliv/basic-info";
      path: "/oneliv/basic-info";
      fullPath: "/oneliv/basic-info";
      preLoaderRoute: typeof OnelivBasicInfoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/educational-background": {
      id: "/oneliv/educational-background";
      path: "/oneliv/educational-background";
      fullPath: "/oneliv/educational-background";
      preLoaderRoute: typeof OnelivEducationalBackgroundRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/experiences": {
      id: "/oneliv/experiences";
      path: "/oneliv/experiences";
      fullPath: "/oneliv/experiences";
      preLoaderRoute: typeof OnelivExperiencesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/faq": {
      id: "/oneliv/faq";
      path: "/oneliv/faq";
      fullPath: "/oneliv/faq";
      preLoaderRoute: typeof OnelivFaqRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/medical-institutions": {
      id: "/oneliv/medical-institutions";
      path: "/oneliv/medical-institutions";
      fullPath: "/oneliv/medical-institutions";
      preLoaderRoute: typeof OnelivMedicalInstitutionsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/social-media": {
      id: "/oneliv/social-media";
      path: "/oneliv/social-media";
      fullPath: "/oneliv/social-media";
      preLoaderRoute: typeof OnelivSocialMediaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/treatment-focus": {
      id: "/oneliv/treatment-focus";
      path: "/oneliv/treatment-focus";
      fullPath: "/oneliv/treatment-focus";
      preLoaderRoute: typeof OnelivTreatmentFocusRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/use-terms": {
      id: "/oneliv/use-terms";
      path: "/oneliv/use-terms";
      fullPath: "/oneliv/use-terms";
      preLoaderRoute: typeof OnelivUseTermsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/oneliv/welcome": {
      id: "/oneliv/welcome";
      path: "/oneliv/welcome";
      fullPath: "/oneliv/welcome";
      preLoaderRoute: typeof OnelivWelcomeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/patients/": {
      id: "/patients/";
      path: "/patients";
      fullPath: "/patients/";
      preLoaderRoute: typeof PatientsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recommendation/": {
      id: "/recommendation/";
      path: "/recommendation";
      fullPath: "/recommendation/";
      preLoaderRoute: typeof RecommendationIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/": {
      id: "/recurring-appointments/";
      path: "/recurring-appointments";
      fullPath: "/recurring-appointments/";
      preLoaderRoute: typeof RecurringAppointmentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/$codAgendamentoRecorrente": {
      id: "/recurring-appointments/$codAgendamentoRecorrente";
      path: "/recurring-appointments/$codAgendamentoRecorrente";
      fullPath: "/recurring-appointments/$codAgendamentoRecorrente";
      preLoaderRoute: typeof RecurringAppointmentsCodAgendamentoRecorrenteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/": {
      id: "/settings/";
      path: "/settings";
      fullPath: "/settings/";
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/assist": {
      id: "/settings/assist";
      path: "/settings/assist";
      fullPath: "/settings/assist";
      preLoaderRoute: typeof SettingsAssistRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/update-required/": {
      id: "/update-required/";
      path: "/update-required";
      fullPath: "/update-required/";
      preLoaderRoute: typeof UpdateRequiredIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/": {
      id: "/waiting-room/";
      path: "/waiting-room";
      fullPath: "/waiting-room/";
      preLoaderRoute: typeof WaitingRoomIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/cancel-recurrence": {
      id: "/appointment/$appointmentId/cancel-recurrence";
      path: "/appointment/$appointmentId/cancel-recurrence";
      fullPath: "/appointment/$appointmentId/cancel-recurrence";
      preLoaderRoute: typeof AppointmentAppointmentIdCancelRecurrenceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/flexible-pricing": {
      id: "/appointment/$appointmentId/flexible-pricing";
      path: "/appointment/$appointmentId/flexible-pricing";
      fullPath: "/appointment/$appointmentId/flexible-pricing";
      preLoaderRoute: typeof AppointmentAppointmentIdFlexiblePricingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/patient-swap": {
      id: "/appointment/$appointmentId/patient-swap";
      path: "/appointment/$appointmentId/patient-swap";
      fullPath: "/appointment/$appointmentId/patient-swap";
      preLoaderRoute: typeof AppointmentAppointmentIdPatientSwapRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/patient-swap-recurrence": {
      id: "/appointment/$appointmentId/patient-swap-recurrence";
      path: "/appointment/$appointmentId/patient-swap-recurrence";
      fullPath: "/appointment/$appointmentId/patient-swap-recurrence";
      preLoaderRoute: typeof AppointmentAppointmentIdPatientSwapRecurrenceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/patient-swap-search": {
      id: "/appointment/$appointmentId/patient-swap-search";
      path: "/appointment/$appointmentId/patient-swap-search";
      fullPath: "/appointment/$appointmentId/patient-swap-search";
      preLoaderRoute: typeof AppointmentAppointmentIdPatientSwapSearchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/reschedule": {
      id: "/appointment/$appointmentId/reschedule";
      path: "/appointment/$appointmentId/reschedule";
      fullPath: "/appointment/$appointmentId/reschedule";
      preLoaderRoute: typeof AppointmentAppointmentIdRescheduleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/reschedule-patient": {
      id: "/appointment/$appointmentId/reschedule-patient";
      path: "/appointment/$appointmentId/reschedule-patient";
      fullPath: "/appointment/$appointmentId/reschedule-patient";
      preLoaderRoute: typeof AppointmentAppointmentIdReschedulePatientRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/$appointmentId/reschedule-recurrence": {
      id: "/appointment/$appointmentId/reschedule-recurrence";
      path: "/appointment/$appointmentId/reschedule-recurrence";
      fullPath: "/appointment/$appointmentId/reschedule-recurrence";
      preLoaderRoute: typeof AppointmentAppointmentIdRescheduleRecurrenceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/create/": {
      id: "/appointment/create/";
      path: "/appointment/create";
      fullPath: "/appointment/create/";
      preLoaderRoute: typeof AppointmentCreateIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/create/available-options": {
      id: "/appointment/create/available-options";
      path: "/appointment/create/available-options";
      fullPath: "/appointment/create/available-options";
      preLoaderRoute: typeof AppointmentCreateAvailableOptionsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/create/flexible-pricing": {
      id: "/appointment/create/flexible-pricing";
      path: "/appointment/create/flexible-pricing";
      fullPath: "/appointment/create/flexible-pricing";
      preLoaderRoute: typeof AppointmentCreateFlexiblePricingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/create/patient": {
      id: "/appointment/create/patient";
      path: "/appointment/create/patient";
      fullPath: "/appointment/create/patient";
      preLoaderRoute: typeof AppointmentCreatePatientRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/appointment/create/search-patient": {
      id: "/appointment/create/search-patient";
      path: "/appointment/create/search-patient";
      fullPath: "/appointment/create/search-patient";
      preLoaderRoute: typeof AppointmentCreateSearchPatientRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/first-access/complete": {
      id: "/auth/first-access/complete";
      path: "/auth/first-access/complete";
      fullPath: "/auth/first-access/complete";
      preLoaderRoute: typeof AuthFirstAccessCompleteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/first-access/define-password": {
      id: "/auth/first-access/define-password";
      path: "/auth/first-access/define-password";
      fullPath: "/auth/first-access/define-password";
      preLoaderRoute: typeof AuthFirstAccessDefinePasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/first-access/document": {
      id: "/auth/first-access/document";
      path: "/auth/first-access/document";
      fullPath: "/auth/first-access/document";
      preLoaderRoute: typeof AuthFirstAccessDocumentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/first-access/document-not-found": {
      id: "/auth/first-access/document-not-found";
      path: "/auth/first-access/document-not-found";
      fullPath: "/auth/first-access/document-not-found";
      preLoaderRoute: typeof AuthFirstAccessDocumentNotFoundRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/first-access/verify-email": {
      id: "/auth/first-access/verify-email";
      path: "/auth/first-access/verify-email";
      fullPath: "/auth/first-access/verify-email";
      preLoaderRoute: typeof AuthFirstAccessVerifyEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/oauth/authorize": {
      id: "/auth/oauth/authorize";
      path: "/auth/oauth/authorize";
      fullPath: "/auth/oauth/authorize";
      preLoaderRoute: typeof AuthOauthAuthorizeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/password-reset/check-email": {
      id: "/auth/password-reset/check-email";
      path: "/auth/password-reset/check-email";
      fullPath: "/auth/password-reset/check-email";
      preLoaderRoute: typeof AuthPasswordResetCheckEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/password-reset/create-password": {
      id: "/auth/password-reset/create-password";
      path: "/auth/password-reset/create-password";
      fullPath: "/auth/password-reset/create-password";
      preLoaderRoute: typeof AuthPasswordResetCreatePasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/password-reset/forgot-password": {
      id: "/auth/password-reset/forgot-password";
      path: "/auth/password-reset/forgot-password";
      fullPath: "/auth/password-reset/forgot-password";
      preLoaderRoute: typeof AuthPasswordResetForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/password-reset/password-changed": {
      id: "/auth/password-reset/password-changed";
      path: "/auth/password-reset/password-changed";
      fullPath: "/auth/password-reset/password-changed";
      preLoaderRoute: typeof AuthPasswordResetPasswordChangedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar/batch-adjust/": {
      id: "/calendar/batch-adjust/";
      path: "/calendar/batch-adjust";
      fullPath: "/calendar/batch-adjust/";
      preLoaderRoute: typeof CalendarBatchAdjustIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar/batch-adjust/cancel": {
      id: "/calendar/batch-adjust/cancel";
      path: "/calendar/batch-adjust/cancel";
      fullPath: "/calendar/batch-adjust/cancel";
      preLoaderRoute: typeof CalendarBatchAdjustCancelRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar/batch-adjust/minutes": {
      id: "/calendar/batch-adjust/minutes";
      path: "/calendar/batch-adjust/minutes";
      fullPath: "/calendar/batch-adjust/minutes";
      preLoaderRoute: typeof CalendarBatchAdjustMinutesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar/batch-adjust/review": {
      id: "/calendar/batch-adjust/review";
      path: "/calendar/batch-adjust/review";
      fullPath: "/calendar/batch-adjust/review";
      preLoaderRoute: typeof CalendarBatchAdjustReviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar/batch-adjust/success": {
      id: "/calendar/batch-adjust/success";
      path: "/calendar/batch-adjust/success";
      fullPath: "/calendar/batch-adjust/success";
      preLoaderRoute: typeof CalendarBatchAdjustSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/calendar/unavailable-slots/create": {
      id: "/calendar/unavailable-slots/create";
      path: "/calendar/unavailable-slots/create";
      fullPath: "/calendar/unavailable-slots/create";
      preLoaderRoute: typeof CalendarUnavailableSlotsCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/custom-website/confirmation/": {
      id: "/custom-website/confirmation/";
      path: "/custom-website/confirmation";
      fullPath: "/custom-website/confirmation/";
      preLoaderRoute: typeof CustomWebsiteConfirmationIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/custom-website/confirmation/error": {
      id: "/custom-website/confirmation/error";
      path: "/custom-website/confirmation/error";
      fullPath: "/custom-website/confirmation/error";
      preLoaderRoute: typeof CustomWebsiteConfirmationErrorRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/custom-website/form/": {
      id: "/custom-website/form/";
      path: "/custom-website/form";
      fullPath: "/custom-website/form/";
      preLoaderRoute: typeof CustomWebsiteFormIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/flows/$stepId/$subStepId": {
      id: "/flows/$stepId/$subStepId";
      path: "/$subStepId";
      fullPath: "/flows/$stepId/$subStepId";
      preLoaderRoute: typeof FlowsStepIdSubStepIdRouteImport;
      parentRoute: typeof FlowsStepIdRoute;
    };
    "/flows/complete/$flowId": {
      id: "/flows/complete/$flowId";
      path: "/flows/complete/$flowId";
      fullPath: "/flows/complete/$flowId";
      preLoaderRoute: typeof FlowsCompleteFlowIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/home/all-features/": {
      id: "/home/all-features/";
      path: "/home/all-features";
      fullPath: "/home/all-features/";
      preLoaderRoute: typeof HomeAllFeaturesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/home/notification-center/": {
      id: "/home/notification-center/";
      path: "/home/notification-center";
      fullPath: "/home/notification-center/";
      preLoaderRoute: typeof HomeNotificationCenterIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/home/notification-center/about": {
      id: "/home/notification-center/about";
      path: "/home/notification-center/about";
      fullPath: "/home/notification-center/about";
      preLoaderRoute: typeof HomeNotificationCenterAboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/locations/$locationId/": {
      id: "/locations/$locationId/";
      path: "/locations/$locationId";
      fullPath: "/locations/$locationId/";
      preLoaderRoute: typeof LocationsLocationIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/consulting/acquisition": {
      id: "/onboarding/consulting/acquisition";
      path: "/onboarding/consulting/acquisition";
      fullPath: "/onboarding/consulting/acquisition";
      preLoaderRoute: typeof OnboardingConsultingAcquisitionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/consulting/career-problem": {
      id: "/onboarding/consulting/career-problem";
      path: "/onboarding/consulting/career-problem";
      fullPath: "/onboarding/consulting/career-problem";
      preLoaderRoute: typeof OnboardingConsultingCareerProblemRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/consulting/channels": {
      id: "/onboarding/consulting/channels";
      path: "/onboarding/consulting/channels";
      fullPath: "/onboarding/consulting/channels";
      preLoaderRoute: typeof OnboardingConsultingChannelsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/consulting/expectation": {
      id: "/onboarding/consulting/expectation";
      path: "/onboarding/consulting/expectation";
      fullPath: "/onboarding/consulting/expectation";
      preLoaderRoute: typeof OnboardingConsultingExpectationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/consulting/intro": {
      id: "/onboarding/consulting/intro";
      path: "/onboarding/consulting/intro";
      fullPath: "/onboarding/consulting/intro";
      preLoaderRoute: typeof OnboardingConsultingIntroRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/consulting/success": {
      id: "/onboarding/consulting/success";
      path: "/onboarding/consulting/success";
      fullPath: "/onboarding/consulting/success";
      preLoaderRoute: typeof OnboardingConsultingSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/": {
      id: "/onboarding/first-schedule/";
      path: "/onboarding/first-schedule";
      fullPath: "/onboarding/first-schedule/";
      preLoaderRoute: typeof OnboardingFirstScheduleIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/first-appointment": {
      id: "/onboarding/first-schedule/first-appointment";
      path: "/onboarding/first-schedule/first-appointment";
      fullPath: "/onboarding/first-schedule/first-appointment";
      preLoaderRoute: typeof OnboardingFirstScheduleFirstAppointmentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/follow-up": {
      id: "/onboarding/first-schedule/follow-up";
      path: "/onboarding/first-schedule/follow-up";
      fullPath: "/onboarding/first-schedule/follow-up";
      preLoaderRoute: typeof OnboardingFirstScheduleFollowUpRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/follow-up-days": {
      id: "/onboarding/first-schedule/follow-up-days";
      path: "/onboarding/first-schedule/follow-up-days";
      fullPath: "/onboarding/first-schedule/follow-up-days";
      preLoaderRoute: typeof OnboardingFirstScheduleFollowUpDaysRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/intro": {
      id: "/onboarding/first-schedule/intro";
      path: "/onboarding/first-schedule/intro";
      fullPath: "/onboarding/first-schedule/intro";
      preLoaderRoute: typeof OnboardingFirstScheduleIntroRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/preview": {
      id: "/onboarding/first-schedule/preview";
      path: "/onboarding/first-schedule/preview";
      fullPath: "/onboarding/first-schedule/preview";
      preLoaderRoute: typeof OnboardingFirstSchedulePreviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/schedule": {
      id: "/onboarding/first-schedule/schedule";
      path: "/onboarding/first-schedule/schedule";
      fullPath: "/onboarding/first-schedule/schedule";
      preLoaderRoute: typeof OnboardingFirstScheduleScheduleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/first-schedule/success": {
      id: "/onboarding/first-schedule/success";
      path: "/onboarding/first-schedule/success";
      fullPath: "/onboarding/first-schedule/success";
      preLoaderRoute: typeof OnboardingFirstScheduleSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/": {
      id: "/onboarding/welcome-meeting/";
      path: "/onboarding/welcome-meeting";
      fullPath: "/onboarding/welcome-meeting/";
      preLoaderRoute: typeof OnboardingWelcomeMeetingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/details": {
      id: "/onboarding/welcome-meeting/details";
      path: "/onboarding/welcome-meeting/details";
      fullPath: "/onboarding/welcome-meeting/details";
      preLoaderRoute: typeof OnboardingWelcomeMeetingDetailsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/dismissed": {
      id: "/onboarding/welcome-meeting/dismissed";
      path: "/onboarding/welcome-meeting/dismissed";
      fullPath: "/onboarding/welcome-meeting/dismissed";
      preLoaderRoute: typeof OnboardingWelcomeMeetingDismissedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/format": {
      id: "/onboarding/welcome-meeting/format";
      path: "/onboarding/welcome-meeting/format";
      fullPath: "/onboarding/welcome-meeting/format";
      preLoaderRoute: typeof OnboardingWelcomeMeetingFormatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/location": {
      id: "/onboarding/welcome-meeting/location";
      path: "/onboarding/welcome-meeting/location";
      fullPath: "/onboarding/welcome-meeting/location";
      preLoaderRoute: typeof OnboardingWelcomeMeetingLocationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/schedule": {
      id: "/onboarding/welcome-meeting/schedule";
      path: "/onboarding/welcome-meeting/schedule";
      fullPath: "/onboarding/welcome-meeting/schedule";
      preLoaderRoute: typeof OnboardingWelcomeMeetingScheduleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/skip-reason": {
      id: "/onboarding/welcome-meeting/skip-reason";
      path: "/onboarding/welcome-meeting/skip-reason";
      fullPath: "/onboarding/welcome-meeting/skip-reason";
      preLoaderRoute: typeof OnboardingWelcomeMeetingSkipReasonRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/onboarding/welcome-meeting/success": {
      id: "/onboarding/welcome-meeting/success";
      path: "/onboarding/welcome-meeting/success";
      fullPath: "/onboarding/welcome-meeting/success";
      preLoaderRoute: typeof OnboardingWelcomeMeetingSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/patients/$patientId/": {
      id: "/patients/$patientId/";
      path: "/patients/$patientId";
      fullPath: "/patients/$patientId/";
      preLoaderRoute: typeof PatientsPatientIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/patients/$patientId/update": {
      id: "/patients/$patientId/update";
      path: "/patients/$patientId/update";
      fullPath: "/patients/$patientId/update";
      preLoaderRoute: typeof PatientsPatientIdUpdateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recommendation/confirmation/": {
      id: "/recommendation/confirmation/";
      path: "/recommendation/confirmation";
      fullPath: "/recommendation/confirmation/";
      preLoaderRoute: typeof RecommendationConfirmationIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/create/": {
      id: "/recurring-appointments/create/";
      path: "/recurring-appointments/create";
      fullPath: "/recurring-appointments/create/";
      preLoaderRoute: typeof RecurringAppointmentsCreateIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/create/availability": {
      id: "/recurring-appointments/create/availability";
      path: "/recurring-appointments/create/availability";
      fullPath: "/recurring-appointments/create/availability";
      preLoaderRoute: typeof RecurringAppointmentsCreateAvailabilityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/create/patient": {
      id: "/recurring-appointments/create/patient";
      path: "/recurring-appointments/create/patient";
      fullPath: "/recurring-appointments/create/patient";
      preLoaderRoute: typeof RecurringAppointmentsCreatePatientRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/create/review": {
      id: "/recurring-appointments/create/review";
      path: "/recurring-appointments/create/review";
      fullPath: "/recurring-appointments/create/review";
      preLoaderRoute: typeof RecurringAppointmentsCreateReviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/create/search-patient": {
      id: "/recurring-appointments/create/search-patient";
      path: "/recurring-appointments/create/search-patient";
      fullPath: "/recurring-appointments/create/search-patient";
      preLoaderRoute: typeof RecurringAppointmentsCreateSearchPatientRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/create/success": {
      id: "/recurring-appointments/create/success";
      path: "/recurring-appointments/create/success";
      fullPath: "/recurring-appointments/create/success";
      preLoaderRoute: typeof RecurringAppointmentsCreateSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/extend/$recurringAppointmentId": {
      id: "/recurring-appointments/extend/$recurringAppointmentId";
      path: "/recurring-appointments/extend/$recurringAppointmentId";
      fullPath: "/recurring-appointments/extend/$recurringAppointmentId";
      preLoaderRoute: typeof RecurringAppointmentsExtendRecurringAppointmentIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/extend/success": {
      id: "/recurring-appointments/extend/success";
      path: "/recurring-appointments/extend/success";
      fullPath: "/recurring-appointments/extend/success";
      preLoaderRoute: typeof RecurringAppointmentsExtendSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/reschedule/availability": {
      id: "/recurring-appointments/reschedule/availability";
      path: "/recurring-appointments/reschedule/availability";
      fullPath: "/recurring-appointments/reschedule/availability";
      preLoaderRoute: typeof RecurringAppointmentsRescheduleAvailabilityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recurring-appointments/reschedule/review": {
      id: "/recurring-appointments/reschedule/review";
      path: "/recurring-appointments/reschedule/review";
      fullPath: "/recurring-appointments/reschedule/review";
      preLoaderRoute: typeof RecurringAppointmentsRescheduleReviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/assist/": {
      id: "/settings/assist/";
      path: "/";
      fullPath: "/settings/assist/";
      preLoaderRoute: typeof SettingsAssistIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/billing/": {
      id: "/settings/billing/";
      path: "/settings/billing";
      fullPath: "/settings/billing/";
      preLoaderRoute: typeof SettingsBillingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/billing/$billingItemId": {
      id: "/settings/billing/$billingItemId";
      path: "/settings/billing/$billingItemId";
      fullPath: "/settings/billing/$billingItemId";
      preLoaderRoute: typeof SettingsBillingBillingItemIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/billing/about": {
      id: "/settings/billing/about";
      path: "/settings/billing/about";
      fullPath: "/settings/billing/about";
      preLoaderRoute: typeof SettingsBillingAboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/blog/": {
      id: "/settings/blog/";
      path: "/settings/blog";
      fullPath: "/settings/blog/";
      preLoaderRoute: typeof SettingsBlogIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/blog/create": {
      id: "/settings/blog/create";
      path: "/settings/blog/create";
      fullPath: "/settings/blog/create";
      preLoaderRoute: typeof SettingsBlogCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/community/": {
      id: "/settings/community/";
      path: "/settings/community";
      fullPath: "/settings/community/";
      preLoaderRoute: typeof SettingsCommunityIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/google-calendar/": {
      id: "/settings/google-calendar/";
      path: "/settings/google-calendar";
      fullPath: "/settings/google-calendar/";
      preLoaderRoute: typeof SettingsGoogleCalendarIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/": {
      id: "/settings/payments/";
      path: "/settings/payments";
      fullPath: "/settings/payments/";
      preLoaderRoute: typeof SettingsPaymentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/welcome": {
      id: "/settings/payments/welcome";
      path: "/settings/payments/welcome";
      fullPath: "/settings/payments/welcome";
      preLoaderRoute: typeof SettingsPaymentsWelcomeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/professional-site/": {
      id: "/settings/professional-site/";
      path: "/settings/professional-site";
      fullPath: "/settings/professional-site/";
      preLoaderRoute: typeof SettingsProfessionalSiteIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/": {
      id: "/settings/profile/";
      path: "/settings/profile";
      fullPath: "/settings/profile/";
      preLoaderRoute: typeof SettingsProfileIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/referral/": {
      id: "/settings/referral/";
      path: "/settings/referral";
      fullPath: "/settings/referral/";
      preLoaderRoute: typeof SettingsReferralIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/referral/about": {
      id: "/settings/referral/about";
      path: "/settings/referral/about";
      fullPath: "/settings/referral/about";
      preLoaderRoute: typeof SettingsReferralAboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/": {
      id: "/settings/regulatory-documents/";
      path: "/settings/regulatory-documents";
      fullPath: "/settings/regulatory-documents/";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/confirmation": {
      id: "/settings/regulatory-documents/confirmation";
      path: "/settings/regulatory-documents/confirmation";
      fullPath: "/settings/regulatory-documents/confirmation";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsConfirmationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/declaration-locations": {
      id: "/settings/regulatory-documents/declaration-locations";
      path: "/settings/regulatory-documents/declaration-locations";
      fullPath: "/settings/regulatory-documents/declaration-locations";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsDeclarationLocationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/download": {
      id: "/settings/regulatory-documents/download";
      path: "/settings/regulatory-documents/download";
      fullPath: "/settings/regulatory-documents/download";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsDownloadRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/locations": {
      id: "/settings/regulatory-documents/locations";
      path: "/settings/regulatory-documents/locations";
      fullPath: "/settings/regulatory-documents/locations";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsLocationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/reason": {
      id: "/settings/regulatory-documents/reason";
      path: "/settings/regulatory-documents/reason";
      fullPath: "/settings/regulatory-documents/reason";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsReasonRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/requests": {
      id: "/settings/regulatory-documents/requests";
      path: "/settings/regulatory-documents/requests";
      fullPath: "/settings/regulatory-documents/requests";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsRequestsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/review": {
      id: "/settings/regulatory-documents/review";
      path: "/settings/regulatory-documents/review";
      fullPath: "/settings/regulatory-documents/review";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsReviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/regulatory-documents/state": {
      id: "/settings/regulatory-documents/state";
      path: "/settings/regulatory-documents/state";
      fullPath: "/settings/regulatory-documents/state";
      preLoaderRoute: typeof SettingsRegulatoryDocumentsStateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/": {
      id: "/settings/reserved-schedules/";
      path: "/settings/reserved-schedules";
      fullPath: "/settings/reserved-schedules/";
      preLoaderRoute: typeof SettingsReservedSchedulesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/": {
      id: "/settings/schedule-options/";
      path: "/settings/schedule-options";
      fullPath: "/settings/schedule-options/";
      preLoaderRoute: typeof SettingsScheduleOptionsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/follow-up-appointment-reminder/$appointmentId": {
      id: "/waiting-room/follow-up-appointment-reminder/$appointmentId";
      path: "/waiting-room/follow-up-appointment-reminder/$appointmentId";
      fullPath: "/waiting-room/follow-up-appointment-reminder/$appointmentId";
      preLoaderRoute: typeof WaitingRoomFollowUpAppointmentReminderAppointmentIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/home/info/$infoItemId/": {
      id: "/home/info/$infoItemId/";
      path: "/home/info/$infoItemId";
      fullPath: "/home/info/$infoItemId/";
      preLoaderRoute: typeof HomeInfoInfoItemIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/home/info/$infoItemId/confirmation": {
      id: "/home/info/$infoItemId/confirmation";
      path: "/home/info/$infoItemId/confirmation";
      fullPath: "/home/info/$infoItemId/confirmation";
      preLoaderRoute: typeof HomeInfoInfoItemIdConfirmationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/home/notification-center/$id/": {
      id: "/home/notification-center/$id/";
      path: "/home/notification-center/$id";
      fullPath: "/home/notification-center/$id/";
      preLoaderRoute: typeof HomeNotificationCenterIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/assist/assist-pro-acceptance/": {
      id: "/settings/assist/assist-pro-acceptance/";
      path: "/assist-pro-acceptance";
      fullPath: "/settings/assist/assist-pro-acceptance/";
      preLoaderRoute: typeof SettingsAssistAssistProAcceptanceIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/contacts-history/": {
      id: "/settings/assist/contacts-history/";
      path: "/contacts-history";
      fullPath: "/settings/assist/contacts-history/";
      preLoaderRoute: typeof SettingsAssistContactsHistoryIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/customer-appointment-overview/": {
      id: "/settings/assist/customer-appointment-overview/";
      path: "/customer-appointment-overview";
      fullPath: "/settings/assist/customer-appointment-overview/";
      preLoaderRoute: typeof SettingsAssistCustomerAppointmentOverviewIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/customer-contact-overview/": {
      id: "/settings/assist/customer-contact-overview/";
      path: "/customer-contact-overview";
      fullPath: "/settings/assist/customer-contact-overview/";
      preLoaderRoute: typeof SettingsAssistCustomerContactOverviewIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/customer-site-overview/": {
      id: "/settings/assist/customer-site-overview/";
      path: "/customer-site-overview";
      fullPath: "/settings/assist/customer-site-overview/";
      preLoaderRoute: typeof SettingsAssistCustomerSiteOverviewIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/feature-settings/": {
      id: "/settings/assist/feature-settings/";
      path: "/feature-settings";
      fullPath: "/settings/assist/feature-settings/";
      preLoaderRoute: typeof SettingsAssistFeatureSettingsIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/follow-up-appointment-reminder/": {
      id: "/settings/assist/follow-up-appointment-reminder/";
      path: "/follow-up-appointment-reminder";
      fullPath: "/settings/assist/follow-up-appointment-reminder/";
      preLoaderRoute: typeof SettingsAssistFollowUpAppointmentReminderIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/rescued-appointment-overview/": {
      id: "/settings/assist/rescued-appointment-overview/";
      path: "/rescued-appointment-overview";
      fullPath: "/settings/assist/rescued-appointment-overview/";
      preLoaderRoute: typeof SettingsAssistRescuedAppointmentOverviewIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/secretary-details/": {
      id: "/settings/assist/secretary-details/";
      path: "/secretary-details";
      fullPath: "/settings/assist/secretary-details/";
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/secretary-details/appointment-infos": {
      id: "/settings/assist/secretary-details/appointment-infos";
      path: "/secretary-details/appointment-infos";
      fullPath: "/settings/assist/secretary-details/appointment-infos";
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsAppointmentInfosRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/secretary-details/faq": {
      id: "/settings/assist/secretary-details/faq";
      path: "/secretary-details/faq";
      fullPath: "/settings/assist/secretary-details/faq";
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsFaqRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/secretary-details/professional-infos": {
      id: "/settings/assist/secretary-details/professional-infos";
      path: "/secretary-details/professional-infos";
      fullPath: "/settings/assist/secretary-details/professional-infos";
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsProfessionalInfosRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/secretary-details/restrictions": {
      id: "/settings/assist/secretary-details/restrictions";
      path: "/secretary-details/restrictions";
      fullPath: "/settings/assist/secretary-details/restrictions";
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsRestrictionsRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/subscribe-assist-pro-legacy/": {
      id: "/settings/assist/subscribe-assist-pro-legacy/";
      path: "/subscribe-assist-pro-legacy";
      fullPath: "/settings/assist/subscribe-assist-pro-legacy/";
      preLoaderRoute: typeof SettingsAssistSubscribeAssistProLegacyIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/subscribe-assist-pro/": {
      id: "/settings/assist/subscribe-assist-pro/";
      path: "/subscribe-assist-pro";
      fullPath: "/settings/assist/subscribe-assist-pro/";
      preLoaderRoute: typeof SettingsAssistSubscribeAssistProIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/subscribed-assist/": {
      id: "/settings/assist/subscribed-assist/";
      path: "/subscribed-assist";
      fullPath: "/settings/assist/subscribed-assist/";
      preLoaderRoute: typeof SettingsAssistSubscribedAssistIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/tasks/": {
      id: "/settings/assist/tasks/";
      path: "/tasks";
      fullPath: "/settings/assist/tasks/";
      preLoaderRoute: typeof SettingsAssistTasksIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/unsubscribe-assist-pro/": {
      id: "/settings/assist/unsubscribe-assist-pro/";
      path: "/unsubscribe-assist-pro";
      fullPath: "/settings/assist/unsubscribe-assist-pro/";
      preLoaderRoute: typeof SettingsAssistUnsubscribeAssistProIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/user-trackable-links/": {
      id: "/settings/assist/user-trackable-links/";
      path: "/user-trackable-links";
      fullPath: "/settings/assist/user-trackable-links/";
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/billing/details/": {
      id: "/settings/billing/details/";
      path: "/settings/billing/details";
      fullPath: "/settings/billing/details/";
      preLoaderRoute: typeof SettingsBillingDetailsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/blog/$userPostId/": {
      id: "/settings/blog/$userPostId/";
      path: "/settings/blog/$userPostId";
      fullPath: "/settings/blog/$userPostId/";
      preLoaderRoute: typeof SettingsBlogUserPostIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/blog/$userPostId/edit": {
      id: "/settings/blog/$userPostId/edit";
      path: "/settings/blog/$userPostId/edit";
      fullPath: "/settings/blog/$userPostId/edit";
      preLoaderRoute: typeof SettingsBlogUserPostIdEditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/bank-account/": {
      id: "/settings/payments/bank-account/";
      path: "/settings/payments/bank-account";
      fullPath: "/settings/payments/bank-account/";
      preLoaderRoute: typeof SettingsPaymentsBankAccountIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/bank-account/change-bank-account-or-ownership": {
      id: "/settings/payments/bank-account/change-bank-account-or-ownership";
      path: "/settings/payments/bank-account/change-bank-account-or-ownership";
      fullPath: "/settings/payments/bank-account/change-bank-account-or-ownership";
      preLoaderRoute: typeof SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/bank-account/update": {
      id: "/settings/payments/bank-account/update";
      path: "/settings/payments/bank-account/update";
      fullPath: "/settings/payments/bank-account/update";
      preLoaderRoute: typeof SettingsPaymentsBankAccountUpdateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/": {
      id: "/settings/payments/create-recipient/";
      path: "/settings/payments/create-recipient";
      fullPath: "/settings/payments/create-recipient/";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/add-bank-account": {
      id: "/settings/payments/create-recipient/add-bank-account";
      path: "/settings/payments/create-recipient/add-bank-account";
      fullPath: "/settings/payments/create-recipient/add-bank-account";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientAddBankAccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/check-cnpj": {
      id: "/settings/payments/create-recipient/check-cnpj";
      path: "/settings/payments/create-recipient/check-cnpj";
      fullPath: "/settings/payments/create-recipient/check-cnpj";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientCheckCnpjRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/choose-holder-type": {
      id: "/settings/payments/create-recipient/choose-holder-type";
      path: "/settings/payments/create-recipient/choose-holder-type";
      fullPath: "/settings/payments/create-recipient/choose-holder-type";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientChooseHolderTypeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/confirm-bank-account": {
      id: "/settings/payments/create-recipient/confirm-bank-account";
      path: "/settings/payments/create-recipient/confirm-bank-account";
      fullPath: "/settings/payments/create-recipient/confirm-bank-account";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientConfirmBankAccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/confirm-document": {
      id: "/settings/payments/create-recipient/confirm-document";
      path: "/settings/payments/create-recipient/confirm-document";
      fullPath: "/settings/payments/create-recipient/confirm-document";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientConfirmDocumentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/status": {
      id: "/settings/payments/create-recipient/status";
      path: "/settings/payments/create-recipient/status";
      fullPath: "/settings/payments/create-recipient/status";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientStatusRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create-recipient/validate-data": {
      id: "/settings/payments/create-recipient/validate-data";
      path: "/settings/payments/create-recipient/validate-data";
      fullPath: "/settings/payments/create-recipient/validate-data";
      preLoaderRoute: typeof SettingsPaymentsCreateRecipientValidateDataRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create/": {
      id: "/settings/payments/create/";
      path: "/settings/payments/create";
      fullPath: "/settings/payments/create/";
      preLoaderRoute: typeof SettingsPaymentsCreateIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/create/confirmation": {
      id: "/settings/payments/create/confirmation";
      path: "/settings/payments/create/confirmation";
      fullPath: "/settings/payments/create/confirmation";
      preLoaderRoute: typeof SettingsPaymentsCreateConfirmationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/evolution-charts/": {
      id: "/settings/payments/evolution-charts/";
      path: "/settings/payments/evolution-charts";
      fullPath: "/settings/payments/evolution-charts/";
      preLoaderRoute: typeof SettingsPaymentsEvolutionChartsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/": {
      id: "/settings/payments/patient-payments/";
      path: "/settings/payments/patient-payments";
      fullPath: "/settings/payments/patient-payments/";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/about-payment-anticipation": {
      id: "/settings/payments/patient-payments/about-payment-anticipation";
      path: "/settings/payments/patient-payments/about-payment-anticipation";
      fullPath: "/settings/payments/patient-payments/about-payment-anticipation";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/about-payment-details": {
      id: "/settings/payments/patient-payments/about-payment-details";
      path: "/settings/payments/patient-payments/about-payment-details";
      fullPath: "/settings/payments/patient-payments/about-payment-details";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentDetailsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/about-payments": {
      id: "/settings/payments/patient-payments/about-payments";
      path: "/settings/payments/patient-payments/about-payments";
      fullPath: "/settings/payments/patient-payments/about-payments";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/details": {
      id: "/settings/payments/patient-payments/details";
      path: "/settings/payments/patient-payments/details";
      fullPath: "/settings/payments/patient-payments/details";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsDetailsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/payment-receipt": {
      id: "/settings/payments/patient-payments/payment-receipt";
      path: "/settings/payments/patient-payments/payment-receipt";
      fullPath: "/settings/payments/patient-payments/payment-receipt";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsPaymentReceiptRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/refund": {
      id: "/settings/payments/patient-payments/refund";
      path: "/settings/payments/patient-payments/refund";
      fullPath: "/settings/payments/patient-payments/refund";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsRefundRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/refund-receipt": {
      id: "/settings/payments/patient-payments/refund-receipt";
      path: "/settings/payments/patient-payments/refund-receipt";
      fullPath: "/settings/payments/patient-payments/refund-receipt";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsRefundReceiptRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/payables/": {
      id: "/settings/payments/payables/";
      path: "/settings/payments/payables";
      fullPath: "/settings/payments/payables/";
      preLoaderRoute: typeof SettingsPaymentsPayablesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/payables/about": {
      id: "/settings/payments/payables/about";
      path: "/settings/payments/payables/about";
      fullPath: "/settings/payments/payables/about";
      preLoaderRoute: typeof SettingsPaymentsPayablesAboutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/terms-of-service/": {
      id: "/settings/payments/terms-of-service/";
      path: "/settings/payments/terms-of-service";
      fullPath: "/settings/payments/terms-of-service/";
      preLoaderRoute: typeof SettingsPaymentsTermsOfServiceIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/professional-site/about/": {
      id: "/settings/professional-site/about/";
      path: "/settings/professional-site/about";
      fullPath: "/settings/professional-site/about/";
      preLoaderRoute: typeof SettingsProfessionalSiteAboutIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/card/": {
      id: "/settings/profile/card/";
      path: "/settings/profile/card";
      fullPath: "/settings/profile/card/";
      preLoaderRoute: typeof SettingsProfileCardIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/card/create": {
      id: "/settings/profile/card/create";
      path: "/settings/profile/card/create";
      fullPath: "/settings/profile/card/create";
      preLoaderRoute: typeof SettingsProfileCardCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/personal-data/": {
      id: "/settings/profile/personal-data/";
      path: "/settings/profile/personal-data";
      fullPath: "/settings/profile/personal-data/";
      preLoaderRoute: typeof SettingsProfilePersonalDataIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/personal-data/edit": {
      id: "/settings/profile/personal-data/edit";
      path: "/settings/profile/personal-data/edit";
      fullPath: "/settings/profile/personal-data/edit";
      preLoaderRoute: typeof SettingsProfilePersonalDataEditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/personal-data/edit-address": {
      id: "/settings/profile/personal-data/edit-address";
      path: "/settings/profile/personal-data/edit-address";
      fullPath: "/settings/profile/personal-data/edit-address";
      preLoaderRoute: typeof SettingsProfilePersonalDataEditAddressRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/plan/": {
      id: "/settings/profile/plan/";
      path: "/settings/profile/plan";
      fullPath: "/settings/profile/plan/";
      preLoaderRoute: typeof SettingsProfilePlanIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/professional-data/": {
      id: "/settings/profile/professional-data/";
      path: "/settings/profile/professional-data";
      fullPath: "/settings/profile/professional-data/";
      preLoaderRoute: typeof SettingsProfileProfessionalDataIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/upsert-public-phone/": {
      id: "/settings/profile/upsert-public-phone/";
      path: "/settings/profile/upsert-public-phone";
      fullPath: "/settings/profile/upsert-public-phone/";
      preLoaderRoute: typeof SettingsProfileUpsertPublicPhoneIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/vehicles/": {
      id: "/settings/profile/vehicles/";
      path: "/settings/profile/vehicles";
      fullPath: "/settings/profile/vehicles/";
      preLoaderRoute: typeof SettingsProfileVehiclesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/vehicles/$vehicleId": {
      id: "/settings/profile/vehicles/$vehicleId";
      path: "/settings/profile/vehicles/$vehicleId";
      fullPath: "/settings/profile/vehicles/$vehicleId";
      preLoaderRoute: typeof SettingsProfileVehiclesVehicleIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/vehicles/create": {
      id: "/settings/profile/vehicles/create";
      path: "/settings/profile/vehicles/create";
      fullPath: "/settings/profile/vehicles/create";
      preLoaderRoute: typeof SettingsProfileVehiclesCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/$reservedScheduleId/": {
      id: "/settings/reserved-schedules/$reservedScheduleId/";
      path: "/settings/reserved-schedules/$reservedScheduleId";
      fullPath: "/settings/reserved-schedules/$reservedScheduleId/";
      preLoaderRoute: typeof SettingsReservedSchedulesReservedScheduleIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/$reservedScheduleId/cancel": {
      id: "/settings/reserved-schedules/$reservedScheduleId/cancel";
      path: "/settings/reserved-schedules/$reservedScheduleId/cancel";
      fullPath: "/settings/reserved-schedules/$reservedScheduleId/cancel";
      preLoaderRoute: typeof SettingsReservedSchedulesReservedScheduleIdCancelRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/create/": {
      id: "/settings/reserved-schedules/create/";
      path: "/settings/reserved-schedules/create";
      fullPath: "/settings/reserved-schedules/create/";
      preLoaderRoute: typeof SettingsReservedSchedulesCreateIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/create/confirm": {
      id: "/settings/reserved-schedules/create/confirm";
      path: "/settings/reserved-schedules/create/confirm";
      fullPath: "/settings/reserved-schedules/create/confirm";
      preLoaderRoute: typeof SettingsReservedSchedulesCreateConfirmRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/create/linked-schedule": {
      id: "/settings/reserved-schedules/create/linked-schedule";
      path: "/settings/reserved-schedules/create/linked-schedule";
      fullPath: "/settings/reserved-schedules/create/linked-schedule";
      preLoaderRoute: typeof SettingsReservedSchedulesCreateLinkedScheduleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/create/slots": {
      id: "/settings/reserved-schedules/create/slots";
      path: "/settings/reserved-schedules/create/slots";
      fullPath: "/settings/reserved-schedules/create/slots";
      preLoaderRoute: typeof SettingsReservedSchedulesCreateSlotsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/create/starting-day": {
      id: "/settings/reserved-schedules/create/starting-day";
      path: "/settings/reserved-schedules/create/starting-day";
      fullPath: "/settings/reserved-schedules/create/starting-day";
      preLoaderRoute: typeof SettingsReservedSchedulesCreateStartingDayRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-receiving-options/": {
      id: "/settings/schedule-options/appointment-receiving-options/";
      path: "/settings/schedule-options/appointment-receiving-options";
      fullPath: "/settings/schedule-options/appointment-receiving-options/";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/": {
      id: "/settings/schedule-options/appointment-types/";
      path: "/settings/schedule-options/appointment-types";
      fullPath: "/settings/schedule-options/appointment-types/";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/preferred-rooms/": {
      id: "/settings/schedule-options/preferred-rooms/";
      path: "/settings/schedule-options/preferred-rooms";
      fullPath: "/settings/schedule-options/preferred-rooms/";
      preLoaderRoute: typeof SettingsScheduleOptionsPreferredRoomsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/preferred-rooms/$unitId": {
      id: "/settings/schedule-options/preferred-rooms/$unitId";
      path: "/settings/schedule-options/preferred-rooms/$unitId";
      fullPath: "/settings/schedule-options/preferred-rooms/$unitId";
      preLoaderRoute: typeof SettingsScheduleOptionsPreferredRoomsUnitIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/schedules/": {
      id: "/settings/schedule-options/schedules/";
      path: "/settings/schedule-options/schedules";
      fullPath: "/settings/schedule-options/schedules/";
      preLoaderRoute: typeof SettingsScheduleOptionsSchedulesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/schedules/$scheduleId": {
      id: "/settings/schedule-options/schedules/$scheduleId";
      path: "/settings/schedule-options/schedules/$scheduleId";
      fullPath: "/settings/schedule-options/schedules/$scheduleId";
      preLoaderRoute: typeof SettingsScheduleOptionsSchedulesScheduleIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/schedules/create": {
      id: "/settings/schedule-options/schedules/create";
      path: "/settings/schedule-options/schedules/create";
      fullPath: "/settings/schedule-options/schedules/create";
      preLoaderRoute: typeof SettingsScheduleOptionsSchedulesCreateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/service-preferences/": {
      id: "/settings/schedule-options/service-preferences/";
      path: "/settings/schedule-options/service-preferences";
      fullPath: "/settings/schedule-options/service-preferences/";
      preLoaderRoute: typeof SettingsScheduleOptionsServicePreferencesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/$codAgendamento/change-time/": {
      id: "/waiting-room/$codAgendamento/change-time/";
      path: "/waiting-room/$codAgendamento/change-time";
      fullPath: "/waiting-room/$codAgendamento/change-time/";
      preLoaderRoute: typeof WaitingRoomCodAgendamentoChangeTimeIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/$codAgendamento/choose-payment-channel/": {
      id: "/waiting-room/$codAgendamento/choose-payment-channel/";
      path: "/waiting-room/$codAgendamento/choose-payment-channel";
      fullPath: "/waiting-room/$codAgendamento/choose-payment-channel/";
      preLoaderRoute: typeof WaitingRoomCodAgendamentoChoosePaymentChannelIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/$codAgendamento/menu/": {
      id: "/waiting-room/$codAgendamento/menu/";
      path: "/waiting-room/$codAgendamento/menu";
      fullPath: "/waiting-room/$codAgendamento/menu/";
      preLoaderRoute: typeof WaitingRoomCodAgendamentoMenuIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/$codAgendamento/receive-room-now/": {
      id: "/waiting-room/$codAgendamento/receive-room-now/";
      path: "/waiting-room/$codAgendamento/receive-room-now";
      fullPath: "/waiting-room/$codAgendamento/receive-room-now/";
      preLoaderRoute: typeof WaitingRoomCodAgendamentoReceiveRoomNowIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/$codAgendamento/send-totem-payment/": {
      id: "/waiting-room/$codAgendamento/send-totem-payment/";
      path: "/waiting-room/$codAgendamento/send-totem-payment";
      fullPath: "/waiting-room/$codAgendamento/send-totem-payment/";
      preLoaderRoute: typeof WaitingRoomCodAgendamentoSendTotemPaymentIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/follow-up-appointment-reminder/patient/$patientId": {
      id: "/waiting-room/follow-up-appointment-reminder/patient/$patientId";
      path: "/waiting-room/follow-up-appointment-reminder/patient/$patientId";
      fullPath: "/waiting-room/follow-up-appointment-reminder/patient/$patientId";
      preLoaderRoute: typeof WaitingRoomFollowUpAppointmentReminderPatientPatientIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/assist/contacts-history/$contactId/": {
      id: "/settings/assist/contacts-history/$contactId/";
      path: "/contacts-history/$contactId";
      fullPath: "/settings/assist/contacts-history/$contactId/";
      preLoaderRoute: typeof SettingsAssistContactsHistoryContactIdIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/contacts-history/about/": {
      id: "/settings/assist/contacts-history/about/";
      path: "/contacts-history/about";
      fullPath: "/settings/assist/contacts-history/about/";
      preLoaderRoute: typeof SettingsAssistContactsHistoryAboutIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/contacts-history/essential/": {
      id: "/settings/assist/contacts-history/essential/";
      path: "/contacts-history/essential";
      fullPath: "/settings/assist/contacts-history/essential/";
      preLoaderRoute: typeof SettingsAssistContactsHistoryEssentialIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/contacts-history/trial-period/": {
      id: "/settings/assist/contacts-history/trial-period/";
      path: "/contacts-history/trial-period";
      fullPath: "/settings/assist/contacts-history/trial-period/";
      preLoaderRoute: typeof SettingsAssistContactsHistoryTrialPeriodIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/customer-contact-overview/stories-feed/": {
      id: "/settings/assist/customer-contact-overview/stories-feed/";
      path: "/customer-contact-overview/stories-feed";
      fullPath: "/settings/assist/customer-contact-overview/stories-feed/";
      preLoaderRoute: typeof SettingsAssistCustomerContactOverviewStoriesFeedIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/follow-up-appointment-reminder/patients/": {
      id: "/settings/assist/follow-up-appointment-reminder/patients/";
      path: "/follow-up-appointment-reminder/patients";
      fullPath: "/settings/assist/follow-up-appointment-reminder/patients/";
      preLoaderRoute: typeof SettingsAssistFollowUpAppointmentReminderPatientsIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/subscribe-assist-pro/confirm/": {
      id: "/settings/assist/subscribe-assist-pro/confirm/";
      path: "/subscribe-assist-pro/confirm";
      fullPath: "/settings/assist/subscribe-assist-pro/confirm/";
      preLoaderRoute: typeof SettingsAssistSubscribeAssistProConfirmIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/tasks/$taskId/": {
      id: "/settings/assist/tasks/$taskId/";
      path: "/tasks/$taskId";
      fullPath: "/settings/assist/tasks/$taskId/";
      preLoaderRoute: typeof SettingsAssistTasksTaskIdIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/unsubscribe-assist-pro/upsert-phone/": {
      id: "/settings/assist/unsubscribe-assist-pro/upsert-phone/";
      path: "/unsubscribe-assist-pro/upsert-phone";
      fullPath: "/settings/assist/unsubscribe-assist-pro/upsert-phone/";
      preLoaderRoute: typeof SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/user-trackable-links/$userTrackableLinkId/": {
      id: "/settings/assist/user-trackable-links/$userTrackableLinkId/";
      path: "/user-trackable-links/$userTrackableLinkId";
      fullPath: "/settings/assist/user-trackable-links/$userTrackableLinkId/";
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/user-trackable-links/create/": {
      id: "/settings/assist/user-trackable-links/create/";
      path: "/user-trackable-links/create";
      fullPath: "/settings/assist/user-trackable-links/create/";
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksCreateIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/billing/details/$billingId/": {
      id: "/settings/billing/details/$billingId/";
      path: "/settings/billing/details/$billingId";
      fullPath: "/settings/billing/details/$billingId/";
      preLoaderRoute: typeof SettingsBillingDetailsBillingIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/billing/details/$billingId/boleto": {
      id: "/settings/billing/details/$billingId/boleto";
      path: "/settings/billing/details/$billingId/boleto";
      fullPath: "/settings/billing/details/$billingId/boleto";
      preLoaderRoute: typeof SettingsBillingDetailsBillingIdBoletoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/billing/details/$billingId/pix": {
      id: "/settings/billing/details/$billingId/pix";
      path: "/settings/billing/details/$billingId/pix";
      fullPath: "/settings/billing/details/$billingId/pix";
      preLoaderRoute: typeof SettingsBillingDetailsBillingIdPixRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/$guid/change-online-payment-status": {
      id: "/settings/payments/patient-payments/$guid/change-online-payment-status";
      path: "/settings/payments/patient-payments/$guid/change-online-payment-status";
      fullPath: "/settings/payments/patient-payments/$guid/change-online-payment-status";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/filters/filter-origins": {
      id: "/settings/payments/patient-payments/filters/filter-origins";
      path: "/settings/payments/patient-payments/filters/filter-origins";
      fullPath: "/settings/payments/patient-payments/filters/filter-origins";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterOriginsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/filters/filter-payment-methods": {
      id: "/settings/payments/patient-payments/filters/filter-payment-methods";
      path: "/settings/payments/patient-payments/filters/filter-payment-methods";
      fullPath: "/settings/payments/patient-payments/filters/filter-payment-methods";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/payments/patient-payments/filters/filter-status": {
      id: "/settings/payments/patient-payments/filters/filter-status";
      path: "/settings/payments/patient-payments/filters/filter-status";
      fullPath: "/settings/payments/patient-payments/filters/filter-status";
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterStatusRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/plan/cancel-subscription/": {
      id: "/settings/profile/plan/cancel-subscription/";
      path: "/settings/profile/plan/cancel-subscription";
      fullPath: "/settings/profile/plan/cancel-subscription/";
      preLoaderRoute: typeof SettingsProfilePlanCancelSubscriptionIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/plan/change/": {
      id: "/settings/profile/plan/change/";
      path: "/settings/profile/plan/change";
      fullPath: "/settings/profile/plan/change/";
      preLoaderRoute: typeof SettingsProfilePlanChangeIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/professional-data/edit/professional-data": {
      id: "/settings/profile/professional-data/edit/professional-data";
      path: "/settings/profile/professional-data/edit/professional-data";
      fullPath: "/settings/profile/professional-data/edit/professional-data";
      preLoaderRoute: typeof SettingsProfileProfessionalDataEditProfessionalDataRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/profile/professional-data/edit/professional-data-contact-information": {
      id: "/settings/profile/professional-data/edit/professional-data-contact-information";
      path: "/settings/profile/professional-data/edit/professional-data-contact-information";
      fullPath: "/settings/profile/professional-data/edit/professional-data-contact-information";
      preLoaderRoute: typeof SettingsProfileProfessionalDataEditProfessionalDataContactInformationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel": {
      id: "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel";
      path: "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel";
      fullPath: "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel";
      preLoaderRoute: typeof SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/": {
      id: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/";
      path: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId";
      fullPath: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config": {
      id: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config";
      path: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config";
      fullPath: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId/advanced-config";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-receiving-options/create/": {
      id: "/settings/schedule-options/appointment-receiving-options/create/";
      path: "/settings/schedule-options/appointment-receiving-options/create";
      fullPath: "/settings/schedule-options/appointment-receiving-options/create/";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-receiving-options/create/advanced-config": {
      id: "/settings/schedule-options/appointment-receiving-options/create/advanced-config";
      path: "/settings/schedule-options/appointment-receiving-options/create/advanced-config";
      fullPath: "/settings/schedule-options/appointment-receiving-options/create/advanced-config";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/$appointmentTypeId/": {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/";
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId";
      fullPath: "/settings/schedule-options/appointment-types/$appointmentTypeId/";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config": {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config";
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config";
      fullPath: "/settings/schedule-options/appointment-types/$appointmentTypeId/advanced-config";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info": {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info";
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info";
      fullPath: "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type": {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type";
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type";
      fullPath: "/settings/schedule-options/appointment-types/$appointmentTypeId/room-type";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info": {
      id: "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info";
      path: "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info";
      fullPath: "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/create/": {
      id: "/settings/schedule-options/appointment-types/create/";
      path: "/settings/schedule-options/appointment-types/create";
      fullPath: "/settings/schedule-options/appointment-types/create/";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/create/advanced-config": {
      id: "/settings/schedule-options/appointment-types/create/advanced-config";
      path: "/settings/schedule-options/appointment-types/create/advanced-config";
      fullPath: "/settings/schedule-options/appointment-types/create/advanced-config";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/create/confirm": {
      id: "/settings/schedule-options/appointment-types/create/confirm";
      path: "/settings/schedule-options/appointment-types/create/confirm";
      fullPath: "/settings/schedule-options/appointment-types/create/confirm";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateConfirmRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/create/patient-info": {
      id: "/settings/schedule-options/appointment-types/create/patient-info";
      path: "/settings/schedule-options/appointment-types/create/patient-info";
      fullPath: "/settings/schedule-options/appointment-types/create/patient-info";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/create/review": {
      id: "/settings/schedule-options/appointment-types/create/review";
      path: "/settings/schedule-options/appointment-types/create/review";
      fullPath: "/settings/schedule-options/appointment-types/create/review";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateReviewRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/create/room-type": {
      id: "/settings/schedule-options/appointment-types/create/room-type";
      path: "/settings/schedule-options/appointment-types/create/room-type";
      fullPath: "/settings/schedule-options/appointment-types/create/room-type";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/appointment-types/create/secretary-info": {
      id: "/settings/schedule-options/appointment-types/create/secretary-info";
      path: "/settings/schedule-options/appointment-types/create/secretary-info";
      fullPath: "/settings/schedule-options/appointment-types/create/secretary-info";
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/service-preferences/edit/general-preferences": {
      id: "/settings/schedule-options/service-preferences/edit/general-preferences";
      path: "/settings/schedule-options/service-preferences/edit/general-preferences";
      fullPath: "/settings/schedule-options/service-preferences/edit/general-preferences";
      preLoaderRoute: typeof SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/schedule-options/service-preferences/edit/patient-preferences": {
      id: "/settings/schedule-options/service-preferences/edit/patient-preferences";
      path: "/settings/schedule-options/service-preferences/edit/patient-preferences";
      fullPath: "/settings/schedule-options/service-preferences/edit/patient-preferences";
      preLoaderRoute: typeof SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/waiting-room/$codAgendamento/change-time/confirm/": {
      id: "/waiting-room/$codAgendamento/change-time/confirm/";
      path: "/waiting-room/$codAgendamento/change-time/confirm";
      fullPath: "/waiting-room/$codAgendamento/change-time/confirm/";
      preLoaderRoute: typeof WaitingRoomCodAgendamentoChangeTimeConfirmIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings/assist/contacts-history/trial-period/$contactId/": {
      id: "/settings/assist/contacts-history/trial-period/$contactId/";
      path: "/contacts-history/trial-period/$contactId";
      fullPath: "/settings/assist/contacts-history/trial-period/$contactId/";
      preLoaderRoute: typeof SettingsAssistContactsHistoryTrialPeriodContactIdIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/assist/user-trackable-links/$userTrackableLinkId/report/": {
      id: "/settings/assist/user-trackable-links/$userTrackableLinkId/report/";
      path: "/user-trackable-links/$userTrackableLinkId/report";
      fullPath: "/settings/assist/user-trackable-links/$userTrackableLinkId/report/";
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRouteImport;
      parentRoute: typeof SettingsAssistRoute;
    };
    "/settings/billing/details/paymentBillingGroup/$billingIdGroup/": {
      id: "/settings/billing/details/paymentBillingGroup/$billingIdGroup/";
      path: "/settings/billing/details/paymentBillingGroup/$billingIdGroup";
      fullPath: "/settings/billing/details/paymentBillingGroup/$billingIdGroup/";
      preLoaderRoute: typeof SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

interface FlowsStepIdRouteChildren {
  FlowsStepIdSubStepIdRoute: typeof FlowsStepIdSubStepIdRoute;
}

const FlowsStepIdRouteChildren: FlowsStepIdRouteChildren = {
  FlowsStepIdSubStepIdRoute: FlowsStepIdSubStepIdRoute,
};

const FlowsStepIdRouteWithChildren = FlowsStepIdRoute._addFileChildren(
  FlowsStepIdRouteChildren,
);

interface SettingsAssistRouteChildren {
  SettingsAssistIndexRoute: typeof SettingsAssistIndexRoute;
  SettingsAssistSecretaryDetailsAppointmentInfosRoute: typeof SettingsAssistSecretaryDetailsAppointmentInfosRoute;
  SettingsAssistSecretaryDetailsFaqRoute: typeof SettingsAssistSecretaryDetailsFaqRoute;
  SettingsAssistSecretaryDetailsProfessionalInfosRoute: typeof SettingsAssistSecretaryDetailsProfessionalInfosRoute;
  SettingsAssistSecretaryDetailsRestrictionsRoute: typeof SettingsAssistSecretaryDetailsRestrictionsRoute;
  SettingsAssistAssistProAcceptanceIndexRoute: typeof SettingsAssistAssistProAcceptanceIndexRoute;
  SettingsAssistContactsHistoryIndexRoute: typeof SettingsAssistContactsHistoryIndexRoute;
  SettingsAssistCustomerAppointmentOverviewIndexRoute: typeof SettingsAssistCustomerAppointmentOverviewIndexRoute;
  SettingsAssistCustomerContactOverviewIndexRoute: typeof SettingsAssistCustomerContactOverviewIndexRoute;
  SettingsAssistCustomerSiteOverviewIndexRoute: typeof SettingsAssistCustomerSiteOverviewIndexRoute;
  SettingsAssistFeatureSettingsIndexRoute: typeof SettingsAssistFeatureSettingsIndexRoute;
  SettingsAssistFollowUpAppointmentReminderIndexRoute: typeof SettingsAssistFollowUpAppointmentReminderIndexRoute;
  SettingsAssistRescuedAppointmentOverviewIndexRoute: typeof SettingsAssistRescuedAppointmentOverviewIndexRoute;
  SettingsAssistSecretaryDetailsIndexRoute: typeof SettingsAssistSecretaryDetailsIndexRoute;
  SettingsAssistSubscribeAssistProLegacyIndexRoute: typeof SettingsAssistSubscribeAssistProLegacyIndexRoute;
  SettingsAssistSubscribeAssistProIndexRoute: typeof SettingsAssistSubscribeAssistProIndexRoute;
  SettingsAssistSubscribedAssistIndexRoute: typeof SettingsAssistSubscribedAssistIndexRoute;
  SettingsAssistTasksIndexRoute: typeof SettingsAssistTasksIndexRoute;
  SettingsAssistUnsubscribeAssistProIndexRoute: typeof SettingsAssistUnsubscribeAssistProIndexRoute;
  SettingsAssistUserTrackableLinksIndexRoute: typeof SettingsAssistUserTrackableLinksIndexRoute;
  SettingsAssistContactsHistoryContactIdIndexRoute: typeof SettingsAssistContactsHistoryContactIdIndexRoute;
  SettingsAssistContactsHistoryAboutIndexRoute: typeof SettingsAssistContactsHistoryAboutIndexRoute;
  SettingsAssistContactsHistoryEssentialIndexRoute: typeof SettingsAssistContactsHistoryEssentialIndexRoute;
  SettingsAssistContactsHistoryTrialPeriodIndexRoute: typeof SettingsAssistContactsHistoryTrialPeriodIndexRoute;
  SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute: typeof SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute;
  SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute: typeof SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute;
  SettingsAssistSubscribeAssistProConfirmIndexRoute: typeof SettingsAssistSubscribeAssistProConfirmIndexRoute;
  SettingsAssistTasksTaskIdIndexRoute: typeof SettingsAssistTasksTaskIdIndexRoute;
  SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute: typeof SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute;
  SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute: typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute;
  SettingsAssistUserTrackableLinksCreateIndexRoute: typeof SettingsAssistUserTrackableLinksCreateIndexRoute;
  SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute: typeof SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute;
  SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute: typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute;
}

const SettingsAssistRouteChildren: SettingsAssistRouteChildren = {
  SettingsAssistIndexRoute: SettingsAssistIndexRoute,
  SettingsAssistSecretaryDetailsAppointmentInfosRoute:
    SettingsAssistSecretaryDetailsAppointmentInfosRoute,
  SettingsAssistSecretaryDetailsFaqRoute:
    SettingsAssistSecretaryDetailsFaqRoute,
  SettingsAssistSecretaryDetailsProfessionalInfosRoute:
    SettingsAssistSecretaryDetailsProfessionalInfosRoute,
  SettingsAssistSecretaryDetailsRestrictionsRoute:
    SettingsAssistSecretaryDetailsRestrictionsRoute,
  SettingsAssistAssistProAcceptanceIndexRoute:
    SettingsAssistAssistProAcceptanceIndexRoute,
  SettingsAssistContactsHistoryIndexRoute:
    SettingsAssistContactsHistoryIndexRoute,
  SettingsAssistCustomerAppointmentOverviewIndexRoute:
    SettingsAssistCustomerAppointmentOverviewIndexRoute,
  SettingsAssistCustomerContactOverviewIndexRoute:
    SettingsAssistCustomerContactOverviewIndexRoute,
  SettingsAssistCustomerSiteOverviewIndexRoute:
    SettingsAssistCustomerSiteOverviewIndexRoute,
  SettingsAssistFeatureSettingsIndexRoute:
    SettingsAssistFeatureSettingsIndexRoute,
  SettingsAssistFollowUpAppointmentReminderIndexRoute:
    SettingsAssistFollowUpAppointmentReminderIndexRoute,
  SettingsAssistRescuedAppointmentOverviewIndexRoute:
    SettingsAssistRescuedAppointmentOverviewIndexRoute,
  SettingsAssistSecretaryDetailsIndexRoute:
    SettingsAssistSecretaryDetailsIndexRoute,
  SettingsAssistSubscribeAssistProLegacyIndexRoute:
    SettingsAssistSubscribeAssistProLegacyIndexRoute,
  SettingsAssistSubscribeAssistProIndexRoute:
    SettingsAssistSubscribeAssistProIndexRoute,
  SettingsAssistSubscribedAssistIndexRoute:
    SettingsAssistSubscribedAssistIndexRoute,
  SettingsAssistTasksIndexRoute: SettingsAssistTasksIndexRoute,
  SettingsAssistUnsubscribeAssistProIndexRoute:
    SettingsAssistUnsubscribeAssistProIndexRoute,
  SettingsAssistUserTrackableLinksIndexRoute:
    SettingsAssistUserTrackableLinksIndexRoute,
  SettingsAssistContactsHistoryContactIdIndexRoute:
    SettingsAssistContactsHistoryContactIdIndexRoute,
  SettingsAssistContactsHistoryAboutIndexRoute:
    SettingsAssistContactsHistoryAboutIndexRoute,
  SettingsAssistContactsHistoryEssentialIndexRoute:
    SettingsAssistContactsHistoryEssentialIndexRoute,
  SettingsAssistContactsHistoryTrialPeriodIndexRoute:
    SettingsAssistContactsHistoryTrialPeriodIndexRoute,
  SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute:
    SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute,
  SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute:
    SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute,
  SettingsAssistSubscribeAssistProConfirmIndexRoute:
    SettingsAssistSubscribeAssistProConfirmIndexRoute,
  SettingsAssistTasksTaskIdIndexRoute: SettingsAssistTasksTaskIdIndexRoute,
  SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute:
    SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute,
  SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute:
    SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute,
  SettingsAssistUserTrackableLinksCreateIndexRoute:
    SettingsAssistUserTrackableLinksCreateIndexRoute,
  SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute:
    SettingsAssistContactsHistoryTrialPeriodContactIdIndexRoute,
  SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute:
    SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute,
};

const SettingsAssistRouteWithChildren = SettingsAssistRoute._addFileChildren(
  SettingsAssistRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AddPaymentCardCreateRoute: AddPaymentCardCreateRoute,
  AddPaymentCardSuccessRoute: AddPaymentCardSuccessRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthIdpCallbackRoute: AuthIdpCallbackRoute,
  AuthLandingRoute: AuthLandingRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthOauthCallbackRoute: AuthOauthCallbackRoute,
  AuthSigninRoute: AuthSigninRoute,
  ExtendTimeAppointmentIdRoute: ExtendTimeAppointmentIdRoute,
  FlowsStepIdRoute: FlowsStepIdRouteWithChildren,
  GoogleCallbackRoute: GoogleCallbackRoute,
  OnelivAdditionalInfoRoute: OnelivAdditionalInfoRoute,
  OnelivBasicInfoRoute: OnelivBasicInfoRoute,
  OnelivEducationalBackgroundRoute: OnelivEducationalBackgroundRoute,
  OnelivExperiencesRoute: OnelivExperiencesRoute,
  OnelivFaqRoute: OnelivFaqRoute,
  OnelivMedicalInstitutionsRoute: OnelivMedicalInstitutionsRoute,
  OnelivSocialMediaRoute: OnelivSocialMediaRoute,
  OnelivTreatmentFocusRoute: OnelivTreatmentFocusRoute,
  OnelivUseTermsRoute: OnelivUseTermsRoute,
  OnelivWelcomeRoute: OnelivWelcomeRoute,
  RecurringAppointmentsCodAgendamentoRecorrenteRoute:
    RecurringAppointmentsCodAgendamentoRecorrenteRoute,
  SettingsAssistRoute: SettingsAssistRouteWithChildren,
  AccessBlockedIndexRoute: AccessBlockedIndexRoute,
  AddPaymentCardIndexRoute: AddPaymentCardIndexRoute,
  CafDocumentsBlockedIndexRoute: CafDocumentsBlockedIndexRoute,
  CalendarIndexRoute: CalendarIndexRoute,
  CustomWebsiteIndexRoute: CustomWebsiteIndexRoute,
  FlowsIndexRoute: FlowsIndexRoute,
  GeneralTermsIndexRoute: GeneralTermsIndexRoute,
  HomeIndexRoute: HomeIndexRoute,
  LocationsIndexRoute: LocationsIndexRoute,
  PatientsIndexRoute: PatientsIndexRoute,
  RecommendationIndexRoute: RecommendationIndexRoute,
  RecurringAppointmentsIndexRoute: RecurringAppointmentsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  UpdateRequiredIndexRoute: UpdateRequiredIndexRoute,
  WaitingRoomIndexRoute: WaitingRoomIndexRoute,
  AppointmentAppointmentIdCancelRecurrenceRoute:
    AppointmentAppointmentIdCancelRecurrenceRoute,
  AppointmentAppointmentIdFlexiblePricingRoute:
    AppointmentAppointmentIdFlexiblePricingRoute,
  AppointmentAppointmentIdPatientSwapRoute:
    AppointmentAppointmentIdPatientSwapRoute,
  AppointmentAppointmentIdPatientSwapRecurrenceRoute:
    AppointmentAppointmentIdPatientSwapRecurrenceRoute,
  AppointmentAppointmentIdPatientSwapSearchRoute:
    AppointmentAppointmentIdPatientSwapSearchRoute,
  AppointmentAppointmentIdRescheduleRoute:
    AppointmentAppointmentIdRescheduleRoute,
  AppointmentAppointmentIdReschedulePatientRoute:
    AppointmentAppointmentIdReschedulePatientRoute,
  AppointmentAppointmentIdRescheduleRecurrenceRoute:
    AppointmentAppointmentIdRescheduleRecurrenceRoute,
  AppointmentCreateAvailableOptionsRoute:
    AppointmentCreateAvailableOptionsRoute,
  AppointmentCreateFlexiblePricingRoute: AppointmentCreateFlexiblePricingRoute,
  AppointmentCreatePatientRoute: AppointmentCreatePatientRoute,
  AppointmentCreateSearchPatientRoute: AppointmentCreateSearchPatientRoute,
  AuthFirstAccessCompleteRoute: AuthFirstAccessCompleteRoute,
  AuthFirstAccessDefinePasswordRoute: AuthFirstAccessDefinePasswordRoute,
  AuthFirstAccessDocumentRoute: AuthFirstAccessDocumentRoute,
  AuthFirstAccessDocumentNotFoundRoute: AuthFirstAccessDocumentNotFoundRoute,
  AuthFirstAccessVerifyEmailRoute: AuthFirstAccessVerifyEmailRoute,
  AuthOauthAuthorizeRoute: AuthOauthAuthorizeRoute,
  AuthPasswordResetCheckEmailRoute: AuthPasswordResetCheckEmailRoute,
  AuthPasswordResetCreatePasswordRoute: AuthPasswordResetCreatePasswordRoute,
  AuthPasswordResetForgotPasswordRoute: AuthPasswordResetForgotPasswordRoute,
  AuthPasswordResetPasswordChangedRoute: AuthPasswordResetPasswordChangedRoute,
  CalendarBatchAdjustCancelRoute: CalendarBatchAdjustCancelRoute,
  CalendarBatchAdjustMinutesRoute: CalendarBatchAdjustMinutesRoute,
  CalendarBatchAdjustReviewRoute: CalendarBatchAdjustReviewRoute,
  CalendarBatchAdjustSuccessRoute: CalendarBatchAdjustSuccessRoute,
  CalendarUnavailableSlotsCreateRoute: CalendarUnavailableSlotsCreateRoute,
  CustomWebsiteConfirmationErrorRoute: CustomWebsiteConfirmationErrorRoute,
  FlowsCompleteFlowIdRoute: FlowsCompleteFlowIdRoute,
  HomeNotificationCenterAboutRoute: HomeNotificationCenterAboutRoute,
  OnboardingConsultingAcquisitionRoute: OnboardingConsultingAcquisitionRoute,
  OnboardingConsultingCareerProblemRoute:
    OnboardingConsultingCareerProblemRoute,
  OnboardingConsultingChannelsRoute: OnboardingConsultingChannelsRoute,
  OnboardingConsultingExpectationRoute: OnboardingConsultingExpectationRoute,
  OnboardingConsultingIntroRoute: OnboardingConsultingIntroRoute,
  OnboardingConsultingSuccessRoute: OnboardingConsultingSuccessRoute,
  OnboardingFirstScheduleFirstAppointmentRoute:
    OnboardingFirstScheduleFirstAppointmentRoute,
  OnboardingFirstScheduleFollowUpRoute: OnboardingFirstScheduleFollowUpRoute,
  OnboardingFirstScheduleFollowUpDaysRoute:
    OnboardingFirstScheduleFollowUpDaysRoute,
  OnboardingFirstScheduleIntroRoute: OnboardingFirstScheduleIntroRoute,
  OnboardingFirstSchedulePreviewRoute: OnboardingFirstSchedulePreviewRoute,
  OnboardingFirstScheduleScheduleRoute: OnboardingFirstScheduleScheduleRoute,
  OnboardingFirstScheduleSuccessRoute: OnboardingFirstScheduleSuccessRoute,
  OnboardingWelcomeMeetingDetailsRoute: OnboardingWelcomeMeetingDetailsRoute,
  OnboardingWelcomeMeetingDismissedRoute:
    OnboardingWelcomeMeetingDismissedRoute,
  OnboardingWelcomeMeetingFormatRoute: OnboardingWelcomeMeetingFormatRoute,
  OnboardingWelcomeMeetingLocationRoute: OnboardingWelcomeMeetingLocationRoute,
  OnboardingWelcomeMeetingScheduleRoute: OnboardingWelcomeMeetingScheduleRoute,
  OnboardingWelcomeMeetingSkipReasonRoute:
    OnboardingWelcomeMeetingSkipReasonRoute,
  OnboardingWelcomeMeetingSuccessRoute: OnboardingWelcomeMeetingSuccessRoute,
  PatientsPatientIdUpdateRoute: PatientsPatientIdUpdateRoute,
  RecurringAppointmentsCreateAvailabilityRoute:
    RecurringAppointmentsCreateAvailabilityRoute,
  RecurringAppointmentsCreatePatientRoute:
    RecurringAppointmentsCreatePatientRoute,
  RecurringAppointmentsCreateReviewRoute:
    RecurringAppointmentsCreateReviewRoute,
  RecurringAppointmentsCreateSearchPatientRoute:
    RecurringAppointmentsCreateSearchPatientRoute,
  RecurringAppointmentsCreateSuccessRoute:
    RecurringAppointmentsCreateSuccessRoute,
  RecurringAppointmentsExtendRecurringAppointmentIdRoute:
    RecurringAppointmentsExtendRecurringAppointmentIdRoute,
  RecurringAppointmentsExtendSuccessRoute:
    RecurringAppointmentsExtendSuccessRoute,
  RecurringAppointmentsRescheduleAvailabilityRoute:
    RecurringAppointmentsRescheduleAvailabilityRoute,
  RecurringAppointmentsRescheduleReviewRoute:
    RecurringAppointmentsRescheduleReviewRoute,
  SettingsBillingBillingItemIdRoute: SettingsBillingBillingItemIdRoute,
  SettingsBillingAboutRoute: SettingsBillingAboutRoute,
  SettingsBlogCreateRoute: SettingsBlogCreateRoute,
  SettingsPaymentsWelcomeRoute: SettingsPaymentsWelcomeRoute,
  SettingsReferralAboutRoute: SettingsReferralAboutRoute,
  SettingsRegulatoryDocumentsConfirmationRoute:
    SettingsRegulatoryDocumentsConfirmationRoute,
  SettingsRegulatoryDocumentsDeclarationLocationsRoute:
    SettingsRegulatoryDocumentsDeclarationLocationsRoute,
  SettingsRegulatoryDocumentsDownloadRoute:
    SettingsRegulatoryDocumentsDownloadRoute,
  SettingsRegulatoryDocumentsLocationsRoute:
    SettingsRegulatoryDocumentsLocationsRoute,
  SettingsRegulatoryDocumentsReasonRoute:
    SettingsRegulatoryDocumentsReasonRoute,
  SettingsRegulatoryDocumentsRequestsRoute:
    SettingsRegulatoryDocumentsRequestsRoute,
  SettingsRegulatoryDocumentsReviewRoute:
    SettingsRegulatoryDocumentsReviewRoute,
  SettingsRegulatoryDocumentsStateRoute: SettingsRegulatoryDocumentsStateRoute,
  WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute:
    WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute,
  AppointmentCreateIndexRoute: AppointmentCreateIndexRoute,
  CalendarBatchAdjustIndexRoute: CalendarBatchAdjustIndexRoute,
  CustomWebsiteConfirmationIndexRoute: CustomWebsiteConfirmationIndexRoute,
  CustomWebsiteFormIndexRoute: CustomWebsiteFormIndexRoute,
  HomeAllFeaturesIndexRoute: HomeAllFeaturesIndexRoute,
  HomeNotificationCenterIndexRoute: HomeNotificationCenterIndexRoute,
  LocationsLocationIdIndexRoute: LocationsLocationIdIndexRoute,
  OnboardingFirstScheduleIndexRoute: OnboardingFirstScheduleIndexRoute,
  OnboardingWelcomeMeetingIndexRoute: OnboardingWelcomeMeetingIndexRoute,
  PatientsPatientIdIndexRoute: PatientsPatientIdIndexRoute,
  RecommendationConfirmationIndexRoute: RecommendationConfirmationIndexRoute,
  RecurringAppointmentsCreateIndexRoute: RecurringAppointmentsCreateIndexRoute,
  SettingsBillingIndexRoute: SettingsBillingIndexRoute,
  SettingsBlogIndexRoute: SettingsBlogIndexRoute,
  SettingsCommunityIndexRoute: SettingsCommunityIndexRoute,
  SettingsGoogleCalendarIndexRoute: SettingsGoogleCalendarIndexRoute,
  SettingsPaymentsIndexRoute: SettingsPaymentsIndexRoute,
  SettingsProfessionalSiteIndexRoute: SettingsProfessionalSiteIndexRoute,
  SettingsProfileIndexRoute: SettingsProfileIndexRoute,
  SettingsReferralIndexRoute: SettingsReferralIndexRoute,
  SettingsRegulatoryDocumentsIndexRoute: SettingsRegulatoryDocumentsIndexRoute,
  SettingsReservedSchedulesIndexRoute: SettingsReservedSchedulesIndexRoute,
  SettingsScheduleOptionsIndexRoute: SettingsScheduleOptionsIndexRoute,
  HomeInfoInfoItemIdConfirmationRoute: HomeInfoInfoItemIdConfirmationRoute,
  SettingsBlogUserPostIdEditRoute: SettingsBlogUserPostIdEditRoute,
  SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute:
    SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute,
  SettingsPaymentsBankAccountUpdateRoute:
    SettingsPaymentsBankAccountUpdateRoute,
  SettingsPaymentsCreateRecipientAddBankAccountRoute:
    SettingsPaymentsCreateRecipientAddBankAccountRoute,
  SettingsPaymentsCreateRecipientCheckCnpjRoute:
    SettingsPaymentsCreateRecipientCheckCnpjRoute,
  SettingsPaymentsCreateRecipientChooseHolderTypeRoute:
    SettingsPaymentsCreateRecipientChooseHolderTypeRoute,
  SettingsPaymentsCreateRecipientConfirmBankAccountRoute:
    SettingsPaymentsCreateRecipientConfirmBankAccountRoute,
  SettingsPaymentsCreateRecipientConfirmDocumentRoute:
    SettingsPaymentsCreateRecipientConfirmDocumentRoute,
  SettingsPaymentsCreateRecipientStatusRoute:
    SettingsPaymentsCreateRecipientStatusRoute,
  SettingsPaymentsCreateRecipientValidateDataRoute:
    SettingsPaymentsCreateRecipientValidateDataRoute,
  SettingsPaymentsCreateConfirmationRoute:
    SettingsPaymentsCreateConfirmationRoute,
  SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute:
    SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute,
  SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute:
    SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute,
  SettingsPaymentsPatientPaymentsAboutPaymentsRoute:
    SettingsPaymentsPatientPaymentsAboutPaymentsRoute,
  SettingsPaymentsPatientPaymentsDetailsRoute:
    SettingsPaymentsPatientPaymentsDetailsRoute,
  SettingsPaymentsPatientPaymentsPaymentReceiptRoute:
    SettingsPaymentsPatientPaymentsPaymentReceiptRoute,
  SettingsPaymentsPatientPaymentsRefundRoute:
    SettingsPaymentsPatientPaymentsRefundRoute,
  SettingsPaymentsPatientPaymentsRefundReceiptRoute:
    SettingsPaymentsPatientPaymentsRefundReceiptRoute,
  SettingsPaymentsPayablesAboutRoute: SettingsPaymentsPayablesAboutRoute,
  SettingsProfileCardCreateRoute: SettingsProfileCardCreateRoute,
  SettingsProfilePersonalDataEditRoute: SettingsProfilePersonalDataEditRoute,
  SettingsProfilePersonalDataEditAddressRoute:
    SettingsProfilePersonalDataEditAddressRoute,
  SettingsProfileVehiclesVehicleIdRoute: SettingsProfileVehiclesVehicleIdRoute,
  SettingsProfileVehiclesCreateRoute: SettingsProfileVehiclesCreateRoute,
  SettingsReservedSchedulesReservedScheduleIdCancelRoute:
    SettingsReservedSchedulesReservedScheduleIdCancelRoute,
  SettingsReservedSchedulesCreateConfirmRoute:
    SettingsReservedSchedulesCreateConfirmRoute,
  SettingsReservedSchedulesCreateLinkedScheduleRoute:
    SettingsReservedSchedulesCreateLinkedScheduleRoute,
  SettingsReservedSchedulesCreateSlotsRoute:
    SettingsReservedSchedulesCreateSlotsRoute,
  SettingsReservedSchedulesCreateStartingDayRoute:
    SettingsReservedSchedulesCreateStartingDayRoute,
  SettingsScheduleOptionsPreferredRoomsUnitIdRoute:
    SettingsScheduleOptionsPreferredRoomsUnitIdRoute,
  SettingsScheduleOptionsSchedulesScheduleIdRoute:
    SettingsScheduleOptionsSchedulesScheduleIdRoute,
  SettingsScheduleOptionsSchedulesCreateRoute:
    SettingsScheduleOptionsSchedulesCreateRoute,
  WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute:
    WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute,
  HomeInfoInfoItemIdIndexRoute: HomeInfoInfoItemIdIndexRoute,
  HomeNotificationCenterIdIndexRoute: HomeNotificationCenterIdIndexRoute,
  SettingsBillingDetailsIndexRoute: SettingsBillingDetailsIndexRoute,
  SettingsBlogUserPostIdIndexRoute: SettingsBlogUserPostIdIndexRoute,
  SettingsPaymentsBankAccountIndexRoute: SettingsPaymentsBankAccountIndexRoute,
  SettingsPaymentsCreateRecipientIndexRoute:
    SettingsPaymentsCreateRecipientIndexRoute,
  SettingsPaymentsCreateIndexRoute: SettingsPaymentsCreateIndexRoute,
  SettingsPaymentsEvolutionChartsIndexRoute:
    SettingsPaymentsEvolutionChartsIndexRoute,
  SettingsPaymentsPatientPaymentsIndexRoute:
    SettingsPaymentsPatientPaymentsIndexRoute,
  SettingsPaymentsPayablesIndexRoute: SettingsPaymentsPayablesIndexRoute,
  SettingsPaymentsTermsOfServiceIndexRoute:
    SettingsPaymentsTermsOfServiceIndexRoute,
  SettingsProfessionalSiteAboutIndexRoute:
    SettingsProfessionalSiteAboutIndexRoute,
  SettingsProfileCardIndexRoute: SettingsProfileCardIndexRoute,
  SettingsProfilePersonalDataIndexRoute: SettingsProfilePersonalDataIndexRoute,
  SettingsProfilePlanIndexRoute: SettingsProfilePlanIndexRoute,
  SettingsProfileProfessionalDataIndexRoute:
    SettingsProfileProfessionalDataIndexRoute,
  SettingsProfileUpsertPublicPhoneIndexRoute:
    SettingsProfileUpsertPublicPhoneIndexRoute,
  SettingsProfileVehiclesIndexRoute: SettingsProfileVehiclesIndexRoute,
  SettingsReservedSchedulesReservedScheduleIdIndexRoute:
    SettingsReservedSchedulesReservedScheduleIdIndexRoute,
  SettingsReservedSchedulesCreateIndexRoute:
    SettingsReservedSchedulesCreateIndexRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute:
    SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute,
  SettingsScheduleOptionsAppointmentTypesIndexRoute:
    SettingsScheduleOptionsAppointmentTypesIndexRoute,
  SettingsScheduleOptionsPreferredRoomsIndexRoute:
    SettingsScheduleOptionsPreferredRoomsIndexRoute,
  SettingsScheduleOptionsSchedulesIndexRoute:
    SettingsScheduleOptionsSchedulesIndexRoute,
  SettingsScheduleOptionsServicePreferencesIndexRoute:
    SettingsScheduleOptionsServicePreferencesIndexRoute,
  WaitingRoomCodAgendamentoChangeTimeIndexRoute:
    WaitingRoomCodAgendamentoChangeTimeIndexRoute,
  WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute:
    WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute,
  WaitingRoomCodAgendamentoMenuIndexRoute:
    WaitingRoomCodAgendamentoMenuIndexRoute,
  WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute:
    WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute,
  WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute:
    WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute,
  SettingsBillingDetailsBillingIdBoletoRoute:
    SettingsBillingDetailsBillingIdBoletoRoute,
  SettingsBillingDetailsBillingIdPixRoute:
    SettingsBillingDetailsBillingIdPixRoute,
  SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute:
    SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute,
  SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute:
    SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute,
  SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute:
    SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute,
  SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute:
    SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute,
  SettingsProfileProfessionalDataEditProfessionalDataRoute:
    SettingsProfileProfessionalDataEditProfessionalDataRoute,
  SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute:
    SettingsProfileProfessionalDataEditProfessionalDataContactInformationRoute,
  SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute:
    SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute:
    SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdAdvancedConfigRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute:
    SettingsScheduleOptionsAppointmentReceivingOptionsCreateAdvancedConfigRoute,
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute:
    SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdAdvancedConfigRoute,
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute:
    SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdPatientInfoRoute,
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute:
    SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoomTypeRoute,
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute:
    SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdSecretaryInfoRoute,
  SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute:
    SettingsScheduleOptionsAppointmentTypesCreateAdvancedConfigRoute,
  SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute:
    SettingsScheduleOptionsAppointmentTypesCreateConfirmRoute,
  SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute:
    SettingsScheduleOptionsAppointmentTypesCreatePatientInfoRoute,
  SettingsScheduleOptionsAppointmentTypesCreateReviewRoute:
    SettingsScheduleOptionsAppointmentTypesCreateReviewRoute,
  SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute:
    SettingsScheduleOptionsAppointmentTypesCreateRoomTypeRoute,
  SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute:
    SettingsScheduleOptionsAppointmentTypesCreateSecretaryInfoRoute,
  SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute:
    SettingsScheduleOptionsServicePreferencesEditGeneralPreferencesRoute,
  SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute:
    SettingsScheduleOptionsServicePreferencesEditPatientPreferencesRoute,
  SettingsBillingDetailsBillingIdIndexRoute:
    SettingsBillingDetailsBillingIdIndexRoute,
  SettingsProfilePlanCancelSubscriptionIndexRoute:
    SettingsProfilePlanCancelSubscriptionIndexRoute,
  SettingsProfilePlanChangeIndexRoute: SettingsProfilePlanChangeIndexRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute:
    SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdIndexRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute:
    SettingsScheduleOptionsAppointmentReceivingOptionsCreateIndexRoute,
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute:
    SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdIndexRoute,
  SettingsScheduleOptionsAppointmentTypesCreateIndexRoute:
    SettingsScheduleOptionsAppointmentTypesCreateIndexRoute,
  WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute:
    WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute,
  SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute:
    SettingsBillingDetailsPaymentBillingGroupBillingIdGroupIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
